import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {MemberService} from '../services/member.service';
import {MatPaginator} from '@angular/material/paginator';
import {Category} from '../models/category';
import {MemberGN1WorkDialogComponent} from './dialogs/member-gn1-work-dialog/member-gn1-work-dialog.component';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {MemberGn1Service} from '../services/member-gn1.service';
import {FormGroup} from '@angular/forms';
import {MemberGn1ExcludedDialogComponent} from './dialogs/member-gn1-excluded-dialog/member-gn1-excluded-dialog.component';
import {AlertComponent} from '../shared/dialogs/alert/alert.component';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {Subscription} from 'rxjs';
import {FileService} from '../services/file.service';

@Component({
  selector: 'app-member-gn1-work',
  templateUrl: './member-gn1-work.component.html',
  styleUrls: [ './member-gn1-work.component.scss' ],
  entryComponents: [
    MemberGN1WorkDialogComponent
  ]
})
export class MemberGN1WorkComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public waiting: any;
  public dataSource: MatTableDataSource<any>
  public dataSourceExcluded: MatTableDataSource<any>
  //public displayedColumns: string[] = [ 'name', 'category', 'contacts', 'docs', 'dates', 'excluded', 'edit' ];
  public displayedColumns: string[] = [ 'name', 'data1', 'data2', 'edit' ];
  //public displayedExcludedColumns: string[] = [ 'name', 'category', 'cpf', 'edit' ];
  public displayedExcludedColumns: string[] = [ 'name', 'category', 'cpf' ];

  public allCategories: Category[] = [];

  public dialogRef: any;
  public pageSizeOptions: string[] = []

  public sbccvMembers: any[] = []
  public gn1Members: any[] = []
  public gn1MembersExcluded: any[] = []
  public validatedMembers: any[] = []
  public notFoundMembers: any[] = []

  private subSbccv: Subscription;
  private subGn1: Subscription;

  constructor (
    public _memberService: MemberService,
    public _memberGn1Service: MemberGn1Service,
    private _dialog: MatDialog,
    private _snackBarService: SnackBarIconService,
    private _spinnerService: SpinnerService,
    private _fileService: FileService,
  ) {

    this.loadSBCCVMembers()
  }

  ngOnInit () {
    //this.loadWorkMembers()
    this.loadWorkMembersExcluded()
  }

  ngOnDestroy () {
    if (this.subSbccv)
      this.subSbccv.unsubscribe();
    if (this.subGn1)
      this.subGn1.unsubscribe();
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadWorkMembers () {
    this.waiting = this._spinnerService.show();

    this.subGn1 = this._memberGn1Service.selectWork()
      .subscribe((result) => {

        this.gn1Members = []
        result.forEach((item) => {
          this.addMember(item.payload.doc.id, item.payload.doc.data())
        })

        this.dataSource = new MatTableDataSource(this.gn1Members);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort

        this.waiting.close()

      })
  }

  loadWorkMembersExcluded () {
    this._memberGn1Service.selectWorkExcluded()
      .subscribe((result) => {
        this.gn1MembersExcluded = []
        result.forEach((item) => {
          this.gn1MembersExcluded.push(this.addMemberExcluded(item.payload.doc.id, item.payload.doc.data()))
        })
        this.dataSourceExcluded = new MatTableDataSource(this.gn1MembersExcluded);
      })

  }

  openDialog (entity) {

    let data: any = {};

    if (entity) {
      data = entity;
    }

    this.dialogRef = this._dialog.open(MemberGN1WorkDialogComponent, {
      width: '1100px', //window.innerWidth.toString() + "px",
      height: '660px', //window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const actionType: string = response[ 0 ]

        if (actionType == 'okGN1') {
          // console.log("GN1 ---------------------------")
          const formData: FormGroup = response[ 1 ]
          const rawData = formData.getRawValue()
          // console.log(JSON.stringify(rawData))

          this._memberGn1Service.update(rawData)
            .then(() => {
              this._snackBarService.openSnackBar("Sucesso!", '', 'success');
            })
            .catch((err) => {
              console.log(err.message)
            })

        }

        if (actionType == 'okSBCCV') {

          // console.log("SBCCV ---------------------------")
          const formData: FormGroup = response[ 1 ]
          const rawData = formData.getRawValue()

          delete rawData.category
          delete rawData.cellPhone

          // console.log(JSON.stringify(rawData))

          this._memberService.update(rawData)
            .then(() => {
              this._snackBarService.openSnackBar("Sucesso!", '', 'success');
            })
            .catch((err) => {
              console.log(err.message)
            })

        }

      })
  }

  openDialogExcluded (entity) {
    let data: any = {};

    if (entity) {
      data = entity;
    }

    this.dialogRef = this._dialog.open(MemberGn1ExcludedDialogComponent, {
      width: '700px', //window.innerWidth.toString() + "px",
      height: '460px', //window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const actionType: string = response[ 0 ]
        const formData: FormGroup = response[ 1 ]
        const rawData = formData.getRawValue()

        if (actionType == 'ok') {
          console.log(JSON.stringify(rawData))


          this._memberService.selectByDocNumber(rawData.cpf)
            .subscribe((res) => {
              if (res.empty) {
                //console.log('não existe')
                this._dialog.open(AlertComponent, {
                  width: '450px',
                  height: '270px',
                  panelClass: 'custom-dialog-container',
                  data: {title: "Alerta", message: "Cadastro SBCCV não encontrado.<br><br>" + rawData.name + '<br>' + rawData.cpf}
                });
              } else {
                const exist = res.docs[ 0 ].data()
                let dialogRef = this._dialog.open(ConfirmComponent, {
                  width: '350px',
                  height: '270px',
                  panelClass: 'custom-dialog-container',
                  data: {title: "Confirme", message: "Cadastro SBCCV encontrado.<br><br>" + exist.name + '<br>' + exist.cpf + "<br><br>Atualizar este cadastro?"}
                });
                dialogRef.afterClosed().subscribe(result => {
                  if (result == "ok") {

                    this._memberGn1Service.updateExcluded(rawData)
                      .then(() => {
                        console.log("ok")
                      })
                      .catch((err) => {
                        console.log("ERRO: " + err.message)
                      })



                  }
                })

              }
            })



        }

      })

  }

  addMemberExcluded (id, gn1_data) {

    let entity: any = {}
    entity.id = id
    entity.name = gn1_data.name
    entity.email = gn1_data.email1 === 'Vazio' ? '' : gn1_data.email
    entity.email2 = gn1_data.email2 === 'Vazio' ? '' : gn1_data.email2
    entity.gender = gn1_data.gender === 'Vazio' ? '' : gn1_data.gender
    entity.filiationDate = this.makeDate(gn1_data.filiationDate)
    entity.birthDate = this.makeDate(gn1_data.birthDate)
    entity.titleDate = this.makeDate(gn1_data.titleDate)
    entity.cpf = gn1_data.cpf === 'Vazio' ? '' : gn1_data.cpf.replace('.', '').replace('.', '').replace('-', '')
    entity.rg = gn1_data.rg === 'Vazio' ? '' : gn1_data.rg
    entity.crm = gn1_data.crm === 'Vazio' ? '' : gn1_data.crm
    entity.cellPhone = gn1_data.cellPhone === 'Vazio' ? '' : gn1_data.cellPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
    entity.faxPhone = gn1_data.faxPhone === 'Vazio' ? '' : gn1_data.faxPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
    entity.clinicPhone = gn1_data.clinicPhone === 'Vazio' ? '' : gn1_data.clinicPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
    entity.hospitalPhone = gn1_data.hospitalPhone === 'Vazio' ? '' : gn1_data.hospitalPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
    entity.aux1Phone = gn1_data.auxPhone1 === 'Vazio' ? '' : gn1_data.auxPhone1.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
    entity.aux2Phone = gn1_data.auxPhone2 === 'Vazio' ? '' : gn1_data.auxPhone2.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
    entity.situation = gn1_data.situation
    entity.category = gn1_data.category
    entity.regional = gn1_data.regional === 'Vazio' ? '' : gn1_data.regional
    entity.state = gn1_data.state === 'Vazio' ? '' : gn1_data.state
    entity.city = gn1_data.city === 'Vazio' ? '' : gn1_data.city
    entity.district = gn1_data.district === 'Vazio' ? '' : gn1_data.district
    entity.address = gn1_data.address === 'Vazio' ? '' : gn1_data.address
    entity.number = gn1_data.number === 'Vazio' ? '' : gn1_data.number
    entity.complement = gn1_data.complement === 'Vazio' ? '' : gn1_data.complement
    entity.postalCode = gn1_data.postalCode === 'Vazio' ? '' : gn1_data.postalCode
    entity.institute = gn1_data.institute
    entity.concilState = gn1_data.concilState
    entity.specialization = gn1_data.specialization
    entity.exclude = gn1_data.exclude

    return entity
  }

  addMember (id, gn1_data) {

    let entity: any = {}

    const sbccv_data = this.sbccvMembers.find((e) => {
      return e.cpf === gn1_data.cpf.replace('.', '').replace('.', '').replace('-', '')
    })

    if (!sbccv_data) {

    } else if (sbccv_data) {

      entity.id = id
      entity.excel_id = gn1_data.excel_id

      entity.name = gn1_data.name
      if (entity.name === sbccv_data.name) entity.name_ok = true; else entity.name_ok = false;

      entity.email = gn1_data.email === 'Vazio' ? '' : gn1_data.email
      if (entity.email === sbccv_data.email) entity.email_ok = true; else entity.email_ok = false;

      entity.email2 = gn1_data.email2 === 'Vazio' ? '' : gn1_data.email2
      if (entity.email2 === sbccv_data.email2) entity.email2_ok = true; else entity.email2_ok = false;

      entity.gender = gn1_data.gender === 'Vazio' ? '' : gn1_data.gender
      if (entity.gender === sbccv_data.gender) entity.gender_ok = true; else entity.gender_ok = false;

      entity.filiationDate = gn1_data.filiationDate === 'Vazio' || gn1_data.filiationDate === '01/01/1900' ? '' : gn1_data.filiationDate
      const filiationDate = this.makeDate(gn1_data.filiationDate)
      if (filiationDate.toString() === sbccv_data.dateFiliation.toString()) entity.filiationDate_ok = true; else entity.filiationDate_ok = false;

      entity.birthDate = gn1_data.birthDate === 'Vazio' || gn1_data.birthDate === '01/01/1900' ? '' : gn1_data.birthDate
      const birthDate = this.makeDate(gn1_data.birthDate)
      if (birthDate.toString() === sbccv_data.dateBirth.toString()) entity.birthDate_ok = true; else entity.birthDate_ok = false;

      entity.titleDate = gn1_data.titleDate === 'Vazio' || gn1_data.titleDate === '01/01/1900' ? '' : gn1_data.titleDate
      const titleDate = this.makeDate(gn1_data.titleDate)
      if (titleDate.toString() === sbccv_data.dateTitle.toString()) entity.titleDate_ok = true; else entity.titleDate_ok = false;

      entity.cpf = gn1_data.cpf === 'Vazio' ? '' : gn1_data.cpf.replace('.', '').replace('.', '').replace('-', '')
      if (entity.cpf === sbccv_data.cpf) entity.cpf_ok = true; else entity.cpf_ok = false;

      entity.rg = gn1_data.rg === 'Vazio' ? '' : gn1_data.rg
      if (entity.rg === sbccv_data.rg) entity.rg_ok = true; else entity.rg_ok = false;

      entity.crm = gn1_data.crm === 'Vazio' ? '' : gn1_data.crm
      if (entity.crm === sbccv_data.crm) entity.crm_ok = true; else entity.crm_ok = false;

      entity.cellPhone = gn1_data.cellPhone === 'Vazio' ? '' : gn1_data.cellPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
      if (entity.cellPhone === sbccv_data.cellPhone) entity.cellPhone_ok = true; else entity.cellPhone_ok = false;

      entity.faxPhone = gn1_data.faxPhone === 'Vazio' ? '' : gn1_data.faxPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
      if (entity.faxPhone === sbccv_data.faxPhone) entity.faxPhone_ok = true; else entity.faxPhone_ok = false;

      entity.clinicPhone = gn1_data.clinicPhone === 'Vazio' ? '' : gn1_data.clinicPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
      if (entity.clinicPhone === sbccv_data.clinicPhone) entity.clinicPhone_ok = true; else entity.clinicPhone_ok = false;

      entity.hospitalPhone = gn1_data.hospitalPhone === 'Vazio' ? '' : gn1_data.hospitalPhone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
      if (entity.hospitalPhone === sbccv_data.hospitalPhone) entity.hospitalPhone_ok = true; else entity.hospitalPhone_ok = false;

      entity.auxPhone1 = gn1_data.auxPhone1 === 'Vazio' ? '' : gn1_data.auxPhone1.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
      if (entity.auxPhone1 === sbccv_data.aux1Phone) entity.auxPhone1_ok = true; else entity.auxPhone1_ok = false;

      entity.auxPhone2 = gn1_data.auxPhone2 === 'Vazio' ? '' : gn1_data.auxPhone2.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(" ", "").replace(" ", "")
      if (entity.auxPhone2 === sbccv_data.aux2Phone) entity.auxPhone2_ok = true; else entity.auxPhone2_ok = false;

      let situation: any = ''
      switch (sbccv_data.situation) {
        case '0':
          situation = 'Quite'
          break
        case '1':
          situation = 'Não-Quite'
          break
        case '2':
          situation = 'Isento'
          break
      }
      entity.situation = gn1_data.situation
      if (entity.situation === situation) entity.situation_ok = true; else entity.situation_ok = false;

      entity.category = gn1_data.category
      if (entity.category === sbccv_data.category) entity.category_ok = true; else entity.category_ok = false;

      entity.regional = gn1_data.regional === 'Vazio' ? '' : gn1_data.regional
      if (entity.regional === sbccv_data.regional) entity.regional_ok = true; else entity.regional_ok = false;

      entity.state = gn1_data.state === 'Vazio' ? '' : gn1_data.state
      if (entity.state === sbccv_data.state) entity.state_ok = true; else entity.state_ok = false;

      entity.city = gn1_data.city === 'Vazio' ? '' : gn1_data.city
      if (entity.city === sbccv_data.city) entity.city_ok = true; else entity.city_ok = false;

      entity.district = gn1_data.district === 'Vazio' ? '' : gn1_data.district
      if (entity.district === sbccv_data.district) entity.district_ok = true; else entity.district_ok = false;

      entity.address = gn1_data.address === 'Vazio' ? '' : gn1_data.address
      if (entity.address === sbccv_data.address) entity.address_ok = true; else entity.address_ok = false;

      entity.number = gn1_data.number === 'Vazio' ? '' : gn1_data.number
      if (entity.number === sbccv_data.number) entity.number_ok = true; else entity.number_ok = false;

      entity.complement = gn1_data.complement === 'Vazio' ? '' : gn1_data.complement
      if (entity.complement === sbccv_data.complement) entity.complement_ok = true; else entity.complement_ok = false;

      entity.postalCode = gn1_data.postalCode === 'Vazio' ? '' : gn1_data.postalCode.replace("-", "").replace(" ", "")
      if (entity.postalCode === sbccv_data.postalCode) entity.postalCode_ok = true; else entity.postalCode_ok = false;

      entity.institute = gn1_data.institute === 'Vazio' ? '' : gn1_data.institute.trim()
      if (entity.institute === sbccv_data.resident_institute) entity.institute_ok = true; else entity.institute_ok = false;

      entity.institute_begin = gn1_data.institute_begin === 'Vazio' || gn1_data.institute_begin === '01/01/1900' ? '' : gn1_data.institute_begin
      const institute_begin = this.makeDate(gn1_data.institute_begin)
      if (institute_begin.toString() === sbccv_data.resident_begin.toString()) entity.institute_begin_ok = true; else entity.institute_begin_ok = false;

      entity.institute_end = gn1_data.institute_end === 'Vazio' || gn1_data.institute_end === '01/01/1900' ? '' : gn1_data.institute_end
      const institute_end = this.makeDate(gn1_data.institute_end)
      if (institute_end.toString() === sbccv_data.resident_end.toString()) entity.institute_end_ok = true; else entity.institute_end_ok = false;

      entity.concilState = gn1_data.concilState
      entity.specialization = gn1_data.specialization
      entity.exclude = gn1_data.exclude

      this.gn1Members.push(entity)
    }

  }

  makeDate (dt: any, name: string = '') {

    //console.log('dt: ' + dt)

    try {

      if (dt === 'Vazio' || dt === '01/01/1900') return ''

      if (dt) {
        const dd = Number(dt.substring(0, 2))
        const mm = Number(dt.substring(3, 5))
        const yy = Number(dt.substring(6, 10))
        return new Date(yy, (mm - 1), dd)
      } else {
        return ""
      }
    }
    catch (err) {
      console.log('name: ' + name)
      console.log('err: ' + err.message)
      console.log('dt: ' + new Date(dt.seconds * 1000))
    }

  }

  loadSBCCVMembers () {
    this.waiting = this._spinnerService.show();

    this.subSbccv = this._memberGn1Service.loadSBCCVMembers()
      .subscribe((result) => {
        this.sbccvMembers = []

        console.log('+++++++++++++++++++++++++++++++++++++++++++++++')
        result.forEach((item) => {

          if (item.payload.doc.data().name.trim().length > 0) {

            let dtBirth: any = item.payload.doc.data().dateBirth
            let dtFiliation: any = item.payload.doc.data().dateFiliation
            let dtTitle: any = item.payload.doc.data().dateTitle

            let dtResident_begin: any = item.payload.doc.data().resident_begin
            let dtResident_end: any = item.payload.doc.data().resident_end

            //console.log('category: ' +  item.payload.doc.data().subCategory.name)

            let cellPhone = this.clearPhone(item.payload.doc.data().cellPhone)
            let hospitalPhone = this.clearPhone(item.payload.doc.data().hospitalPhone)
            let clinicPhone = this.clearPhone(item.payload.doc.data().clinicPhone)
            let faxPhone = this.clearPhone(item.payload.doc.data().faxPhone)
            let aux1Phone = this.clearPhone(item.payload.doc.data().aux1Phone)
            let aux2Phone = this.clearPhone(item.payload.doc.data().aux2Phone)

            let postalCode = this.clearPostalCode(item.payload.doc.data().postalCode)

            this.sbccvMembers.push({
              'id': item.payload.doc.id,
              'name': item.payload.doc.data().name,
              'email': item.payload.doc.data().email,
              'email2': item.payload.doc.data().email2,
              'gender': item.payload.doc.data().sex,
              'dateBirth': dtBirth ? dtBirth.toDate() : '',
              'dateFiliation': dtFiliation ? dtFiliation.toDate() : '',
              'dateTitle': dtTitle ? dtTitle.toDate() : '',
              'cpf': item.payload.doc.data().cpf,
              'rg': item.payload.doc.data().rg,
              'crm': item.payload.doc.data().crm,
              'cellPhone': cellPhone,
              'hospitalPhone': hospitalPhone,
              'clinicPhone': clinicPhone,
              'faxPhone': faxPhone,
              'aux1Phone': aux1Phone,
              'aux2Phone': aux2Phone,
              'situation': item.payload.doc.data().situation,
              'category': item.payload.doc.data().subCategory ? item.payload.doc.data().subCategory.name : '',
              'regional': item.payload.doc.data().regional,
              'state': item.payload.doc.data().state,
              'city': item.payload.doc.data().city,
              'district': item.payload.doc.data().district,
              'address': item.payload.doc.data().address,
              'number': item.payload.doc.data().number,
              'complement': item.payload.doc.data().complement,
              'postalCode': postalCode,
              'resident_institute': item.payload.doc.data().resident_institute ? item.payload.doc.data().resident_institute.trim() : '',
              'resident_begin': dtResident_begin ? dtResident_begin.toDate() : '',
              'resident_end': dtResident_end ? dtResident_end.toDate() : ''
            })
          }

        })

        this.waiting.close()

        this.loadWorkMembers();

      })
  }

  clearPhone (phone) {
    if (phone)
      return phone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '').replace(' ', '').replace(' ', '')
    else
      return ''
  }

  clearPostalCode (code) {
    if (code)
      return code.replace('-', '').replace(' ', '')
    else
      return ""
  }

  readCSVFile (fileInput: any) {

    console.log('fileInput: ' + fileInput.target.files[ 0 ].name)
    this._memberGn1Service.readCSVFile(fileInput)

  }

  validation () {
    this.waiting = this._spinnerService.show();
    this.notFoundMembers = []

    this.dataSource.data.forEach((item) => {
      if (!item.exclude) {

        const cpf = item.cpf.replace('.', '').replace('.', '').replace('-', '')

        const cpf_found = this.sbccvMembers.find((e) => {
          return e.cpf === cpf
        })

        if (!cpf_found) {
          this.notFoundMembers.push(item)
        }
      }
    })

    this.exportNotFound()
  }

  validateAllMembers () {
    this.waiting = this._spinnerService.show();
    this.notFoundMembers = []

    this.dataSource.data.forEach((item) => {
      if (!item.exclude) {

        const cpf_found = this.sbccvMembers.find((e) => {
          return e.cpf === item.cpf.replace('.', '').replace('.', '').replace('-', '')
        })

        const crm_found = this.sbccvMembers.find((e) => {
          return e.crm === item.crm
        })

        const email_found = this.sbccvMembers.find((e) => {
          return e.email === item.email
        })

        const cellPhone_found = this.sbccvMembers.find((e) => {
          return e.cellPhone === item.cellPhone
        })

        const sex_found = this.sbccvMembers.find((e) => {
          return e.sex === item.sex
        })

        const dateBirth_found = this.sbccvMembers.find((e) => {
          return e.dateBirth === item.dateBirth
        })

        const filiationDate_found = this.sbccvMembers.find((e) => {
          return e.filiationDate === item.dateFiliation
        })

        const regional_found = this.sbccvMembers.find((e) => {
          return e.regional === item.regional
        })



        const entity = {
          'id': item.id,
          'name': item.name,

          'cpf': item.cpf,
          'cpf_found': cpf_found ? true : false,

          'crm': item.crm,
          'crm_found': crm_found ? true : false,

          'email': item.email,
          'email_found': email_found ? true : false,

          'cellPhone': item.cellPhone,
          'cellPhone_found': cellPhone_found ? true : false,

          'dateBirth': item.dateBirth,
          'dateBirth_found': dateBirth_found ? true : false,

          'filiationDate': item.dateBirth,
          'filiationDate_found': filiationDate_found ? true : false,

          'sex': item.sex,
          'sex_found': sex_found ? true : false,

          'regional': item.regional,
          'regional_found': regional_found ? true : false,
        }

        this.validatedMembers.push(entity)

      }
    })


  }

  exportNotFound () {
    //console.log(JSON.stringify(this.notFoundMembers))
    const data = this.notFoundMembers;

    let csvFile: any[] = []

    csvFile.push("" + ";" + "Usuários GN1" + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += "id" + ';'
    csvHeader += "name" + ';'
    csvHeader += "category" + ';'
    csvHeader += "situation" + ';'
    csvHeader += "address" + ';'
    csvHeader += "number" + ';'
    csvHeader += "complement" + ';'
    csvHeader += "district" + ';'
    csvHeader += "postalCode" + ';'
    csvHeader += "city" + ';'
    csvHeader += "state" + ';'
    csvHeader += "email" + ';'
    csvHeader += "email2" + ';'
    csvHeader += "cellPhone" + ';'
    csvHeader += "faxPhone" + ';'
    csvHeader += "clinicPhone" + ';'
    csvHeader += "hospitalPhone" + ';'
    csvHeader += "auxPhone1" + ';'
    csvHeader += "auxPhone2" + ';'
    csvHeader += "rg" + ';'
    csvHeader += "cpf" + ';'
    csvHeader += "crm" + ';'
    csvHeader += "birthDate" + ';'
    csvHeader += "filiationDate" + ';'
    csvHeader += "titleDate" + ';'
    csvHeader += "institute" + ';'
    csvHeader += "regional" + ';'
    csvHeader += "gender" + ';'
    csvHeader += "concilState" + ';'
    csvHeader += "specialization" + ';'
    csvHeader += "exclude" + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((line) => {

      let csvLine: string;

      csvLine = "" + ";"
      csvLine += line.id + ";"
      csvLine += line.name + ";"
      csvLine += line.category + ";"
      csvLine += line.situation + ";"
      csvLine += line.address + ";"
      csvLine += line.number + ";"
      csvLine += line.complement + ";"
      csvLine += line.district + ";"
      csvLine += line.postalCode + ";"
      csvLine += line.city + ";"
      csvLine += line.state + ";"
      csvLine += line.email + ";"
      csvLine += line.email2 + ";"
      csvLine += line.cellPhone + ";"
      csvLine += line.faxPhone + ";"
      csvLine += line.clinicPhone + ";"
      csvLine += line.hospitalPhone + ";"
      csvLine += line.auxPhone1 + ";"
      csvLine += line.auxPhone2 + ";"
      csvLine += line.rg + ";"
      csvLine += line.cpf + ";"
      csvLine += line.crm + ";"
      csvLine += line.birthDate + ";"
      csvLine += line.filiationDate + ";"
      csvLine += 'oooo' + ";" //line.titleDate + ";"
      csvLine += line.institute + ";"
      csvLine += line.regional + ";"
      csvLine += line.gender + ";"
      csvLine += line.concilState + ";"
      csvLine += line.specialization + ";"

      if (line.exclude) {
        csvLine += 'Sim' + "\r\n"
      } else {
        csvLine += 'Não' + "\r\n"
      }

      csvFile.push(csvLine)

    })

    this.waiting.close()

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
    this._fileService.saveFile(blob, "membrosGN1.csv");


  }


  _readCSVFormation (fileInput: any) {

    console.log('fileInput: ' + fileInput.target.files[ 0 ].name)
    this._memberGn1Service.readCSVFormation(fileInput, this.sbccvMembers, this.gn1Members)

  }

  async _updateSBCCV () {
    const arryUpdate = this.loadUpdates()

    for (let i = 0; i < arryUpdate.length; i++) {//arryUpdate.length
      let item = arryUpdate[ i ]


      console.log(i)
      /*
     console.log(item.id)
     console.log(item.name)
     console.log(JSON.stringify(item.data))
     console.log('--------------------------------------')
     */

      const data = {
        'resident_institute': item.data.resident_institute,
        'resident_begin': new Date(item.data.resident_begin),
        'resident_end': new Date(item.data.resident_end),
      }

      await this._memberGn1Service.updateMemberFormation(item.id, data)
        .then(async () => {
          console.log(i + ' - sucesso! ' + item.id)
        })
        .catch((err) => {
          console.log('erro: ' + item.id + " - " + err.message)
        })

    }

  }


  loadUpdates () {

    return [
      {
        "id": "kmH5EUJRDN0Ht0mbb9Io",
        "name": "Abílio Nascimento Silva",
        "data": {
          "resident_institute": "Serv. CCV Hospital BP - Prof. Noedir de 01/02/007 a 31/12/2007 e Serv. CCV Hosp. Francisca Mendes - Dr. Mariano Terrazas, de 04/03/2013 a 04/03/2016",
          "resident_begin": "2013-03-04T03:00:00.000Z",
          "resident_end": "2016-03-04T03:00:00.000Z"
        }
      },
      {
        "id": "WVt1qCq8yrtvGokCuDGa",
        "name": "Achilles Abelaira Filho ",
        "data": {
          "resident_institute": "Faculdade de Medicina de São José do Rio Preto - CNRM - Coordenador: Prof. Antônio Hélio Oliani",
          "resident_begin": "1999-02-14T02:00:00.000Z",
          "resident_end": "2002-02-13T02:00:00.000Z"
        }
      },
      {
        "id": "m7hFAW6dwk2YCb4qDre1",
        "name": "Acrísio Sales Valente",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de São Paulo - CNRM/MEC - Dr. Valdir Bolin",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "B5UC9zEGXkJiT2syTNHq",
        "name": "Adalberto Freire Sobrinho ",
        "data": {
          "resident_institute": "Hosp. Vera Cruz - Roney Ronald Peixoto",
          "resident_begin": "1988-02-01T02:00:00.000Z",
          "resident_end": "1990-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "lRwAWoRS62nZmOxiHJeg",
        "name": "Ademir Júnior Souto Jacob ",
        "data": {
          "resident_institute": "Hosp. Clementino Fraga Fº - Mauro Paes Leme de Sá",
          "resident_begin": "2008-01-02T02:00:00.000Z",
          "resident_end": "2012-03-31T03:00:00.000Z"
        }
      },
      {
        "id": "pYmMGn81MHYnGsJ2dpVo",
        "name": "Adnaldo da Silveira Maia",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia",
          "resident_begin": "2020-03-02T03:00:00.000Z",
          "resident_end": "2024-03-02T03:00:00.000Z"
        }
      },
      {
        "id": "f38oKRJuryAsrGSFG6bc",
        "name": "Adriana Silveira de Almeida ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Porto Alegre - CNRM/MEC Coord. Luis Fernando Venegas",
          "resident_begin": "2003-02-01T02:00:00.000Z",
          "resident_end": "2006-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "i0TI2EeVtfPSe0xVOTuP",
        "name": "Agenor Ribeiro de Jesus Filho ",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - BPSP - Profº. Dr. Sergio A de Oliveira",
          "resident_begin": "1979-01-01T03:00:00.000Z",
          "resident_end": "1982-08-30T03:00:00.000Z"
        }
      },
      {
        "id": "Vtkn3lJk125KroOephsi",
        "name": "Ahmad Ali Abdouni",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - Dr. Sergio A Oliveira",
          "resident_begin": "2002-01-18T02:00:00.000Z",
          "resident_end": "2005-02-20T03:00:00.000Z"
        }
      },
      {
        "id": "gurv9KVS8e3q7Jvmc8wy",
        "name": "Ailton Carvalho Barbosa Jr. ",
        "data": {
          "resident_institute": "Hospital Adventista Silvestre - Dr. Ranieri C. leitão",
          "resident_begin": "1999-01-02T02:00:00.000Z",
          "resident_end": "2002-03-19T03:00:00.000Z"
        }
      },
      {
        "id": "GURPPXewZW36lzX2UPm3",
        "name": "Aislan Henrique Bezerra Pinheiro",
        "data": {
          "resident_institute": "Serv. CCV Escola Paulista de Medicina - UNIFESP CNRM/MEC Coord. Dr. Fábio Veiga de castro Sparapani",
          "resident_begin": "2018-03-05T03:00:00.000Z",
          "resident_end": "2023-03-04T03:00:00.000Z"
        }
      },
      {
        "id": "NyrhtBJ2cIZ0kLrPrP45",
        "name": "Alan Anderson Fernandes Oliveira",
        "data": {
          "resident_institute": "Serv CCV Clinica J. P da Silva - Equipe Dr José Pedro da Silva",
          "resident_begin": "2015-01-02T02:00:00.000Z",
          "resident_end": "2019-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "MNxyGJnICvYZIwWgfYkt",
        "name": "Alan Michel Miola Pfluck ",
        "data": {
          "resident_institute": "BPSP - Clínica Cirúrgica e Cardiologia Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2006-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "8N9hQSBqNnTe9ee9BXHw",
        "name": "Albert Salviano dos Santos ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de São Paulo",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "z4g208sklTlwQlFufGkd",
        "name": "Alberto Bornschein",
        "data": {
          "resident_institute": "Inst. D. Cardio Pulm. Zerbini - Preceptor atual: Eduardo Coelho Souza",
          "resident_begin": "1975-01-02T03:00:00.000Z",
          "resident_end": "1979-01-20T03:00:00.000Z"
        }
      },
      {
        "id": "MUysaOlCWdWMEIqlqKxr",
        "name": "Alberto Mauro Anijar",
        "data": {
          "resident_institute": "Hospital do Coração - Prof Dr. Adib Domingos Jatene",
          "resident_begin": "1986-02-01T02:00:00.000Z",
          "resident_end": "1989-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "big4Dp8apjLbAlIbDOyK",
        "name": "Alberto Ocampo Macedo ",
        "data": {
          "resident_institute": "Instituto do Coração - Fundação Zerbini - Dr. E. J. Zerbini",
          "resident_begin": "1991-01-01T02:00:00.000Z",
          "resident_end": "1992-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Hg7BjKRljMzxCUs8GkuW",
        "name": "Aldo Pesarini ",
        "data": {
          "resident_institute": "Serviço CCV Santa Casa de Misericórdia de Curitiba - Dr. Iseu Affonso da Costa",
          "resident_begin": "1976-01-01T03:00:00.000Z",
          "resident_end": "1978-01-01T03:00:00.000Z"
        }
      },
      {
        "id": "vsJksbsfilmzwNOWqFeq",
        "name": "Alef de Carvalho Vieira",
        "data": {
          "resident_institute": "Serviço CCV Instituto Dante Pazzanese - Dr. Renato Arnoni",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "6WdYTp9oFzpPZQGhJdqm",
        "name": "Alessandro Bordinhão ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba Danton Loures",
          "resident_begin": "2000-01-10T02:00:00.000Z",
          "resident_end": "2003-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "tpvC9Vtn6GPh40BouejW",
        "name": "Alessandro Gonçalves Altoé ",
        "data": {
          "resident_institute": "Hospital Universitário Pedro Acadêmico - UERJ - CNRM/MEC - Coordenador: João Carlos Arieira",
          "resident_begin": "1999-03-01T03:00:00.000Z",
          "resident_end": "2003-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "gPIzjIUNwp6J6ygFuE6G",
        "name": "Alex Barbosa ",
        "data": {
          "resident_institute": "Inst. D. Cardio Pulm. Zerbini - Preceptor atual: Eduardo Coelho Souza",
          "resident_begin": "1981-07-01T03:00:00.000Z",
          "resident_end": "1983-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "uCLd0JdlPAtJ2oDJqfSU",
        "name": "Alex Luiz Celullare ",
        "data": {
          "resident_institute": "Universidade São Paulo - CNRM/MEC Coordenador do Programa: Prof. Noedir Antônio",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "mDNHny9kszsVrptSuJHG",
        "name": "Alex Mota Benevides ",
        "data": {
          "resident_institute": "BP SP - Clínica Stolf - Noedir Stolf",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "R1jnniVR3IcgGE2nPozK",
        "name": "Alexandre Augusto Zamuner ",
        "data": {
          "resident_institute": "SERVIÇO DE CIRURGIA CARDÍACA do norte do Paraná -Londrina PR",
          "resident_begin": "2022-02-15T03:00:00.000Z",
          "resident_end": "2027-02-15T03:00:00.000Z"
        }
      },
      {
        "id": "CSOaiUvd9ynJJkJWiOh2",
        "name": "Alexandre Cabral Zilli ",
        "data": {
          "resident_institute": "Beneficencia Portuguesa",
          "resident_begin": "2004-01-01T02:00:00.000Z",
          "resident_end": "2007-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "xOE7su8C93MoAlR0hIgK",
        "name": "Alexandre Ciappina Hueb ",
        "data": {
          "resident_institute": "Instituto do Coração do Hospital das Clínicas SP - Dr. Geraldo Verginelli - Comissão de Ensino",
          "resident_begin": "1993-02-01T03:00:00.000Z",
          "resident_end": "1996-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "AMac3jtIQ7PpvVaBZX9Q",
        "name": "Alexandre Gadelha Fernandes ",
        "data": {
          "resident_institute": "Hosp. Cruz Vermelha Brasileira - PR Jerônimo A. Fortunato Jr",
          "resident_begin": "2010-03-01T03:00:00.000Z",
          "resident_end": "2014-02-27T03:00:00.000Z"
        }
      },
      {
        "id": "yjfwlUGoug38oIW15nJJ",
        "name": "Alexandre Herculano de Alencar ",
        "data": {
          "resident_institute": "Instituto de Medicina Integral",
          "resident_begin": "2020-03-02T03:00:00.000Z",
          "resident_end": "2025-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "aNlwkmlC0g7HCk8XgXAS",
        "name": "Alexandre Magno Macario Nunes Soares ",
        "data": {
          "resident_institute": "Serviço CCV PROCAPE CNRM/MEC - Alexandre Motta de Menezes",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "5iuEbKBK6LwbyajBciiS",
        "name": "Alexandre Noboru Murakami ",
        "data": {
          "resident_institute": "Serviço CCV Hospital Evangélico - Dr Francisco Gregori Jr",
          "resident_begin": "1995-03-01T03:00:00.000Z",
          "resident_end": "1999-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "qcTuNGccWCUk5wqN5jKu",
        "name": "Alexandre Redondo de Carvalho ",
        "data": {
          "resident_institute": "Instituto Dante pazzanese - CNRM/MEC - Paulo Paredes Paulista",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "zKCTSoxlPaQi0xoTBzQV",
        "name": "Alexandre Siciliano Colafranceschi ",
        "data": {
          "resident_institute": "Instituto Nacional de Cardiologia Laranjeiras (INCL) CNRM/MEC Dra. Juçara Valverde - Coordenadora Acadêmica",
          "resident_begin": "2000-03-01T03:00:00.000Z",
          "resident_end": "2003-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "p0nIwny6fhbq6ZlebYJM",
        "name": "Alexandre Soutelo Souto da Silva",
        "data": {
          "resident_institute": "Serv. CCV Universidade Católica de Minas Gerais/Hospital Madre Teresa - Dr. Rodrigo Bernardes",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "vj3BZvD8iHO7d2S3d9kJ",
        "name": "Alexandre Targino Gomes Falcão Filho",
        "data": {
          "resident_institute": "InCor - HCFMUSP CNRM/MEC - DR. Alfredo Fiorelli",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "oQW5u6iNISWZNqIScPem",
        "name": "Alexandre Visconti Brick ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1976-01-02T03:00:00.000Z",
          "resident_end": "1978-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "nPFTq6EL4iIsiqRLhEqq",
        "name": "Alexsandra Lima Balbinot ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Instituto de Cardiologia/RS CRM/MEC - Paulo Roberto Prates",
          "resident_begin": "2001-01-01T02:00:00.000Z",
          "resident_end": "2004-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "hwoMj2BM5C1dmdlBuw6g",
        "name": "Aline Almeida Heck ",
        "data": {
          "resident_institute": "Universidade Católica do Rio Grande do Sul - CNRM/MEC - Prof Dr Mateus Herbert Jone",
          "resident_begin": "2010-02-03T02:00:00.000Z",
          "resident_end": "2014-02-02T02:00:00.000Z"
        }
      },
      {
        "id": "N4kuLyxHWdz4u5eHzkNL",
        "name": "Aline Hamilton Goulart ",
        "data": {
          "resident_institute": "Hospital São Lucas da PUCRS - CNRM/MEC - Dr José Miguel Chatkin",
          "resident_begin": "2002-01-02T02:00:00.000Z",
          "resident_end": "2004-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "0C730CSckDjjq8PIEFPk",
        "name": "Alisson Parrilha Toschi ",
        "data": {
          "resident_institute": "InCor - FMUSP",
          "resident_begin": "2003-01-01T02:00:00.000Z",
          "resident_end": "2006-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "XfV3JTJIvY8InOswPPgw",
        "name": "Alisson Silva Brito",
        "data": {
          "resident_institute": "Serviço CCV Biocor - Equipe do Bayard Gontijo Fº",
          "resident_begin": "2017-01-01T02:00:00.000Z",
          "resident_end": "2020-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "ad4Ay2oKHgM9UABs31fW",
        "name": "Allysson Klosowski Calixto ",
        "data": {
          "resident_institute": "Instituto de Neurologia e Cardiologia de Curitiba e Santa Casa de Curitiba - Dr. Francisco Diniz A. da Costa",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "RBFONe6HEsElW8xmVljT",
        "name": "Almiro Carlos Ferro Jr. ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC - Dra Magaly Arrais",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "WXQAxuWb6h8uImxQF4MV",
        "name": "Aloísio Sales Barbosa Gondim ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Paiulo Paredes Paulista",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2001-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "vV8J7fcIuOwxTTpLZjMB",
        "name": "Alvaro Augusto de Sousa Mota ",
        "data": {
          "resident_institute": "Serv. em CCV Hosp. Felício Rocho - Dr. Dielson Teixeira Sampaio",
          "resident_begin": "2015-03-02T03:00:00.000Z",
          "resident_end": "2019-03-02T03:00:00.000Z"
        }
      },
      {
        "id": "qFpeK1fgLMiR6rg7qU4z",
        "name": "Alvaro Daniel Ortuño Justiniano ",
        "data": {
          "resident_institute": "Serv. CCV Instituto Dante Pazzanese - Dra. Magaly Arrais",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "1uk9yntz7n0s3s26AoOH",
        "name": "Alvaro Monteiro Perazzo ",
        "data": {
          "resident_institute": "Faculdade de Ciências Médicas - PE - CNRM/MEC - Coor: Dr. PROF DR RICARDO DE CARVALHO LIMA",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "4gHLGtxd57bwRKbUcA2U",
        "name": "Alvaro Schmidt Albrecht ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2002-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "C7L3Lnk40AsgVwFLrXwN",
        "name": "Amanda Gabas Mercado",
        "data": {
          "resident_institute": "Serv. CCV Clinica Cardio-Cirúrgica Dr José Pedro da Silva LTda - Dr. José Pedro da Silva",
          "resident_begin": "2014-01-01T02:00:00.000Z",
          "resident_end": "2018-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "IbzV4eWdenzEfJJ8ZmvT",
        "name": "Amarildo Batalha de Almeida ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - Preceptor Responsável: Dr. José Pedro da Silva",
          "resident_begin": "1992-01-18T02:00:00.000Z",
          "resident_end": "1995-12-18T02:00:00.000Z"
        }
      },
      {
        "id": "4rBGkhqqcrmDBi223uln",
        "name": "Amaury Edgardo Mont´Serrat Ávila Souza Dias ",
        "data": {
          "resident_institute": "Serv. Cir.Torácica NHU-UFMS - José Carlos Dorsa V. Pontes",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "I5Wc7m73P4BNm5Vg6JKn",
        "name": "Américo Álvaro Farinha Martins ",
        "data": {
          "resident_institute": "Universidade Federal do Paraná - CNRM/MEC",
          "resident_begin": "1986-02-01T02:00:00.000Z",
          "resident_end": "1989-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "zCQIJlFvUWPDzihDA4CL",
        "name": "Ana Beatriz Silva Barbosa",
        "data": {
          "resident_institute": "INSTITUTO DANTE PAZZANESE",
          "resident_begin": "2019-02-28T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "bfdmrCiHBWlAzORWtgrW",
        "name": "Ana Helena Dotta ",
        "data": {
          "resident_institute": "Pontifícia Universidade Católica do Rio Grande do Sul - Hosp. São Lucas - CNRM/MEC",
          "resident_begin": "1994-01-02T02:00:00.000Z",
          "resident_end": "1996-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "feTAp9nlKyEO0Nwebern",
        "name": "Ana Lia Mesquita Nunes",
        "data": {
          "resident_institute": "HSL - PUCRS",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "CqNU8YcyL7A2UlAkxpB4",
        "name": "Ana Paula Romagnioli Mattos ",
        "data": {
          "resident_institute": "Hospital Felicio Rocho",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "FERLLCa0v2fdCVMO4A0l",
        "name": "Ana Paula Tagliari ",
        "data": {
          "resident_institute": "HC Porto Alegre CNRM/MEC - Dra Helena Von Eye Cortela",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "f75KHlPoW0L9EZMKNogh",
        "name": "Ana Thalita de Oliveira Miranda",
        "data": {
          "resident_institute": "Serv. CCV Clínica Cardio-Cirúrgica J.P. da Silva Ltda - Dr. José Pedro da Silva",
          "resident_begin": "2011-01-03T02:00:00.000Z",
          "resident_end": "2015-01-03T02:00:00.000Z"
        }
      },
      {
        "id": "CZSkIRMpYqpahrCWuVp7",
        "name": "Anderson Benício ",
        "data": {
          "resident_institute": "Instituto do Coração do Hospital das Clínicas da FMUSP - Dr. Fábio Jatene",
          "resident_begin": "1995-01-02T02:00:00.000Z",
          "resident_end": "1998-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "mn5psTmnW5juTf27hawu",
        "name": "Anderson da Rosa Rosado ",
        "data": {
          "resident_institute": "Serviço CCV Instituto de Cardiologia de Santa Catarina - CNRM/MEC - Dr Amandio Rampinelli",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "momWB9r97qBCF7ipcNZ0",
        "name": "Anderson da Silva Terrazas ",
        "data": {
          "resident_institute": "Unidade de Doenças Torácicas Stolf - Noedir Stolf",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "6kWeXheSrZjWb3Ycvc8u",
        "name": "André Amaral Dergint ",
        "data": {
          "resident_institute": "Hosp. Clínicas UFPR - Dr. Danton Loures",
          "resident_begin": "1994-02-01T02:00:00.000Z",
          "resident_end": "1998-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "DlPe0GSJPanlR3yYMhhP",
        "name": "André Luiz Mendes Martins ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Prof Dr Sérgio Almeida de Oliveira",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2003-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "5VgeLBxMGoauUE69wQNW",
        "name": "André Luiz Ribeiro Gomes Capaverde ",
        "data": {
          "resident_institute": "Especialização em CCV no Hospital Santa Casa de Misericórdia de Belo Horizonte - Dr. João Alfredo paulo e Silva",
          "resident_begin": "2013-03-04T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "5ahNmX5HyfHZqXjs0aP5",
        "name": "André Luppi Mota ",
        "data": {
          "resident_institute": "UNIFESP - CNRM/MEC - Dr Fábio Veiga de Castro Sparapani",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "ZNNGQrM6MNZQYXkBAd9A",
        "name": "André Micheletto Laurino",
        "data": {
          "resident_institute": "Incor - HCFMUSP - Clínica Stolf",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "pKB2eZzOJIxx0fCMkRlN",
        "name": "André Monti Garzesi ",
        "data": {
          "resident_institute": "Serviço de CCV da Faculdade de Medicina de Botucatu - Dr. Marcelo Laneza Felício",
          "resident_begin": "2013-02-01T02:00:00.000Z",
          "resident_end": "2017-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "8xaAN7yNUDDOVNkWcgFG",
        "name": "André Raimundo Franca Guimarães ",
        "data": {
          "resident_institute": "Fundação Baiana de Cardiologia - Dr. Alvaro Rabelo Alves Jr",
          "resident_begin": "2006-02-01T02:00:00.000Z",
          "resident_end": "2010-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "xOzLgG8i52YSugASTNrP",
        "name": "André Saraiva Rosa",
        "data": {
          "resident_institute": "Especialização em CCV no Hosp. Madre Teresa - Dr. Rodrigo de Castro Bernardes",
          "resident_begin": "2017-01-01T02:00:00.000Z",
          "resident_end": "2021-10-27T03:00:00.000Z"
        }
      },
      {
        "id": "k72iTPmLkb6qAVUu4WnE",
        "name": "André Telis de Vilela Araújo ",
        "data": {
          "resident_institute": "UNIFESP/EPM - Januário M. de Souza Serv. Cir Cardiovasc. Ltda - Januário M. de Souza",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "e30jF97J4vzs1KoU8RrL",
        "name": "Andrea Cristina Oliveira Freitas ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Fundação do ABC - CNRM/MEC - Adilson Casemiro Pires",
          "resident_begin": "2003-02-01T02:00:00.000Z",
          "resident_end": "2007-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "2RAcpVOvEjrF816lyq6K",
        "name": "Andrea Dumsch de Aragon Ferreira ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Curitiba- Francisco Costa",
          "resident_begin": "1993-03-01T03:00:00.000Z",
          "resident_end": "1996-12-30T02:00:00.000Z"
        }
      },
      {
        "id": "rJwXjZASDjOXikW4mmqg",
        "name": "Andrey Pereira Pinto ",
        "data": {
          "resident_institute": "Especialização em CCV no Hosp. Madre Teresa - Dr. Rodrigo de Castro Bernardes",
          "resident_begin": "2006-01-02T02:00:00.000Z",
          "resident_end": "2009-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "mRFEoMWWaa4SGtWA6jpf",
        "name": "Andrey Vega Matos",
        "data": {
          "resident_institute": "Serviço CCV Clínica Cirúrgica JP da Silva Ltda - Dr. José Pedro da Silva",
          "resident_begin": "2016-01-01T02:00:00.000Z",
          "resident_end": "2020-01-01T03:00:00.000Z"
        }
      },
      {
        "id": "F26cDjvGGrzoGELp9Rqg",
        "name": "Angélica Abrantes Miranda",
        "data": {
          "resident_institute": "Universidade nove de julho - UNINOVE",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "9RRY9nutGxUNPCH66Brb",
        "name": "Anilton Bezerra Rodrigues Júnior",
        "data": {
          "resident_institute": "Promater/Incor Natal",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "W7KpxxBfqZzDQjLH0FbH",
        "name": "Anna Carolina Franco",
        "data": {
          "resident_institute": "Serv. CCV da Universidade de Medicina de Cuiabá - CNRM/MEC. Dra. Denise Marta D. Abech",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-03-07T03:00:00.000Z"
        }
      },
      {
        "id": "APnsRFrRcci19nvsOQ2z",
        "name": "Anny Kátia Puchalski Micalay",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC - Dra. Magaly Arrais",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "sCxPEPY5PMvvH5mhhEaE",
        "name": "Antoninho Sanfins Arnoni ",
        "data": {
          "resident_institute": "Instituto de Cardiologia - Secretaria da Saúde / CNRM Adib Jatene",
          "resident_begin": "1971-01-20T03:00:00.000Z",
          "resident_end": "1973-11-13T03:00:00.000Z"
        }
      },
      {
        "id": "XnIi8LiukrCh9Orphk3s",
        "name": "Antonio Alexandrino de Britto Costa ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Campos - Dr. Ronald Souza Peixoto",
          "resident_begin": "1990-01-02T02:00:00.000Z",
          "resident_end": "1993-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "Xywh7J89TS2CTgS4KLz7",
        "name": "Antonio Amauri Groppo ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC - Vicente Ávila Neto",
          "resident_begin": "1982-02-01T03:00:00.000Z",
          "resident_end": "1985-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "3u1JxhMlJoTVDcqauLyi",
        "name": "Antonio Carlos Brandi ",
        "data": {
          "resident_institute": "Faculdade de Medicina de São José do Rio Preto - CNRM/MEC - Coordenador: Humberto Liedtke Junior",
          "resident_begin": "1994-02-01T02:00:00.000Z",
          "resident_end": "1997-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "FjBvk4ouP3zo7Gkj3xsc",
        "name": "Antonio Carlos Bráulio de Camargo ",
        "data": {
          "resident_institute": "Assoc. Hospitalar de Bauru - Antonio Estefano Germano",
          "resident_begin": "1990-01-02T02:00:00.000Z",
          "resident_end": "1993-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "JXJnkwUQOvNqquOBoJ30",
        "name": "Antonio Carlos Escorel de Almeida Neto",
        "data": {
          "resident_institute": "Universidade de Pernambuco/Faculdade de Ciências Medicas - CNRM/MEC Coord. Dra. Mariane Regina A. Sabino",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-10T03:00:00.000Z"
        }
      },
      {
        "id": "3Q36ntOtM55dgUQRU1Im",
        "name": "Antonio da Trindade Meira Henriques Neto",
        "data": {
          "resident_institute": "Serv. CCV e Torácica - PE - Mauro Barbosa Arruda",
          "resident_begin": "1986-08-01T03:00:00.000Z",
          "resident_end": "1988-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "3Q36ntOtM55dgUQRU1Im",
        "name": "Antonio da Trindade Meira Henriques Neto",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese se Cardiologia - CNRM/MEC - Paulo Paredes Paulista",
          "resident_begin": "1988-02-01T02:00:00.000Z",
          "resident_end": "1991-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "psfgBJto2mJevPxg6QEJ",
        "name": "Antonio de Jesus Chaves Junior",
        "data": {
          "resident_institute": "Universidade Federal da Bahia (UFBA)",
          "resident_begin": "2018-01-01T02:00:00.000Z",
          "resident_end": "2024-12-01T03:00:00.000Z"
        }
      },
      {
        "id": "DIpYIpLu4uQgOjU0pqpj",
        "name": "Antonio Estéfano Germano ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC",
          "resident_begin": "1979-02-01T03:00:00.000Z",
          "resident_end": "1982-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "7j8WSeh2OsZYoXef4Elz",
        "name": "Antonio Felipe Leite Simão ",
        "data": {
          "resident_institute": "Escola de Saúde Pública do Ceará Hospital de Messejana - CNRM/MEC - Dra Silvia de Melo Cunha",
          "resident_begin": "2014-03-06T03:00:00.000Z",
          "resident_end": "2018-03-05T03:00:00.000Z"
        }
      },
      {
        "id": "CGoVFR2PcIlkn5UmVpBi",
        "name": "Antonio Flávio Sanchez de Almeida ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1989-02-01T03:00:00.000Z",
          "resident_end": "1993-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "kcQhOV17lfFT1jYflY1t",
        "name": "Antonio Paulo de Oliveira Furlan ",
        "data": {
          "resident_institute": "Unidade de Doenças Toracicas Stolf - Dr. Noedir Stolf",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "XpspvKYeD0EYGFuZbq6Y",
        "name": "Antonio Sérgio Martins ",
        "data": {
          "resident_institute": "Universidade Estadual Paulista / Julio de Mesquita Filho - CNRM/MEC - Dr. Cláudio Antônio",
          "resident_begin": "1985-02-01T03:00:00.000Z",
          "resident_end": "1988-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "CXTcC3SxjPjkUnBC1hnt",
        "name": "Arnóbio Holanda Lavor ",
        "data": {
          "resident_institute": "Residência em CCV Hospital Messejana - CNRM/MEC",
          "resident_begin": "1979-07-30T03:00:00.000Z",
          "resident_end": "1981-07-29T03:00:00.000Z"
        }
      },
      {
        "id": "TBj43ytuRWnX2GsJvtei",
        "name": "Arthur Diniz Malheiros",
        "data": {
          "resident_institute": "Famerp",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "01ArCt1gmLSqfCZjF0XE",
        "name": "Arthur Soares Lima",
        "data": {
          "resident_institute": "BIOCOR",
          "resident_begin": "2019-05-23T03:00:00.000Z",
          "resident_end": "2024-05-23T03:00:00.000Z"
        }
      },
      {
        "id": "yPfbogVfqiP0KbY5cz0x",
        "name": "Arthur Souto Silva",
        "data": {
          "resident_institute": "Hospital São Francisco de Assis - Belo Horizonte MG",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "yiv9GL2q5EdRmcl741Lm",
        "name": "Artur José da Silva Raoul",
        "data": {
          "resident_institute": "Serviço CCV Hospital BP/SP Equipe do Dr. Hélio Pereira de Magalhães",
          "resident_begin": "1991-01-01T02:00:00.000Z",
          "resident_end": "1994-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "4kKyf4tI2Mrw1X4Uvhos",
        "name": "Artur Lourenção Jr. ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Hospital Jaraguá - Rubens M. de Arruda",
          "resident_begin": "1974-03-01T03:00:00.000Z",
          "resident_end": "1976-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "AhcBzUrG2CEDiMO1FJ7v",
        "name": "Assad Miguel Sassine ",
        "data": {
          "resident_institute": "Serv. CCV BPSP Equipe do Dr João Bosco - Clínica Cirúrgica de Moléstias Cardiovasculares",
          "resident_begin": "2002-02-01T02:00:00.000Z",
          "resident_end": "2006-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "GxsLjuFPKuuU3WZ2kAAQ",
        "name": "Atena Cipriano Castro ",
        "data": {
          "resident_institute": "Hospital Madre Teresa - Preceptor Responsável: Rodrigo Bernardes",
          "resident_begin": "1989-07-01T03:00:00.000Z",
          "resident_end": "1993-07-01T03:00:00.000Z"
        }
      },
      {
        "id": "jj3M86QEr8fT4nxvBz1D",
        "name": "Augusto Ferreira Silva Júnior ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca da Clínica Cirurgia Cardiovascular e Pulmonar do Hospital Santa Isabel da Santa Casa de Misericórdia - Dr. Nilzo Ribeiro",
          "resident_begin": "1979-12-01T03:00:00.000Z",
          "resident_end": "1982-12-30T03:00:00.000Z"
        }
      },
      {
        "id": "v7EI9AYysi6PYcA9mbNf",
        "name": "Bárbara Perroni",
        "data": {
          "resident_institute": "Universidade Nove de Julho (UNINOVE)",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "3jXuDGouXH3dLJa5gWx1",
        "name": "Bayard Gontijo Filho ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Santa Casa de Misericórdia - Dr Ricardo Pereira de Sousa",
          "resident_begin": "1974-07-12T03:00:00.000Z",
          "resident_end": "1976-07-12T03:00:00.000Z"
        }
      },
      {
        "id": "HiKwZGC9JxBw28x7X1ub",
        "name": "Beatriz Helena S. Furlanetto ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC - Vicente Ávila Neto",
          "resident_begin": "1982-02-15T03:00:00.000Z",
          "resident_end": "1985-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "B8UIrXNp0GxRrsDDtZ7k",
        "name": "Bernardo de Almeida Ávila ",
        "data": {
          "resident_institute": "Serviço de Clínica e Cirurgia Cardiovascular do Prof. Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2004-02-03T02:00:00.000Z",
          "resident_end": "2007-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "X0iSgGO29AEAerDfLrjm",
        "name": "Bernardo Jucá Oliveira ",
        "data": {
          "resident_institute": "Ir. Santa Casa de Misericórdia de São Paulo",
          "resident_begin": "2000-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "fjla62r9O3ok5h4u63cy",
        "name": "Bernardo Parreiras Guimarães Tarabal ",
        "data": {
          "resident_institute": "Hospital das Clínicas da Univ. Federal de MG serv. CCV CNRM/MEC - Dra. Andréa Maria Silveira",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "GnMW1GUSumH4BSmmnzyT",
        "name": "Bianor Terra Neto",
        "data": {
          "resident_institute": "Escola Superior de Ciências da Santa Casa de Misericórdia de Vitória (EMESCAM)",
          "resident_begin": "2018-01-01T02:00:00.000Z",
          "resident_end": "2024-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "griDesp6SsoA1caYm7Tg",
        "name": "Breno Soares de Andrade Wanderley ",
        "data": {
          "resident_institute": "Unidade de Doenças Torácicas - Clinica Stolf - Noedir Stolf",
          "resident_begin": "2003-01-02T02:00:00.000Z",
          "resident_end": "2006-12-29T02:00:00.000Z"
        }
      },
      {
        "id": "7iqUcVq6NtGO2UI0Mbwm",
        "name": "Bruno Andrade Mello Teixeira de Oliveira",
        "data": {
          "resident_institute": "MADRE TERESA BH",
          "resident_begin": "2019-03-08T03:00:00.000Z",
          "resident_end": "2024-03-08T03:00:00.000Z"
        }
      },
      {
        "id": "pb98lVjkqa7MCpJXH5V8",
        "name": "Bruno Mamede Lins Brasiliense",
        "data": {
          "resident_institute": "Instituto HCOR - CNRM/MEC - Dr. Luiz Carlos Bento de Souza",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "s709QZKFQwe1xJqXqYbx",
        "name": "Bruno Miranda Marques ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina - CNRM/MEC - Alfredo Fiorelli",
          "resident_begin": "2005-01-01T02:00:00.000Z",
          "resident_end": "2009-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "JnBLXlZ51VEcTjVSIuZb",
        "name": "Bruno Sell Holz ",
        "data": {
          "resident_institute": "Serviço CCV na Irmandade Santa Casa de Misericórdia de Porto Alegre - Equipe do Dr. Fernando Lucchese",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "xCqhCextQRQuEtKvT0WH",
        "name": "Bruno Sepúlveda Reis ",
        "data": {
          "resident_institute": "Faculdade de Ciências Medicas de Minas Gerais - Hospital Felício Rocho - CNRM/MEC",
          "resident_begin": "2003-01-15T02:00:00.000Z",
          "resident_end": "2006-01-15T02:00:00.000Z"
        }
      },
      {
        "id": "pMo85q4kiU1KuXshhO26",
        "name": "Bruno Silva Ribeiro",
        "data": {
          "resident_institute": "Serv. CCV Hosp. e Maternidade Celso Pierrô PUC CAMP - Dr. Gustavo Calado",
          "resident_begin": "2018-02-01T02:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "eFcuyNsHv2b2dVcobSpi",
        "name": "Caio Bottini Cruz ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Luis Carlos Bento de Souza",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "4RmDyydQPIP2VmQ4OD3U",
        "name": "Caio Leite Ladessa",
        "data": {
          "resident_institute": "Especialização em CCV no Hospital Beneficência Portuguesa - Dr. Sérgio A. de Oliveira",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2027-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "JsO7qsizeGKC0WWhd1yN",
        "name": "Callian Couto Vasconcelos",
        "data": {
          "resident_institute": "Universidade nove de julho - (UNINOVE) Campus Osasco 2021.1 2026.2",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2026-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "Hkfc3F0Wgm7BicFMJx2X",
        "name": "Camila Defendi da Cunha ",
        "data": {
          "resident_institute": "Serv. CCV Sta Casa P. Alegre - Hosp. S. Francisco - Dr. Fernando Antonio Lucchese/Dra. Marcela da Cunha Sales",
          "resident_begin": "2019-02-01T02:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "wfo5SBjD4v5jv9o5yc6w",
        "name": "Camilo Abdulmassih Neto ",
        "data": {
          "resident_institute": "Instituto de Cardiologia - Secretaria da Saúde / CNRM - Adib Jatene",
          "resident_begin": "1970-02-01T03:00:00.000Z",
          "resident_end": "1973-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "ijTbb3nOSchmNMLsSHAm",
        "name": "Cândido Rodrigues Martins Gomes ",
        "data": {
          "resident_institute": "Incor - HCFMUSP - Prof. Dr. Adib Jatene",
          "resident_begin": "1978-01-01T03:00:00.000Z",
          "resident_end": "1981-01-01T03:00:00.000Z"
        }
      },
      {
        "id": "HO1R7SmmqQZnqjQ4SdjP",
        "name": "Carlo Átila Holanda Lopes ",
        "data": {
          "resident_institute": "Hospital de Cardiologia de Messejana - CNRM/MEC - Eduardo Regis Juca Data",
          "resident_begin": "2001-03-01T03:00:00.000Z",
          "resident_end": "2003-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "NqBs8tStIMmcbQVQhSMR",
        "name": "Carlos Alberto Méndez Contreras ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Paulo Paredes Paulista",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "tVYkvuSdx6h1Iw3j2aty",
        "name": "Carlos Alberto Mendonça Caprini ",
        "data": {
          "resident_institute": "BIOCOR INSTITUTO - Bayard Gontijo Filho",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "7nfeqARBqXRZp3KWvKWI",
        "name": "Carlos Alberto Sâncio Jr.",
        "data": {
          "resident_institute": "Serv. CCV Prof Adib Jatene BPSP - Dr. Paulo Paredes Paulista",
          "resident_begin": "1995-02-01T02:00:00.000Z",
          "resident_end": "1997-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "maRV6h0uLslhxQvIuJ9q",
        "name": "Carlos Edson Campos Cunha Filho",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo - CNRM/ME - Glauciete Costa Roque",
          "resident_begin": "2003-02-01T02:00:00.000Z",
          "resident_end": "2006-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "JiH0e1a9DcMvvL2OA9f0",
        "name": "Carlos Eduardo de Alcantara Castilho",
        "data": {
          "resident_institute": "Serviço CCV HC/UFPR - CNRM/MEC - Prof. Dr. Angelo Luiz Tesser",
          "resident_begin": "2003-02-01T02:00:00.000Z",
          "resident_end": "2007-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "KYFxbxPDGhpZerrHZhly",
        "name": "Carlos Eduardo Pereira Dantas ",
        "data": {
          "resident_institute": "Serviço de Clínica e Cirurgia Cardiovascular Prof Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2002-01-02T02:00:00.000Z",
          "resident_end": "2005-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "8IEKMBibk2D4ustStUEh",
        "name": "Carlos Fernando Ramos Lavagnoli ",
        "data": {
          "resident_institute": "Unicamp - CNRM/MEC - Luis Roberto Lopes",
          "resident_begin": "2006-02-01T02:00:00.000Z",
          "resident_end": "2010-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "glvSchnrgl4PUGA8eoIs",
        "name": "Carlos Henrique Gori Gomes ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Curitiba- Francisco Costa",
          "resident_begin": "2004-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "XD78iuyp1yvlb2tEBbiE",
        "name": "Carlos Idelmar de Campos Barbosa ",
        "data": {
          "resident_institute": "Hospital Universitário Pedro Ernesto - Dr. Milton Meier",
          "resident_begin": "1987-01-03T02:00:00.000Z",
          "resident_end": "1990-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "09vd5IMjOhhpF98rX4x3",
        "name": "Carlos Júnior Toshiyuki Karigyo ",
        "data": {
          "resident_institute": "Cirurgia Cardíaca Norte do Parana - Francisco Gregori Jr",
          "resident_begin": "2011-01-01T02:00:00.000Z",
          "resident_end": "2016-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "Nci7AIXDEKQ27UR2Ryfu",
        "name": "Carlos Manuel de Almeida Brandão ",
        "data": {
          "resident_institute": "Instituto do Coração do Hospital das Clínicas da FMUSP - Dr. Fábio Jatene",
          "resident_begin": "1995-01-02T02:00:00.000Z",
          "resident_end": "1998-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "XiLWy0PdF63EBg18Jrcz",
        "name": "Carlos Michiles Barreto ",
        "data": {
          "resident_institute": "Hospital Adventista Silvestre - CNRM/MEC",
          "resident_begin": "1992-03-01T03:00:00.000Z",
          "resident_end": "1995-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "lhDLVRh3W077yzNVIF2H",
        "name": "Carolina Batalha Costa ",
        "data": {
          "resident_institute": "Universidade Nove de Julho - Uninove",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "avuGVtLx5mNA2t1PPGfF",
        "name": "Célio Matheus",
        "data": {
          "resident_institute": "Hospital Adventista Silvestre - CNRM/MEC Dr. Dorival Duarte Lima",
          "resident_begin": "1992-03-01T03:00:00.000Z",
          "resident_end": "1997-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "oRRhpK5C5uYkpXZ2mB0Q",
        "name": "Celso Reis de Avila ",
        "data": {
          "resident_institute": "UNIFESP - CNRM/MEC - Dr. Adagmar Andriolo",
          "resident_begin": "2014-03-06T03:00:00.000Z",
          "resident_end": "2018-03-05T03:00:00.000Z"
        }
      },
      {
        "id": "TphwFAZPUJU5Ny1IpHGV",
        "name": "César Quintaes Freitas Lima Filho",
        "data": {
          "resident_institute": "Especialização em CCV no Hosp. Vera Cruz - Dr Roney Ronald Peixoto",
          "resident_begin": "2014-02-03T02:00:00.000Z",
          "resident_end": "2018-02-03T02:00:00.000Z"
        }
      },
      {
        "id": "qmMyePfesTLRFI8USrM5",
        "name": "Christian José David Cabanillas Fernandez ",
        "data": {
          "resident_institute": "Serv. CCV Santa Casa de Misericórdia de Maceió/Hospital do coração de Alagoas - Dr. Jose Wanderley Neto",
          "resident_begin": "2016-01-11T02:00:00.000Z",
          "resident_end": "2020-01-11T03:00:00.000Z"
        }
      },
      {
        "id": "HMnb4i5jajtKGeJSPvmH",
        "name": "Christian Martins Macedo ",
        "data": {
          "resident_institute": "Hospital Vera Cruz-MG - Homero Geraldo de Oliveira",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "uAjTiB1jsq3FlwfLCnrH",
        "name": "Christiano da Silveira de Barcellos ",
        "data": {
          "resident_institute": "Inst. Cardiologia/RS - Dr. Paulo Prates",
          "resident_begin": "1996-01-02T02:00:00.000Z",
          "resident_end": "1999-12-02T02:00:00.000Z"
        }
      },
      {
        "id": "6CCNycCxQJDQ685BdzNM",
        "name": "Cibelle Padilha Villar Barreto Correia",
        "data": {
          "resident_institute": "Instituto do Coração (incor Pernambuco) CNRM/MEC - Fernando Ribeiro de Moraes Neto",
          "resident_begin": "2014-03-03T03:00:00.000Z",
          "resident_end": "2018-06-15T03:00:00.000Z"
        }
      },
      {
        "id": "1bu38uS5EzkRrPSOGpu9",
        "name": "Cinthia Valdez Toledo",
        "data": {
          "resident_institute": "Serv. CCV Fac Medicina de Botucatu - Coord. Marcello Felicio Laneza",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "EuVeg6zdaqH0f4GwwxmF",
        "name": "Ciro Vinicius Rezende dos Reis",
        "data": {
          "resident_institute": "Serv. CCV Hospital Santa Casa de Misericórdia de Goiânia - CNRM/MEC Dr. Evrandro M. R. Bittencourt Junior",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-29T03:00:00.000Z"
        }
      },
      {
        "id": "PrQ6kHGYOM07Cg542IvB",
        "name": "Claudinei Collatusso ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular No Hospital de Caridade da Irmandade da Santa Casa de Misericórdia - Francisco Costa",
          "resident_begin": "2003-02-02T02:00:00.000Z",
          "resident_end": "2007-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "CrMEJlBzYlh1i1mwik9W",
        "name": "Cláudio Albernaz César",
        "data": {
          "resident_institute": "Fundação Centro de Estudo Dr. Wiliam Maksoud - João Jazbik Neto",
          "resident_begin": "1995-02-02T02:00:00.000Z",
          "resident_end": "1998-02-02T02:00:00.000Z"
        }
      },
      {
        "id": "A0gFbSMSrgOxhuhzdZQs",
        "name": "Cláudio Almeida Parra ",
        "data": {
          "resident_institute": "Hospital Vera Cruz - Roney Ronald Peixoto",
          "resident_begin": "2009-01-01T02:00:00.000Z",
          "resident_end": "2012-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "OnihPyWjPMkA6mJRMfwr",
        "name": "Cláudio Leo Gelape ",
        "data": {
          "resident_institute": "Inst. Card. Dante Pazzanese - Antoninho Arnoni",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2001-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "dbvHmVev5rhUncu4ai0e",
        "name": "Claudio Mendes Sobrinho",
        "data": {
          "resident_institute": "Santa casa de Misericórdia do Maranhão e Hospital de Referência da Alta Complx Dr. Carlos Macieira - 2.6.8 Edital 2023 (10 anos de atuação)",
          "resident_begin": "2005-03-01T03:00:00.000Z",
          "resident_end": "2023-03-31T03:00:00.000Z"
        }
      },
      {
        "id": "GaqC6XjCatqgp6B4Fwa4",
        "name": "Cleber Glória Silva ",
        "data": {
          "resident_institute": "Hospital Geral Dr. Beda",
          "resident_begin": "2004-01-01T02:00:00.000Z",
          "resident_end": "2007-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "JyS5Mj4rUgRaqWTRMXRx",
        "name": "Cledicyon Eloy da Costa",
        "data": {
          "resident_institute": "Serviço Clínica Cardio-Cirúrgica J.P. da Silva - Hospital São Joaquim BPSP",
          "resident_begin": "1992-01-02T02:00:00.000Z",
          "resident_end": "1995-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "9p8xqOkNygKCe4P1OHJO",
        "name": "Cleryston Barbosa Maia",
        "data": {
          "resident_institute": "\"Serviço CCV Equipe Dr",
          "resident_begin": null,
          "resident_end": "1997-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "uxAKsI7DNMh9wi4qp7bp",
        "name": "Cristiano Berardo Carneiro da Cunha ",
        "data": {
          "resident_institute": "Instituto do Coração de Pernambuco - CNRM/MEC - Dr. Fernando Ribeiro de Moraes Neto",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "ne5B6zr8B2WHZAbEsSyj",
        "name": "Cristiano Blaya Martins ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do RS / Fundação Universitária de Cardiologia - Renato Kalil",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "fgpYkx2pWeniRBHQD05B",
        "name": "Cristiano Gustavo Hahn ",
        "data": {
          "resident_institute": "Hospital NS das Graças de Curitiba - CNRM/MEC - Leonardo Mulinari",
          "resident_begin": "2000-01-05T02:00:00.000Z",
          "resident_end": "2003-01-05T02:00:00.000Z"
        }
      },
      {
        "id": "6HkTf8zwl8Ye0v6fGpdd",
        "name": "Cristiano Mahlmann Muniz Dantas",
        "data": {
          "resident_institute": "Serv. CCV FMUSP CNRM/MEC - Comissão Dra. Gesiele dos Santos Lara",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "SDJfKH7gba3M4qGyn3EP",
        "name": "Cristina Sofia Candia Barrientos ",
        "data": {
          "resident_institute": "Serv. CCV Hospital Madre Teresa - Dr. Rodrigo de Castro Bernardes",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "rtsbquTawUKAVYq97s52",
        "name": "Crystian Josue Tholl ",
        "data": {
          "resident_institute": "Instituto de Cardiologia de S.C.",
          "resident_begin": "2003-01-01T02:00:00.000Z",
          "resident_end": "2007-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "N7kAbrv1COv51XT2Vsd8",
        "name": "Cybelle Soares Matos Cascudo ",
        "data": {
          "resident_institute": "Clinica Cardio-Cirurgia J. p. da Silva",
          "resident_begin": "2011-01-03T02:00:00.000Z",
          "resident_end": "2015-01-03T02:00:00.000Z"
        }
      },
      {
        "id": "bSnBpyH8LZ0ikLR4dggp",
        "name": "Daniel Augusto Schröder ",
        "data": {
          "resident_institute": "Serv. CCV - Instituto de Cardiologia do Rio Grande do Sul - CNRM/MEC - Dr. Marne de Freitas Gomes",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "5H8brXYm4e9Zjq0GmmfC",
        "name": "Daniel Chagas Dantas ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanesse - CNRM/MEC Cood. Dra. Magaly Arrais",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "iurixPLO0PGDAi5btBwM",
        "name": "Daniel Dos Santos Lima Marques",
        "data": {
          "resident_institute": "Honpar - Hospital Norte Paranaense",
          "resident_begin": "2019-01-07T02:00:00.000Z",
          "resident_end": "2024-01-07T03:00:00.000Z"
        }
      },
      {
        "id": "DlhYrWLGJ4L1qAdkByWh",
        "name": "Daniel Enrique da Silva Andrade",
        "data": {
          "resident_institute": "Ser. CCV Hospital Infante Don Henrique - INST. CIRURG. CARD E DOENÇAS DA AORTA LTDA. Coord. Dr. João Carlos Ferreira Leal",
          "resident_begin": "2015-01-12T02:00:00.000Z",
          "resident_end": "2019-01-12T02:00:00.000Z"
        }
      },
      {
        "id": "uJhPllsJpSNJ792WST54",
        "name": "Daniel Fioravanti Freitas",
        "data": {
          "resident_institute": "Serviço CCV Incardio Santa Casa Feira de Santana - Dr. André Guimarães (Tempo de Atuação em CCV item 2.6.7 do Edital 2021)",
          "resident_begin": "2010-12-01T02:00:00.000Z",
          "resident_end": "2021-04-30T03:00:00.000Z"
        }
      },
      {
        "id": "lWrel2XYc1ltd8sCTbUL",
        "name": "Daniel Francisco de Mendonça Trompieri ",
        "data": {
          "resident_institute": "Unidade de Doenças Toracicas Stolf - Dr. Noedir Stolf",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "a8vPgddB3sABR4c6X0xF",
        "name": "Daniel Hoyer de Carvalho Barcellos ",
        "data": {
          "resident_institute": "Hospital São Francisco - Sta Casa de Porto Alegre - Dr. Fernando Lucchese",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "1SPq5g5oP4AtHhClXl1m",
        "name": "Daniel Marcelo Silva Magalhães ",
        "data": {
          "resident_institute": "Clínica Cardio Cirúrgica J. P. da Silva Ltda - Dr. José Pedro da Silva",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2003-08-31T03:00:00.000Z"
        }
      },
      {
        "id": "HNQMCO6jrucu2LEk428R",
        "name": "Daniel Marcondes Chacon",
        "data": {
          "resident_institute": "Serv CCV BPSP Equipe Dr. de Oliveira - Coord. Dr. Sérgio Almeida",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "WJSFL0OQEIwxSUESuxP8",
        "name": "Daniel Nardi",
        "data": {
          "resident_institute": "Hospital Felicio Rocho - CNRM/MEC Coord. Dr. Marcondes Oliveira Pena",
          "resident_begin": "2005-02-02T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "FrxQDZc2PShXH2JKUOi4",
        "name": "Daniel Peres Guimarães ",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - Sergio A Oliveira",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "4tpjUzpABoIUqwellQEr",
        "name": "Daniel Robert Alexander",
        "data": {
          "resident_institute": "Hospital do Coração - SP (HCOR)",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "VPejuTuqnwioWQIKsVbn",
        "name": "Daniel Rossano Correa",
        "data": {
          "resident_institute": "Hospital São Lucas - CNRM/MEC - Prof José Miguel Chatkin",
          "resident_begin": "2004-02-17T03:00:00.000Z",
          "resident_end": "2008-02-16T02:00:00.000Z"
        }
      },
      {
        "id": "K3kJplabOWfeVAhbOrk0",
        "name": "Daniel Siqueira Barbosa ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - Preceptor Responsável: Dr. José Pedro da Silva",
          "resident_begin": "2003-01-03T02:00:00.000Z",
          "resident_end": "2006-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "SxpVW2XLr9x04I1eSWLu",
        "name": "Daniela Machado Bezerra",
        "data": {
          "resident_institute": "Serviço CCV BPSP - Equipe do Dr. Januário Manuel de Souza",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "nNW50UEri7bTgVhUKSUW",
        "name": "Daniele de Fátima Fornazari Collatusso ",
        "data": {
          "resident_institute": "Hospital Santa Casa de Curitiba - Francisco Costa",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "pVBagCY2tyGGsaNSV9bb",
        "name": "Danilo Maroja Bentes de Carvalho ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - Preceptor Responsável: Dr. José Pedro da Silva",
          "resident_begin": "2003-01-02T02:00:00.000Z",
          "resident_end": "2006-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "5UmZHck9ge777VGK59uK",
        "name": "Dante Thomé da Cruz ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina - CNRM/MEC - Sérgio Almeida de Oliveira",
          "resident_begin": "2000-02-01T02:00:00.000Z",
          "resident_end": "2003-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "2E1l0BMvGp16WvyrXSXw",
        "name": "Darteson da Silveira Gutierrez ",
        "data": {
          "resident_institute": "Hospital Universitário Pedro Ernesto - CNRM/MEC",
          "resident_begin": "1997-03-01T03:00:00.000Z",
          "resident_end": "2000-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "SFNBoq7e9WXbhS4DRrSh",
        "name": "Davi Freitas Tenório",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo/InCor - HCFMUSP CNRM/MEC - DR. Alfredo Fiorelli / Dr. Fábio Jatene",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "e9Kgsv0767kWcbiMPj11",
        "name": "Débora Klein Ferreira ",
        "data": {
          "resident_institute": "Universidade Católica do Rio Grande do Sul - CNRM/MEC - Dra Margareth Rodrigues Salerno",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "prVEkg4LSluafkSLGudO",
        "name": "Deborah Louize da Rocha Vianna Palmieri",
        "data": {
          "resident_institute": "Serviço CCV Instituto Nacional de Cardiologia (INC) CNRM/MEC - Responsável Dr. Diego Sarty Vianna",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ZXjgJ0xKFrzvYjrrYVz1",
        "name": "Décio Cardoso da Silva Júnior ",
        "data": {
          "resident_institute": "InCor/FMUSP",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "pWpnxr0dJGFYWgjb5jE9",
        "name": "Décio Cavalet Soares Abuchaim ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca da Santa Casa de Misericórdia de Curitiba - Preceptor atual: Dr. Francisco Costa",
          "resident_begin": "1995-01-10T02:00:00.000Z",
          "resident_end": "1999-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "7aXjhZ76tdHA9TaBDKs8",
        "name": "Demian Cândido Ferreira ",
        "data": {
          "resident_institute": "Serviço Equipe do Dr. Sérgio Almeida de Oliveira - Hospital São Joaquim SPBP",
          "resident_begin": "2005-01-01T02:00:00.000Z",
          "resident_end": "2008-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "g8QTi6xI5KlSBMOLHQZD",
        "name": "Dennys Marcel Sanches Martins ",
        "data": {
          "resident_institute": "BPSP Clinica de Cirurgia das Moléstias Cardiovascular - João Bosco de Oliveira",
          "resident_begin": "2007-01-20T02:00:00.000Z",
          "resident_end": "2011-01-20T02:00:00.000Z"
        }
      },
      {
        "id": "Ng4j2isoiXhBCQyQR8Bk",
        "name": "Dhaisa Thaina Souza Conceição ",
        "data": {
          "resident_institute": "Universidade Federal da Bahia (UFBA)",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2025-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "hXinbxIZhW0TRBpvUNMV",
        "name": "Diego Gamarra Moreira",
        "data": {
          "resident_institute": "Serv. CCV Inst. Card. Dante Pazzanese - Dr. Antoninho Arnoni",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "0zSSoOszfL3xn3SfsuhW",
        "name": "Diego Leiz Destro da Silva ",
        "data": {
          "resident_institute": "Hospital das Clinicas do Paraná - Dr George Soncini - Atualmente com 7 anos, completando 8 anos em março/2020",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2020-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "s3183n94ktnCfjlUXRSu",
        "name": "Diego Maia Martins ",
        "data": {
          "resident_institute": "Serv. CCV Hospital Do Coração Hcor/SP - CNRM/MEC - Dra. Ieda Biscegli Jatene",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "73weVmWoKfRfs8L2A1w1",
        "name": "Diego Pereira Gregorio de Andrade ",
        "data": {
          "resident_institute": "Serv CCV. Santa Casa de Misericórdia de Maceió, Inst. de Doença do Coração - Dr. José Wanderley Neto",
          "resident_begin": "2017-02-01T02:00:00.000Z",
          "resident_end": "2021-02-01T03:00:00.000Z"
        }
      },
      {
        "id": "GCB4b3ALS8iFbvZagKif",
        "name": "Diego Pretel",
        "data": {
          "resident_institute": "Serv. CCV Fac Medicina de Botucatu - Coord. Marcello Felicio Laneza",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "nC3O0eUNDHmvFAfrOURQ",
        "name": "Diego Sarty Vianna ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina - CNRM/MEC - Alfredo Fiorelli",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "csRvIA741WFTpCrED5s5",
        "name": "Dilmar Cardeal da Cunha",
        "data": {
          "resident_institute": "Instituto Cardiologia do Rio Grande do Sul CNRM/MEC - Dr. Domingos Vitola",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "caInCe2UEo2vJ5ez9FAN",
        "name": "Diogo Assis Souza ",
        "data": {
          "resident_institute": "Serv. CCV Hospital de Base do Distrito Federal - Dr. Luiz Carlos Schimin",
          "resident_begin": "2021-07-01T03:00:00.000Z",
          "resident_end": "2026-07-01T03:00:00.000Z"
        }
      },
      {
        "id": "RTzyi9FXLiYONu6h1f4j",
        "name": "Diogo Luiz de Magalhães Ferraz ",
        "data": {
          "resident_institute": "Instituto do Coração de Pernambuco - Fernando Moraes Ribeiro Neto",
          "resident_begin": "2011-09-01T03:00:00.000Z",
          "resident_end": "2015-08-31T03:00:00.000Z"
        }
      },
      {
        "id": "ZqutUxaHuG8A3uyiAkDt",
        "name": "Diogo Osternack Curi Lage ",
        "data": {
          "resident_institute": "Faculdade de Medicina de SP - Depart. CCV - CNRM/MEC - Alfredo Fiorelli",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "QuBCcGXDoEu8Ys5dnCes",
        "name": "Dionísio Otavio Bentes Carvalho Neto ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - Preceptor Responsável: Dr. José Pedro da Silva",
          "resident_begin": "1991-01-02T02:00:00.000Z",
          "resident_end": "1994-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "5Ryx1h9dMc8hj576EQhO",
        "name": "Dionisio Yaya Chumpitaz ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "1987-01-02T02:00:00.000Z",
          "resident_end": "1990-01-12T02:00:00.000Z"
        }
      },
      {
        "id": "EVlQi0qc4uTEu9a17JnS",
        "name": "Dirceu de Queiroz Amaral ",
        "data": {
          "resident_institute": "Hospital Madre Teresa - Preceptor Responsável: Rodrigo Bernardes",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "Ns6RWOpyz8XmfQC5FM2S",
        "name": "Dirceu Oscar Faelli Júnior ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Paulo Paredes Paulista",
          "resident_begin": "1977-02-01T03:00:00.000Z",
          "resident_end": "1980-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "qH8TRPCnJaqHhEW9dHo8",
        "name": "Divino Francisco Pinto ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo",
          "resident_begin": "1990-02-01T02:00:00.000Z",
          "resident_end": "1993-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "4xQoHLTL2AU5CdoxRlFj",
        "name": "Dora Liliana Campo Morales",
        "data": {
          "resident_institute": "Serv. CCV - RJ - HOSPITAL UNIVERSITÁRIO PEDRO ERNESTO UERJ CNRM/MEC - Dr. Joaquim Henrique Coutinho",
          "resident_begin": "2020-03-02T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "QlIOacEbDWRnI0eXmuzQ",
        "name": "Dorian Nogueira Cardoso ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Universitário Francisca Mendes - DR Mariano Brasil Terrazas",
          "resident_begin": "2010-01-01T02:00:00.000Z",
          "resident_end": "2013-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "QlIOacEbDWRnI0eXmuzQ",
        "name": "Dorian Nogueira Cardoso ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Universitário Francisca Mendes - DR Mariano Brasil Terrazas : ",
          "resident_begin": "2010-01-01T02:00:00.000Z",
          "resident_end": "2013-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "iQTNmaqJVWtSVMAJF4ru",
        "name": "Douglas Barbosa Ferreira Souza ",
        "data": {
          "resident_institute": "Especialização em CCV no Hospital Felicio Rocho - Dr. Dielson Teixeira Sampaio",
          "resident_begin": "2014-03-06T03:00:00.000Z",
          "resident_end": "2018-03-06T03:00:00.000Z"
        }
      },
      {
        "id": "x96RTcMH0zbKkwiGfOBc",
        "name": "Douglas Rossoni",
        "data": {
          "resident_institute": "Clinica Cardio Cirúrgica JP da Silva - Dr José Pedro da Silva",
          "resident_begin": "2015-01-02T02:00:00.000Z",
          "resident_end": "2019-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "Lo5C6YALP7P9P10nKIec",
        "name": "Dugarth Amado Nina Garcia ",
        "data": {
          "resident_institute": "BP SP - Clínica Stolf - BP SP - Clínica Stolf",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2001-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "qZky4qLteefXLfrbIOUl",
        "name": "Edemir Veras de Carvalho Jr. ",
        "data": {
          "resident_institute": "Universidade São Paulo - CNRM Coordenador do Programa: Alfredo Inácio Fiorelli",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "ME00y8sHlm3Bo1swOH9E",
        "name": "Edmilson Cardoso Santos Filho ",
        "data": {
          "resident_institute": "Instituto do Coração (incor Pernambuco) CNRM/MEC - Dr Euclides Martins Tenório",
          "resident_begin": "2001-03-01T03:00:00.000Z",
          "resident_end": "2004-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "W2goKcIVkWRaxU6HUTVa",
        "name": "Edmo Atique Gabriel ",
        "data": {
          "resident_institute": "Universidade Paulista de Medicina - CNRM/MEC - Ramiro Anthero de Azevedo",
          "resident_begin": "2005-02-02T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "qc30SF06kHbexXLOps7g",
        "name": "Edson Gary Moreira Moreira",
        "data": {
          "resident_institute": "INSTITUTO DANTE PAZZANESE DE CARDIOLOGIA",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "MdnbqvSTY8yu6aEqcBFh",
        "name": "Eduardo Augusto dos Santos Moreira Silva",
        "data": {
          "resident_institute": "Serv. CCV Hospital São Francisco de Assis - Coord. Dr. José Augusto Ferreira",
          "resident_begin": "2014-06-11T03:00:00.000Z",
          "resident_end": "2018-06-10T03:00:00.000Z"
        }
      },
      {
        "id": "Qwt0xZPpg7h45XJaMPBX",
        "name": "Eduardo Augusto Oliveira Farias ",
        "data": {
          "resident_institute": "Incor - HCFMUSP - Dr. Fábio B. Jatene",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "a2uA7CXMMCt61fFYNtz7",
        "name": "Eduardo Campos Valentim ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Santa Casa de Campo Grande - João Jazbik Neto",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "b2V6B23RsSMbm6GUu34Q",
        "name": "Eduardo Carvalho Ferreira ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Paulo Paredes Paulista",
          "resident_begin": "2004-02-01T02:00:00.000Z",
          "resident_end": "2007-10-31T02:00:00.000Z"
        }
      },
      {
        "id": "I54dzWsUOhVFh4QEI1Tf",
        "name": "Eduardo de Franco Borges ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba Danton Loures",
          "resident_begin": "2000-01-02T02:00:00.000Z",
          "resident_end": "2004-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "Qjdm1veCCbQiEQOBzmvU",
        "name": "Eduardo Gregório Chamlian ",
        "data": {
          "resident_institute": "irmandade da Santa Casa de Misericórdia de São Paulo - CNRM/MEC - Raimuindo Raffaelli Filho",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "CmAlnnrzjRt13rIfjULG",
        "name": "Eduardo Miranda Teixeira",
        "data": {
          "resident_institute": "Serviço CCV Unidade Cardiotorácica da Fundação Beneficência Hospital de Cirurgia -SE Coord: Dr. José Teles Mendonça",
          "resident_begin": "2006-01-01T02:00:00.000Z",
          "resident_end": "2010-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "Zu1rtedZLLTj2KVRPPIE",
        "name": "Eduardo Piccini Nascimento Gomes",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina CNRM/MEC - Prof. Dr. Alfredo Fiorelli",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "lKXrCxQeyOBXld9f6MAD",
        "name": "Eduardo Pradi Adam ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca da Santa Casa de Curitiba - Preceptor atual: Dr. Francisco Costa",
          "resident_begin": "1997-01-10T02:00:00.000Z",
          "resident_end": "2000-12-18T02:00:00.000Z"
        }
      },
      {
        "id": "WvlbjP4n4vE2zDUHxXHi",
        "name": "Eduardo Sérgio Bastos ",
        "data": {
          "resident_institute": "Hospital Servidores do Estado do RJ - IPASE - Dr. Cid Nogueira",
          "resident_begin": "1974-01-10T03:00:00.000Z",
          "resident_end": "1976-01-30T03:00:00.000Z"
        }
      },
      {
        "id": "FsYWKNeBEfrhMejo4cic",
        "name": "Eduardo Toshimitsu Watanuki ",
        "data": {
          "resident_institute": "Hospital e Maternidade Celso Pierro Puc - Campinas",
          "resident_begin": "2009-01-01T02:00:00.000Z",
          "resident_end": "2013-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "hAi2TbROvagdY4w9GdYN",
        "name": "Elcio Pires Júnior",
        "data": {
          "resident_institute": "Beneficência Portuguesa",
          "resident_begin": "2005-01-01T02:00:00.000Z",
          "resident_end": "2009-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "5NLDizpgqY1YJFotezLQ",
        "name": "Eleonora Dias Galheigo ",
        "data": {
          "resident_institute": "Hospital Universitário Clementino Fraga Filho - CNRM/MEC - Dr. Mauro Paes Leme de Sá",
          "resident_begin": "2000-04-01T03:00:00.000Z",
          "resident_end": "2002-03-31T03:00:00.000Z"
        }
      },
      {
        "id": "G4yRUxcgeXEhHiembBfg",
        "name": "Eliane dos Reis Cruz ",
        "data": {
          "resident_institute": "Cirurgia Cardíaca na Unidade de Doenças Torácicas Stolf - Dr Noedir Stolf",
          "resident_begin": "2013-01-01T02:00:00.000Z",
          "resident_end": "2017-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "w2FOStkDwJQYLGRSCFVi",
        "name": "Elias Kallás ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo - Carlos da Silva Pacaz",
          "resident_begin": "1973-03-01T03:00:00.000Z",
          "resident_end": "1974-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "mbc11rf4GLD7GQQWFz1Q",
        "name": "Eliévia Maria de Oliveira Escossio ",
        "data": {
          "resident_institute": "Serviço de Clinica e Cirurgia Cardiovascular - BPSP - Dr. Adib D. Jatene",
          "resident_begin": "1993-01-01T02:00:00.000Z",
          "resident_end": "1995-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "EtAfmnqDcepyhD8K2cGP",
        "name": "Elinthon Tavares Veronese ",
        "data": {
          "resident_institute": "Universidade São Paulo - CNRM Coordenador do Programa: Alfredo Inácio Fiorelli",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "gAho81WNvytwDNddNFZQ",
        "name": "Elisa de Hollanda Calderari ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba Danton Loures",
          "resident_begin": "1993-01-02T02:00:00.000Z",
          "resident_end": "1996-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "ZlJhhcGBjq0kXIS34cIR",
        "name": "Elísio de Souza Rebouças ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Santa Casa de Misericordiosa de Ribeirão Preto - Eduardo Cosac Paranhos",
          "resident_begin": "2012-01-09T02:00:00.000Z",
          "resident_end": "2015-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "1aINPSVslZ6pt9f4Nwlt",
        "name": "Elizabeth Sartori Crevelari ",
        "data": {
          "resident_institute": "Intituto do Coração do Hospital das Clínicas da Facul. USP - Dr. Equipe Dr. Pablo M. A. Pomerantzeff",
          "resident_begin": "1990-01-01T02:00:00.000Z",
          "resident_end": "1994-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "fgEwsLaGtJlsOqtOnaat",
        "name": "Eloi Colen Filho ",
        "data": {
          "resident_institute": "Inst. D. Cardio Pulm. Zerbini - Preceptor atual: Eduardo Coelho Souza",
          "resident_begin": "1982-07-10T03:00:00.000Z",
          "resident_end": "1984-06-30T03:00:00.000Z"
        }
      },
      {
        "id": "QNYDGHu7T5yq6OmsL9yb",
        "name": "Elson Borges Lima ",
        "data": {
          "resident_institute": "Incor - HCFMUSP - Dr. Fábio B. Jatene",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2008-03-14T03:00:00.000Z"
        }
      },
      {
        "id": "hiUOIUp4KS6Pe0yNZyrG",
        "name": "Elvis Aaron Porto",
        "data": {
          "resident_institute": "Serviço CCV Faculdade de Medicina de Botucatu CNRM/MEC - Coord Dra. Cátia Regina Branco da Fonseca",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "nyQ5gJ97BJbCFJf5vTDq",
        "name": "Emanoel Pimentel Cruz ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia CNRM/MEC - Dr. Antoninho Arnoni",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "gCw5zwr5gp2qn8axzBaB",
        "name": "Emmanuel Calou Silva Thé ",
        "data": {
          "resident_institute": "Universidade de Pernambuco - CNRM/MEC Coordenadora: Dra. Valdecira J. de Lucena",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "fKqdk4mirnKpitNkFqdV",
        "name": "Endrigo de Oliveira Rodrigues ",
        "data": {
          "resident_institute": "Unidade Carddiotorácica Fundação Beneficência Hospital de Cirurgia - Dr José Teles Mendonça",
          "resident_begin": "2010-10-01T03:00:00.000Z",
          "resident_end": "2014-10-31T02:00:00.000Z"
        }
      },
      {
        "id": "KUrfspRDNH3y1f5UxEXv",
        "name": "Enio Buffolo ",
        "data": {
          "resident_institute": "Escola Paulista de medicina - Serviço CCV do Dr. Costabile Gallucci",
          "resident_begin": "1996-01-02T02:00:00.000Z",
          "resident_end": "1970-01-02T03:00:00.000Z"
        }
      },
      {
        "id": "Gb1f8gFOJjJzt6MfErjp",
        "name": "Eôlo Ribeiro de Alencar Neto",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - Preceptor Responsável: Dr. José Pedro da Silva",
          "resident_begin": "1996-01-18T02:00:00.000Z",
          "resident_end": "1999-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "AGzH3sArBrdZZRvixeKi",
        "name": "Eric Rodrigo Morales Mercado ",
        "data": {
          "resident_institute": "Serv. CCV Unidade de Doenças Torácicas Stolf - Dr. Noedir Stolf",
          "resident_begin": "2012-02-01T02:00:00.000Z",
          "resident_end": "2016-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "FiQNyEPhN2tNXOCdHono",
        "name": "Érica Yumi Matsumoto Gusikuda ",
        "data": {
          "resident_institute": "Universidade Nove de Julho Osasco (UNINOVE)",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "C18irmJOxFIoLUdbHUD8",
        "name": "Ernesto Frank Cisneros López ",
        "data": {
          "resident_institute": "Instituto do Coração (Incor) - Hospital das Clínicas - Prof. Fábio Jatene",
          "resident_begin": "2004-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "vB6AS6qikUIkpb7iWGYS",
        "name": "Ernesto Koehler Chavez ",
        "data": {
          "resident_institute": "Pontificia Universidade Cotólica do Rio de Janeiro - CNRM/MEC",
          "resident_begin": "1975-01-02T03:00:00.000Z",
          "resident_end": "1976-02-20T03:00:00.000Z"
        }
      },
      {
        "id": "yrKhxFUfK82dajdgFV6B",
        "name": "Estevan Letti ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Porto Alegre / Hospital São Francisco - Dr. Fernando Antônio Lucchese",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "4aLDxOmSRLFYsYObPnw1",
        "name": "Eucário Leite Monteiro Alves ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1992-02-01T02:00:00.000Z",
          "resident_end": "1995-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "8rz4VQREy5VbaF9e80xt",
        "name": "Evando Esteves de Lucena ",
        "data": {
          "resident_institute": "Instituto Biocor Doenças cardiovasculares - Dr. Bayard Gontijo Filho",
          "resident_begin": "1990-12-01T02:00:00.000Z",
          "resident_end": "1993-12-01T02:00:00.000Z"
        }
      },
      {
        "id": "fTeqVdc25JL4lYsoJbp7",
        "name": "Evandro Carlos Ribeiro Lopes ",
        "data": {
          "resident_institute": "SBCG Santa Casa Fundação Centro de Estudo - CNRM/MEC - João Jazbik Neto",
          "resident_begin": "2002-01-03T02:00:00.000Z",
          "resident_end": "2005-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "foUTdabGXQ6PPw7KSm0J",
        "name": "Evelyn Soares Costa ",
        "data": {
          "resident_institute": "Serv. CCV do Santa Casa de Misericórdia de Santos CNRM/MEC - Dr. Regério A. Dedivitis",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ZnOqz81CtQjKkXQ4pVEW",
        "name": "Fabian Cecchi Teno Castilho ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1996-02-01T02:00:00.000Z",
          "resident_end": "1999-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "ZlzhIrAEmqcQschHp0Lf",
        "name": "Fabiana Michelle Feitosa de Oliveira",
        "data": {
          "resident_institute": "Residência Médica em CCV no Instituto do Coração de Pernambuco CNRM/MEC - Dr. Fernando Ribeiro Moraes Neto",
          "resident_begin": "2015-03-02T03:00:00.000Z",
          "resident_end": "2019-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "znJNFvKTIqZMJkOXLTvz",
        "name": "Fabiano Gonçalves Jucá ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC - Adib Jatene",
          "resident_begin": "1996-02-01T02:00:00.000Z",
          "resident_end": "1999-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "yR90UibGt1F4XWXPDqrp",
        "name": "Fabiano Silva Câmara de Souza Amaral",
        "data": {
          "resident_institute": "Serv. CCV BPSP Equipe do Dr Sérgio Almeida de Oliveira - Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2013-02-18T03:00:00.000Z",
          "resident_end": "2017-02-18T02:00:00.000Z"
        }
      },
      {
        "id": "trJl3mMPC4R4g0E7nhnv",
        "name": "Fabio Antonio Amando Granja ",
        "data": {
          "resident_institute": "Núcleo de Cardiologia e Cirurgia Cardiovascular - NCT/Real Hospital Português - PE - Dra. Sheila Maria (mais de 8 anos de treinamento)",
          "resident_begin": "2000-03-01T03:00:00.000Z",
          "resident_end": "2019-11-29T03:00:00.000Z"
        }
      },
      {
        "id": "xqTX7GiqTIBdSS1966cZ",
        "name": "Fábio Antonio Gaiotto ",
        "data": {
          "resident_institute": "Instituto do Coração - Fundação Zerbini - Dra. Silvia Lage",
          "resident_begin": "1997-02-01T02:00:00.000Z",
          "resident_end": "2000-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "BTlpXRTvn56uWDHODHh2",
        "name": "Fabio Biscegli Jatene ",
        "data": {
          "resident_institute": "Hospital das Clínicas - Faculdade de Medicina de SP - Rubens Monteiro de Arruda",
          "resident_begin": "1981-02-26T03:00:00.000Z",
          "resident_end": "1983-02-13T03:00:00.000Z"
        }
      },
      {
        "id": "PCVMEl2ssb4llAyYHG7Y",
        "name": "Fabrício Barreira Pombo",
        "data": {
          "resident_institute": "Hospital de Messejana Dr. Carlos Albert Studart Gomes - CNRM/MEC",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "5oDJONxb6KKoNRImsWEj",
        "name": "Fabrício José de Souza Dinato ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo - CNRM/ME - Glauciete Costa Roque",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "2eC5tG3Rf3IgH8ZRNRA0",
        "name": "Fabrício Lara Carvalho",
        "data": {
          "resident_institute": "Serv. CCV Hospital Beneficência Portuguesa de Sao Paulo - Equipe Dr Januário Manoel de Souza",
          "resident_begin": "2024-03-04T03:00:00.000Z",
          "resident_end": "2029-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "2sKKZE5TkYFdIUEwk9aX",
        "name": "Farid Cesar Faes",
        "data": {
          "resident_institute": "Inst. Cardiologia/RS Paulo Prates",
          "resident_begin": "1989-02-01T03:00:00.000Z",
          "resident_end": "1993-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "dHJraQIYTblKRxLTYpZz",
        "name": "Felipe Abatti Spadini ",
        "data": {
          "resident_institute": "Serv. CCV do Hospital Nossa Senhora da Conceição - GHC CNRM/MEC - Dra Adriana Silveira de Almeida",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2027-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "yKp7ZQzJC69rT0rz5FBn",
        "name": "Felipe Becker Magalhães ",
        "data": {
          "resident_institute": "Serviço em CCV Sanda Casa de Misericórdia de Belo Horizonte - Marcelo Frederigue de Castro",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "RyQ0kLj1Nuk2fB3JCDw8",
        "name": "Felipe Borsu de Salles ",
        "data": {
          "resident_institute": "Incor - FMUSP/CNRM-MEC - Dr Alfredo Inácio Fiorelli",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ZG7TZCr9aXDw2fJZvQCm",
        "name": "Felipe Raminho Coelho",
        "data": {
          "resident_institute": "Serv. CCV Hospital vera Cruz - Dr Roney Ronald Peixoto",
          "resident_begin": "2013-01-01T02:00:00.000Z",
          "resident_end": "2017-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "AtXcVcGzQRhRm88BYtTT",
        "name": "Felipe Reale Cividanes ",
        "data": {
          "resident_institute": "Serv CCV BPSP Equipe Dr Januário - Dr Januário M de Souza",
          "resident_begin": "2014-02-01T02:00:00.000Z",
          "resident_end": "2018-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "ZIrxHNNBdnmPcXMwBH8i",
        "name": "Felipe Vale de Araujo",
        "data": {
          "resident_institute": "HOSPITAL DAS CLINICAS DA FACULDADE DE MEDICINA DE BOTUCATU (HCFMB - UNESP)",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "XNlcaGbtnW8Vq49tRJCK",
        "name": "Felix Marcelo Gutierrez Mealla ",
        "data": {
          "resident_institute": "Programa de Capacitação/Especialização em CCV - InCor-FMUSP - Alfredo Inácio Fiorelli",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "CITyN0UQHCKQoYhfkUsG",
        "name": "Fernanda Lübe Antunes Pereira ",
        "data": {
          "resident_institute": "Serviço CCV Biocor - Equipe da Dra. Erika Vrandecic - Coordenador Dr. Leonardo Ferber Drumond",
          "resident_begin": "2016-01-01T02:00:00.000Z",
          "resident_end": "2019-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "erCyDflL7ZGmpehDnqM9",
        "name": "Fernando Alves Pereira Júnior ",
        "data": {
          "resident_institute": "Hospital Madre Teresa - Belo Horizonte - Dr Rodrigo Bernardes",
          "resident_begin": "2014-02-03T02:00:00.000Z",
          "resident_end": "2018-01-29T02:00:00.000Z"
        }
      },
      {
        "id": "afsnjBQP9NpJnPtrRxrt",
        "name": "Fernando Andrade Guedes ",
        "data": {
          "resident_institute": "Serviço Cardiovascular e Pulmonar - Prof. Dr. Edgard. San Juan",
          "resident_begin": "1979-01-01T03:00:00.000Z",
          "resident_end": "1981-12-30T03:00:00.000Z"
        }
      },
      {
        "id": "RzhhxnIjXUFxXnBViKDk",
        "name": "Fernando Antibas Atik ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de SP - CNRM/MEC Dr. Márcio Rogério Batista Coord.",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2001-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "KGboPJaP8ub7mjron2Qe",
        "name": "Fernando Antoniali ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - Preceptor Responsável: Dr. José Pedro da Silva",
          "resident_begin": "1999-02-02T02:00:00.000Z",
          "resident_end": "2002-02-20T03:00:00.000Z"
        }
      },
      {
        "id": "RYDKllEwxDZR8rGlgksq",
        "name": "Fernando Antonio Fantini ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Belo Horizonte - Ricardo Pereira Souza",
          "resident_begin": "1975-07-01T03:00:00.000Z",
          "resident_end": "1977-11-30T03:00:00.000Z"
        }
      },
      {
        "id": "VbemlUiQZS2XiFQdu4NW",
        "name": "Fernando Antonio Lucchese ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul - Ivo Abrahão Nesralla",
          "resident_begin": "1971-02-01T03:00:00.000Z",
          "resident_end": "1973-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "NhhkcW8nkKMls4DibJvF",
        "name": "Fernando Augusto Lorencini ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca Hospital da PUC - Campinas - Gustavo Calado",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2010-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "bqnFsDYiw6XBvhquhl0s",
        "name": "Fernando Augusto Marinho dos Santos Figueira ",
        "data": {
          "resident_institute": "INCOR/PE - Carlos R. Moraes",
          "resident_begin": "2006-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "opldCD9LX0CgEpbNC8lS",
        "name": "Fernando Bermudez Kubrusly ",
        "data": {
          "resident_institute": "Universidade do Texas -",
          "resident_begin": "2010-12-02T02:00:00.000Z",
          "resident_end": "2015-06-02T03:00:00.000Z"
        }
      },
      {
        "id": "Wx2fqbiUlXEP6m4xXA9U",
        "name": "Fernando César Gimenes Barbosa Santos ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Norte do Paraná - Dr. Francisco Gregori Jr",
          "resident_begin": "2009-12-18T02:00:00.000Z",
          "resident_end": "2014-12-21T02:00:00.000Z"
        }
      },
      {
        "id": "mZhB6qIRyDpmk0Q33eAF",
        "name": "Fernando César Laforga ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese se Cardiologia - CNRM/MEC - Paulo Paredes Paulista",
          "resident_begin": "1993-02-01T03:00:00.000Z",
          "resident_end": "1996-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "iZohUka3tjemmtInK4wi",
        "name": "Fernando Magalhães Coutinho ",
        "data": {
          "resident_institute": "Serv. CCV BPSP Equipe Dr. JANUÁRIO M. DE SOUZA CIRURGIA CARDIOVASCULAR LTDA",
          "resident_begin": "2015-02-01T02:00:00.000Z",
          "resident_end": "2019-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "1FOP7Zi0JdYEpDFFPM17",
        "name": "Fernando Patricio Aliaga Mora ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Coord. Dr. José Eduardo M. R. Sousa",
          "resident_begin": "1980-02-01T03:00:00.000Z",
          "resident_end": "1983-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "SklXG4G0mrWIFB7VJW0M",
        "name": "Fernando Pedro Pereira",
        "data": {
          "resident_institute": "Instituto Nacional de Cardiologia Laranjeiras (INC) CNRM/MEC - Dr. João Manoel de Almeida Pedroso",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "CscxREQE3Pd18o3oqnaG",
        "name": "Fernando Platania ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo",
          "resident_begin": "1995-02-01T02:00:00.000Z",
          "resident_end": "1998-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "qsz0Z5dmKPAsur5BbrpT",
        "name": "*Fernando Silvério",
        "data": {
          "resident_institute": "Serviço CCV Clínica Cirúrgica JP da Silva Ltda - Dr. José Pedro da Silva",
          "resident_begin": "2004-01-01T02:00:00.000Z",
          "resident_end": "2008-01-08T02:00:00.000Z"
        }
      },
      {
        "id": "yGYspS2c6IB1DcVbkOlz",
        "name": "Filinto Marques de Cerqueira Neto ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de SP - CNRM/MEC Dr. Márcio Rogério Batista Coord.",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "k65dMcKtptW5VfLwYqpH",
        "name": "Filipe Tomasi Keppen Sequeira de Almeida ",
        "data": {
          "resident_institute": "Hospital Santa Casa de Londrina - CNRM/MEC Dr. Arnaldo Okino",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-03-28T03:00:00.000Z"
        }
      },
      {
        "id": "84y87yS54zyXPIQBBhdz",
        "name": "Flávia Cristina Kufner ",
        "data": {
          "resident_institute": "Serv. Cir.Cardiovascular Hospital Nossa Senhora do Rocio - Dr. Leonardo A. Mulinari",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "6yFSMzwKt0mzFmceaAbH",
        "name": "Flávio de Almeida Rosa ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2003-12-01T02:00:00.000Z"
        }
      },
      {
        "id": "19VxaP6qanQSGRdxoPlU",
        "name": "Flávio Dias de Abreu ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - Preceptor Responsável: Dr. José Pedro da Silva",
          "resident_begin": "1995-01-10T02:00:00.000Z",
          "resident_end": "1999-12-11T02:00:00.000Z"
        }
      },
      {
        "id": "UOXkn9RSPwXtdGUG9CGe",
        "name": "Flávio Duarte Camurça ",
        "data": {
          "resident_institute": "Universidade São Paulo - CNRM Coordenador do Programa: Alfredo Inácio Fiorelli",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "y6PEGVJGpdE2y7nXxbPj",
        "name": "Flávio Guedes Teixeira de Alencar ",
        "data": {
          "resident_institute": "Sociedade Brasileira e Japonesa de Beneficência Santa Cruz - Serviço Dr. Kenji Nakiri",
          "resident_begin": "2008-01-31T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "XtN6hID8plHHppZmEEGP",
        "name": "Flávio Júnior Soares Godoi",
        "data": {
          "resident_institute": "Universidade Tocantinense Presidente Antonio Carlos (UNITPAC)",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2025-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "5zZCLsmlW5XJLQiyE5qx",
        "name": "Franciele Kuhn Mesacasa",
        "data": {
          "resident_institute": "Instituto de Cardiologia de Santa Catarina - CNRM/MEC - Dr Amandio Rampinelli",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "hOjm1xPd5AmcQ3R8AQiS",
        "name": "Francisco Cândido Monteiro Cajueiro",
        "data": {
          "resident_institute": "Universidade de Pernambuco - FCM CNRM/MEC - Prof. Dr. Ricardo de Carvalho Lima",
          "resident_begin": "2015-03-02T03:00:00.000Z",
          "resident_end": "2019-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "j2pAgW0foxPF8rkLkaFy",
        "name": "Francisco Coelho Lamachia ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Porto Alegre / Hospital São Francisco - Dr. Fernando Antônio Lucchese",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "yp1SqWvrOgncLhVqTRyx",
        "name": "Francisco Diniz Affonso da Costa",
        "data": {
          "resident_institute": "Hospital de Clínicas da Universidade Federal do Paraná - Iwan Augusto Collaço",
          "resident_begin": "1983-02-01T03:00:00.000Z",
          "resident_end": "1987-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "EpTBpjMogpZ2tXmHRyVt",
        "name": "Francisco Gregori Júnior ",
        "data": {
          "resident_institute": "Hospital das Clínicas - Faculdade de Medicina da USP - Sebastião A. P. Sampaio",
          "resident_begin": "1972-02-01T03:00:00.000Z",
          "resident_end": "1973-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "XlDJPiR9Vs2mz8n9wE20",
        "name": "Francisco Jorge Lima",
        "data": {
          "resident_institute": "Hospital de Messejana / CE - CNRM/MEC - Marco Aurélio Barroso Aguiar",
          "resident_begin": "1998-03-01T03:00:00.000Z",
          "resident_end": "2001-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ay4YKeucmrSR4LjUwXe6",
        "name": "Francisco José Saraiva Lino ",
        "data": {
          "resident_institute": "INAMPS - CNRM/MEC Hospital da Lago",
          "resident_begin": "1982-04-02T03:00:00.000Z",
          "resident_end": "1985-03-31T03:00:00.000Z"
        }
      },
      {
        "id": "hlnhpvxC4KmQX0HViRtu",
        "name": "Francisco Victor Alves da Silva ",
        "data": {
          "resident_institute": "Serv. CCV Instituto Dante Pazzanese de cardiologia CNRM/MEC - Dr. Mario Issa",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "KUtUXl8ZxjMh1gZhU5pI",
        "name": "Francisco Xavier do Rego Barros Neto ",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - Dr. Sergio A Oliveira",
          "resident_begin": "1994-01-02T02:00:00.000Z",
          "resident_end": "1997-12-12T02:00:00.000Z"
        }
      },
      {
        "id": "G7Wgq4Sj38kqsZ2OVRtk",
        "name": "Francismar Vidal de Arruda Júnior ",
        "data": {
          "resident_institute": "IMC - São José do Rio Preto - Roberto V. Ardito",
          "resident_begin": "1999-01-04T02:00:00.000Z",
          "resident_end": "2002-01-04T02:00:00.000Z"
        }
      },
      {
        "id": "Ro6dTflVW61MC5kXnP4I",
        "name": "Franz Andrei Patriarcha",
        "data": {
          "resident_institute": "Residência - Faculdade de Medicina de S. J. Rio Preto - SP - Hospital de Base de São José do Rio Preto - Coord. Dr. Marcelo José Ferreira Soares",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "G3Qcs6rajsU61yGtw06o",
        "name": "Frederico José di Giovanni ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Curitiba / CNRM/MEC - Dr. Pedro Emilio de Cerqueira Lima Neto",
          "resident_begin": "1986-01-15T02:00:00.000Z",
          "resident_end": "1989-01-15T02:00:00.000Z"
        }
      },
      {
        "id": "a5szCQeQADtDRp3ExX2c",
        "name": "Frederico Moreira Cardoso Ayres ",
        "data": {
          "resident_institute": "Serviço CCV Hospital Maternidade Therezinha de Jesus - Dr. Antonio Augusto Miana",
          "resident_begin": "2018-02-05T02:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "9yuJGMybLmXZQF1hmY1X",
        "name": "Gabriel Bianco Giuliani",
        "data": {
          "resident_institute": "Serv. CCV Hospital das Clínicas FMRPUSP CNRM/MEC - Chefe da Seção de Residência Dra Nilza Faccio",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "ZhxioBn2okhgo0enTURC",
        "name": "Gabriel Chahini Paixão ",
        "data": {
          "resident_institute": "Serv. CCV Hospital das Clínicas Gaspar Vianna - CNRM/MEC Coord. Dr. Arlindo Fiel da Costa Neto",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "3soRgnQAej9eiNeUrgOK",
        "name": "Gabriel Gustavo Longo ",
        "data": {
          "resident_institute": "Hospital Santa Isabel - Frederico José Di Giovani",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2005-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "7ugy49Q37JRlGMlm6dgg",
        "name": "Gabriel Lorente Mitsumoto ",
        "data": {
          "resident_institute": "Santa Casa de São Paulo",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "2cJG0M2p5D05HamFlLOw",
        "name": "Gabriel Salles Ottoboni ",
        "data": {
          "resident_institute": "Hospital das Graças - CNRM/MEC",
          "resident_begin": "2001-01-05T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "F3dEQJGjJdhFOvcBA1BP",
        "name": "Gabriela Carvalho Silva ",
        "data": {
          "resident_institute": "Serv. CCV Real Hospital Português de Beneficência em Pernambuco - CNRM/MEC Coord. Dra Daniella Souza",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "604SJZCwY8x68cByIeyl",
        "name": "Gabriela Duarte Costa Constantino ",
        "data": {
          "resident_institute": "Serviço CCV Equipe do Dr. Januário Manoel de Sousa - Hospital BPSP",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "TjKC1GPM1i1JugCymu9Z",
        "name": "Gabriela Miotto Schnorr",
        "data": {
          "resident_institute": "Serv CCV Hospital Santa Casa de Curitiba - Equipe Dr Paulo Brofmann",
          "resident_begin": "2013-01-16T02:00:00.000Z",
          "resident_end": "2017-01-15T02:00:00.000Z"
        }
      },
      {
        "id": "Phy2qxlObyNnq7n2tDhf",
        "name": "Gabriela Zamunaro Lopes Ruiz ",
        "data": {
          "resident_institute": "Serv. CCV Hospital das Clínicas da UFMG CNRM/MEC - Coord. Dra Marilene de Castro Vale Monteiro",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "qovvPvHxlsL0F2hOe2Su",
        "name": "Gabriella Mendes de Freitas",
        "data": {
          "resident_institute": "universidade nove de julho",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "iyF55kppqDYb3xGVEb73",
        "name": "Germano de Freitas Dan",
        "data": {
          "resident_institute": "Serv. CCV Instituto Dante Pazzanese de cardiologia CNRM/MEC - Dra. Magaly Arrais dos Santos",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "Xn5J7jelzf8kGP9CFb2o",
        "name": "Gerson Pereira de Oliveira ",
        "data": {
          "resident_institute": "Hospital de Clínicas de Porto Alegre",
          "resident_begin": "1996-01-02T02:00:00.000Z",
          "resident_end": "1999-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "XWtwHvTXp78zCiUO6rEW",
        "name": "Getúlio da Silva Lubanco Filho ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC - Dra. Magaly Arrais",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "RdK6oS1vHDDWV3PnXR28",
        "name": "Giancarlo Grossi Mota ",
        "data": {
          "resident_institute": "Hosp. Madre Teresa - Dr Raul Correa Rabelo",
          "resident_begin": "1992-01-02T02:00:00.000Z",
          "resident_end": "1995-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "NJv2CuCd6QEbkbH44Nej",
        "name": "Giani Osni Alves ",
        "data": {
          "resident_institute": "Serv. em CCV Hospital do Coração - Dr Luiz Carlos Bento de Souza",
          "resident_begin": "1989-02-01T03:00:00.000Z",
          "resident_end": "1992-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "laNNgMSyojIdCzlVSKkK",
        "name": "Gibran Roder Feguri ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "BSbfjWiHxN3KhihA8yJp",
        "name": "Gil César de Carvalho Paim ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Madre Teresa - Dr. Rodrigo Bernardes de Castro",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "fZynOkmGMBjSpyN6NcgE",
        "name": "Gil Vicente Lico e Cividanes ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca Hosp. BP/SP - Dr. Luiz Boro Puig",
          "resident_begin": "1988-03-01T03:00:00.000Z",
          "resident_end": "1991-04-28T03:00:00.000Z"
        }
      },
      {
        "id": "El2IFA70Pj9cuVPEFYE5",
        "name": "Gilberto Celestino da Silva Júnior ",
        "data": {
          "resident_institute": "Serviço - JANUÁRIO M. DE SOUZA CIRURGIA CARDIOVASCULAR LTDA",
          "resident_begin": "2013-02-18T03:00:00.000Z",
          "resident_end": "2017-02-18T02:00:00.000Z"
        }
      },
      {
        "id": "T9TxFfM4LEZMW6lA1Mw2",
        "name": "Gilberto Paulozzi Júnior",
        "data": {
          "resident_institute": "Serv. CCV BPSP Equipe do Dr Sérgio Almeida de Oliveira - Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "yP9v1YUaKffTWIhPxQui",
        "name": "Gilberto Venossi Barbosa ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade Federal do Rio Grande do Sul - Cid Nogueira",
          "resident_begin": "1966-01-03T02:00:00.000Z",
          "resident_end": "1969-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "5ThrSSFCdxIyqKFyvBHd",
        "name": "Giorgio Pieracciani ",
        "data": {
          "resident_institute": "USP",
          "resident_begin": "1973-02-15T03:00:00.000Z",
          "resident_end": "1974-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "LRese8GW8i0EYE6naEM5",
        "name": "Giovanna Campagnaro",
        "data": {
          "resident_institute": "hospital Beneficencia Portuguesa",
          "resident_begin": "2020-02-17T03:00:00.000Z",
          "resident_end": "2025-02-17T03:00:00.000Z"
        }
      },
      {
        "id": "3WPDFofY1yfPKMaMDQ4f",
        "name": "Gisela Guareschi",
        "data": {
          "resident_institute": "Instituto de Cardiologia do DF - Fernando Atik",
          "resident_begin": "2019-03-03T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "p3zC4cDj5xK2X310rUt1",
        "name": "Gisele Aparecida Lapenna ",
        "data": {
          "resident_institute": "Especialização em CCV no Hospital das Clínicas/Incor - Prof Fábio Jatene",
          "resident_begin": "2004-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "bWI6nTzDyValb4fhBANp",
        "name": "Glaucio Mauren da Silva Gerônimo ",
        "data": {
          "resident_institute": "BP SP - Clínica Stolf - BP SP - Clínica Stolf",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "cW0rByd30IXzTnp1qtUh",
        "name": "Gualberto Salomon Rojas Llanos",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - BPSP - Profº. Dr. Sergio A de Oliveira",
          "resident_begin": "1997-01-01T02:00:00.000Z",
          "resident_end": "2000-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "ftfMFddhDskLegRAScNK",
        "name": "Guaracy Fernandes Teixeira Filho ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do RS / Fundação Universitária de Cardiologia",
          "resident_begin": "1973-01-01T03:00:00.000Z",
          "resident_end": "1975-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "aFilzmijuiF08j9DrZBh",
        "name": "Guilherme Andrade Krawczun ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Norte do Paraná - Dr. Francisco Gregori Jr",
          "resident_begin": "2005-12-10T02:00:00.000Z",
          "resident_end": "2010-12-13T02:00:00.000Z"
        }
      },
      {
        "id": "B6wrOLAKKQuNy8HGNCRm",
        "name": "Guilherme Cunha de Toledo Ferrão",
        "data": {
          "resident_institute": "Serv. CCV Instituto Dante Pazzanese - Dr. Luiz Carlos B. de Souza",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "2IbxmkRXp2YSKjGfKSxp",
        "name": "Guilherme D' Addazio Marques ",
        "data": {
          "resident_institute": "Inst. D. Cardio Pulm. Zerbini - Preceptor atual: Eduardo Coelho Souza",
          "resident_begin": "2005-01-02T02:00:00.000Z",
          "resident_end": "2009-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "Sr2tOilpKFl38bA688F4",
        "name": "Guilherme Guimarães Medrado de Castro",
        "data": {
          "resident_institute": "Serviço CCV Biocor - Equipe do DR. Ektor Vrandecic - Coordenador da Especialização de Cirurgia Cardiovascular",
          "resident_begin": "2010-04-01T03:00:00.000Z",
          "resident_end": "2014-04-01T03:00:00.000Z"
        }
      },
      {
        "id": "26LNxDTtzu0YwMmq4OXU",
        "name": "Guilherme Mainardi Aguiar da Silva ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina - CNRM/MEC - Alfredo Fiorelli",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "23Otp5A99btiS8JRbsHh",
        "name": "Guilherme Parente Lira ",
        "data": {
          "resident_institute": "UNIFESP/EPM - Diego Gaia. Depart Cir Cardiovasc.",
          "resident_begin": "2011-12-01T02:00:00.000Z",
          "resident_end": "2015-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "CqJwRdfF0iuJekzSR6wu",
        "name": "Guilherme Souza Policarpo ",
        "data": {
          "resident_institute": "Hospital de Força Aérea do Galeão",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2027-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "uu9idTuTpj6K9eLtJcnS",
        "name": "Guilherme Terra Correa ",
        "data": {
          "resident_institute": "BP SP - Clínica Stolf - Noedir Stolf",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Iij7QIjWr6cx5ZoExV3A",
        "name": "Guilherme Veiga Francisco",
        "data": {
          "resident_institute": "Instituto de Neurologia e Cardiologia de Curitiba - Dr Francisco Diniz Affonso da Costa",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "V64V1Hjhqx4criX08D9u",
        "name": "Guilherme Viotto Rodrigues da Silva",
        "data": {
          "resident_institute": "Hospital das Clínicas da Faculdade de Medicina de Botucatu - SP Coord Marcos Augusto Moraes Silva",
          "resident_begin": "2011-01-03T02:00:00.000Z",
          "resident_end": "2015-02-02T02:00:00.000Z"
        }
      },
      {
        "id": "fjWoNJWAyqKQLqMnbVxf",
        "name": "Guilherme Visconde Brasil",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina CNRM/MEC - Prof Fábio Jatene",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "pLWcDSBiyQmbgfFqh9bX",
        "name": "Guilherme Winter ",
        "data": {
          "resident_institute": "Hospital Santa Casa de Curitiba - Equipe Dr. Francisco D. A. da Costa",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "p25TUvoL37PDRcRHFrAK",
        "name": "Gustavo Bento Rodrigues ",
        "data": {
          "resident_institute": "Clinica Cardio-Cirurgia J. p. da Silva - Dr José Pedro da Silva",
          "resident_begin": "2013-01-01T02:00:00.000Z",
          "resident_end": "2017-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "m8m2HlmDksaqZKLdjIWc",
        "name": "Gustavo Caggiano",
        "data": {
          "resident_institute": "Serv. CCV Hospital Nossa Senhora do Rocio CNRM/MEC - Coord. Dr. Gustavo Klug Pimentel",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "zooTDAmj9P81ioZPBNHV",
        "name": "Gustavo Fernandes Carneiro ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Magnus R. Coelho Souza",
          "resident_begin": "2004-01-02T02:00:00.000Z",
          "resident_end": "2008-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "Qv553hxW0cXkyi3UHHlD",
        "name": "Gustavo Henrique de Oliveira Teixeira ",
        "data": {
          "resident_institute": "Especialização em CCV no Hosp. Vera Cruz . Dr. Renato Rocha Rabello/Dr. Roney Ronald Peixoto",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "YSTjpav26KV1ydeC6v9p",
        "name": "Gustavo Ieno Judas ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC - Noedir Stolf",
          "resident_begin": "2004-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "yN3YdZoErJL7U75KjI6u",
        "name": "Gustavo José Ventura Couto ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular do Hospital de Clínicas da Universidade do Estado do Rio de Janeiro - Prof. Waldir Jazbik",
          "resident_begin": "1978-05-01T03:00:00.000Z",
          "resident_end": "1981-07-30T03:00:00.000Z"
        }
      },
      {
        "id": "YqqWIVwcZQJ51RJIafzX",
        "name": "Gustavo Kikuta ",
        "data": {
          "resident_institute": "UERJ - Hosp. Universitário Pedro Ernesto - Coord. Dr. João José A. Caramez",
          "resident_begin": "2014-03-01T03:00:00.000Z",
          "resident_end": "2018-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "QZjFuLMJXZlRdcYRyw2I",
        "name": "Gustavo Klug Pimentel ",
        "data": {
          "resident_institute": "Serv. CCV do Hospital NS das Graças - CNRM/MEC -",
          "resident_begin": "1999-05-01T03:00:00.000Z",
          "resident_end": "2005-01-05T02:00:00.000Z"
        }
      },
      {
        "id": "0MisdbAfltLgMfjEWC9a",
        "name": "Gustavo Pampolha Guerreiro",
        "data": {
          "resident_institute": "Serv. CCV Instituto do Coração - Incor CNRM/MEC - Dr Alfredo Fiorelli",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "JFwlbxovhBmsUfZiOiZV",
        "name": "Gustavo Ramalho e Silva ",
        "data": {
          "resident_institute": "beneficiencia portuguesa de são paulo",
          "resident_begin": "2003-01-01T02:00:00.000Z",
          "resident_end": "2006-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "lNVbfkvr6o51E4KQ4uCg",
        "name": "Gustavo Santiago Almeida ",
        "data": {
          "resident_institute": "Fundação Bahiana de Cardiologia - Prof Alvaro Rabelo Jr",
          "resident_begin": "2008-01-01T02:00:00.000Z",
          "resident_end": "2012-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "A5wwJKMdcI2ErrVVbiO9",
        "name": "Gustavo Tedeschi dos Santos ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Curitiba- Francisco Costa",
          "resident_begin": "2007-01-01T02:00:00.000Z",
          "resident_end": "2011-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "lbMo75Z5VYtncErePTp9",
        "name": "Halyna Stephane Machado de Melo Firmino ",
        "data": {
          "resident_institute": "Instituto do Coração de Pernambuco CNRM/MEC Dr Fernando Moraes",
          "resident_begin": "2014-03-07T03:00:00.000Z",
          "resident_end": "2018-09-02T03:00:00.000Z"
        }
      },
      {
        "id": "ZTXmnm0ahUM6C6nmiuJC",
        "name": "Haroldo Adans Ferraz ",
        "data": {
          "resident_institute": "Hospital Universitário Pedro Ernesto - CNRM/MEC - Coord. Maurílio Pereira de Carvalho Salek",
          "resident_begin": "1996-04-08T03:00:00.000Z",
          "resident_end": "1999-04-17T03:00:00.000Z"
        }
      },
      {
        "id": "68SklgZItOhzxBPRTJmF",
        "name": "Hassan Fahd El Malat ",
        "data": {
          "resident_institute": "Hospital do Coração - CNRM/MEC - Ieda Jatene",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "DeVBk9hxkocN4Qp0iA1E",
        "name": "Héber Souza Melo Silva ",
        "data": {
          "resident_institute": "Serv. CCV Santa Casa de Misericórdia de Ribeirão Preto - Coord. Dr. Francisco Fernandes Moreira Neto",
          "resident_begin": "2003-03-01T03:00:00.000Z",
          "resident_end": "2006-03-30T03:00:00.000Z"
        }
      },
      {
        "id": "tZLXMCEyTS7JLIOEvK81",
        "name": "Hector Bedoya Copello ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1987-02-01T02:00:00.000Z",
          "resident_end": "1990-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "lB4dneoxhoy1Dthzc615",
        "name": "Heidy Piccolotto Carvalho ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Magnus R. Coelho Souza",
          "resident_begin": "1982-01-02T03:00:00.000Z",
          "resident_end": "1985-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "ReplF0KW7kALHES2bBLA",
        "name": "Helcio Giffhorn ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba - Danton R. Rocha Loures",
          "resident_begin": "1990-02-01T02:00:00.000Z",
          "resident_end": "1992-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "3l3HNVaM31oHSz8bqEt6",
        "name": "Helder Christian Bassetti dos Santos ",
        "data": {
          "resident_institute": "Unidade de Doenças Toracicas Stolf - Dr. Noedir Stolf",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "0qCaf7Q9BtIQYZONgnFQ",
        "name": "Helen Lima Gomes",
        "data": {
          "resident_institute": "Instituto do Coração - Dr. Alfredo Fiorelli",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "tWO7LeZYh8GhUSE72wbe",
        "name": "Hélio Poço Ferreira ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC Coordenador: Vicente Avila Neto",
          "resident_begin": "1982-01-01T03:00:00.000Z",
          "resident_end": "1985-01-01T03:00:00.000Z"
        }
      },
      {
        "id": "Tt7lZYngIRb4k1gISR8e",
        "name": "Helmgton José Brito de Souza ",
        "data": {
          "resident_institute": "Especialização em CCV no Serviço do Hospital Santa Izabel - Laudelino Souza Filho",
          "resident_begin": "1997-10-01T03:00:00.000Z",
          "resident_end": "2001-11-30T02:00:00.000Z"
        }
      },
      {
        "id": "OHpron2uSu66HD3v0kre",
        "name": "Helmiton Vieira de Moura",
        "data": {
          "resident_institute": "UNITORAX / DR RICARDOLIMA / SERVICO DE CARDIOLOGIA - DR JOSE PEDRO DA SILVA",
          "resident_begin": "2010-01-01T02:00:00.000Z",
          "resident_end": "2014-03-30T03:00:00.000Z"
        }
      },
      {
        "id": "A7ft6pdcFNAODAE8lcEs",
        "name": "Henrique Barsanulfo Furtado ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Dr. Jose Eduardo M. R. Souza",
          "resident_begin": "1978-03-01T03:00:00.000Z",
          "resident_end": "1980-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "prQOqGrWycd8QINYLtUU",
        "name": "Henrique do Nascimento Borges ",
        "data": {
          "resident_institute": "Serv. CCV Beneficência Portuguesa de São Paulo - CNRM/MEC - Dr. Luiz Eduardo L. Bettarello",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "keFvoyoOACgEM8bxAcmx",
        "name": "Henrique Madureira da Rocha Coutinho ",
        "data": {
          "resident_institute": "UERJ - Hosp. Universitário Pedro Ernesto - Coord. Dr. João José A. Caramez",
          "resident_begin": "2015-03-02T03:00:00.000Z",
          "resident_end": "2019-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "SZvFOKaWwaen8fLT9uVj",
        "name": "Henry Eiji Toma",
        "data": {
          "resident_institute": "Serv. CCV Irmandade da Santa Casa de Misericórdia de São Paulo CNRM/MEC Coord. Dr. Diego Figueira Folcochio",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "7qi2vEYdO3teszgHsWwG",
        "name": "Heraldo Guedis Lobo Filho ",
        "data": {
          "resident_institute": "Instituto do Coração e Pulmão Fortaleza - CE - Dr. José Glauco Lobo Filho",
          "resident_begin": "2006-02-01T02:00:00.000Z",
          "resident_end": "2010-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "0Uk0MMluuRG0zl8bvVVB",
        "name": "Herbert Coelho Hortmann ",
        "data": {
          "resident_institute": "Hosp. Vera Cruz - Homero Geraldo de Oliveira",
          "resident_begin": "2003-02-01T02:00:00.000Z",
          "resident_end": "2007-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "RIt56cesgC71nQ4HHtL9",
        "name": "Herbet Rosa Pires Junior ",
        "data": {
          "resident_institute": "Escola Alvaro Alvim",
          "resident_begin": "2003-01-01T02:00:00.000Z",
          "resident_end": "2007-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "juQHId192qssIkMj2vrL",
        "name": "Hermes de Souza Felippe",
        "data": {
          "resident_institute": "Universidade de São Paulo - Faculdade de Medicina SP - Dr. Vicente Avila Neto",
          "resident_begin": "1986-03-01T02:00:00.000Z",
          "resident_end": "1987-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "gLyI83O7v2vSVLJkaY0H",
        "name": "Hernando José Martínez ",
        "data": {
          "resident_institute": "Item 2.6.8 do Edital 2024 - Comprovação de treinamento/capacitação em Cirurgia Cardiovascular por meio de atividades profissionais, consd 10 anos",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "rctLxwETQQOJvQGeJfkv",
        "name": "Hernani de Paiva Gadelha Jr. ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanesse - CNRM/MEC Cood. Dr Paulo Paredes Paulista",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "1RidaYqaeBeASEcmo4c3",
        "name": "Hugo de Moraes Sarmento Macruz",
        "data": {
          "resident_institute": "USP - Instituto do Coração -",
          "resident_begin": "1982-03-01T03:00:00.000Z",
          "resident_end": "1985-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ktLpAsCFkTgAliGalE2e",
        "name": "Hugo Meister Filho ",
        "data": {
          "resident_institute": "Hospital de Caridade da Santa Casa de Misericórdia de Curitiba",
          "resident_begin": "2008-01-01T02:00:00.000Z",
          "resident_end": "2012-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "zQNPuBOaGCLIhl5dVqal",
        "name": "Hugo Monteiro Neder Issa ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina - CNRM/MEC - Alfredo Fiorelli",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ewEhHxDWBt6dFP3E6FrW",
        "name": "Hurik Pontes Rocha",
        "data": {
          "resident_institute": "Universidade Federal do Ceará (UFC)",
          "resident_begin": "2023-03-01T03:00:00.000Z",
          "resident_end": "2028-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "JzlbWFZhFQuIHal0HR2G",
        "name": "Icaro Amorim Monteiro",
        "data": {
          "resident_institute": "Serv. CCV. Instituto do Coração do Hospital das Clínicas FMUSP CNRM/MEC - Diretor do Serv. Dr. Fábio Jatene",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "bDRQFAZiIRzILWOvOjAR",
        "name": "Igor Tiago Correia Silva ",
        "data": {
          "resident_institute": "Instituto do Coração (incor Pernambuco) CNRM/MEC - Fernando Ribeiro de Moraes Neto",
          "resident_begin": "2013-03-04T03:00:00.000Z",
          "resident_end": "2017-03-03T03:00:00.000Z"
        }
      },
      {
        "id": "zdpDTSt6bncUjpygIUOJ",
        "name": "Ingrid Santos de Morais da Silva",
        "data": {
          "resident_institute": "Universidade Nove de Julho",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2027-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "P8RK02uSRZolnYhBpteo",
        "name": "Isaac Azevedo Silva ",
        "data": {
          "resident_institute": "InCor",
          "resident_begin": "2005-01-01T02:00:00.000Z",
          "resident_end": "2009-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "fV6BGUREZqe2oS3JjKAc",
        "name": "Isaac Newton Guimarães Andrade ",
        "data": {
          "resident_institute": "Instituto do Coração de Pernambuco - CNRM/MEC - Dr. Euclides Martins Tenório",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "0zGCEwCzqh6cJmw1j40z",
        "name": "Isabella Knablen de Souza",
        "data": {
          "resident_institute": "Nove de Julho",
          "resident_begin": "2022-01-01T03:00:00.000Z",
          "resident_end": "2027-01-01T03:00:00.000Z"
        }
      },
      {
        "id": "NvhLFtaQwKWdFoMbnZ8o",
        "name": "Isadora Silveira Rossetto",
        "data": {
          "resident_institute": "Faculdade de Medicina Botucatu - Unesp - Dr. Marcello Laneza Felicio",
          "resident_begin": "2023-03-01T03:00:00.000Z",
          "resident_end": "2028-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "TemKQdwBlfTktjyAW9Ua",
        "name": "Iuri Schwaab ",
        "data": {
          "resident_institute": "Instituto de cardiologia (icfuc)",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "qMuplAa3z9zpq7WEArbB",
        "name": "Ivana Oliveira de Lamônica Freire ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC Coordenador: Marcio Rogério Batista",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "wWx0IJYbKUQ5qPBqvaQp",
        "name": "Ives Maciel Duarte ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "2005-01-02T02:00:00.000Z",
          "resident_end": "2009-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "BvRSfinA6QkKR3NBFXBf",
        "name": "Ivo Richter ",
        "data": {
          "resident_institute": "Serv. CCV Instituto Dante Pazzanese de cardiologia CNRM/MEC - Coord. Horácio Arakaki",
          "resident_begin": "1980-02-01T03:00:00.000Z",
          "resident_end": "1983-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "rtBKMRCBCiVoCqXKbRm4",
        "name": "Jackson Brandão Lopes ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC - Luiz Alberto Bacheschi",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Dkr4qbcJvkOT5iq1YR60",
        "name": "Jader Bueno Amorim ",
        "data": {
          "resident_institute": "Hosp. Madre Teresa - Dr. Rodrigo Bernardes",
          "resident_begin": "2002-07-20T03:00:00.000Z",
          "resident_end": "2006-07-21T03:00:00.000Z"
        }
      },
      {
        "id": "0VZmL6icDHe1ypCgr3AC",
        "name": "Jaime da Mota Correa Júnior ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Porto Alegre - CNRM/MEC- Dr. Luis Fernando Venegas",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2004-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "G29DJeSSbf6G4aOboxrC",
        "name": "Jairo Leal Soares Júnior ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Curitiba",
          "resident_begin": "2005-01-01T02:00:00.000Z",
          "resident_end": "2009-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "FImktZFTI5RNR3Sw6kXp",
        "name": "Janayna Thaina Rabelato ",
        "data": {
          "resident_institute": "Serv. CCV Inst. Card. Dante Pazzanese CNRM/MEC Dr. Mário Issa",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "T8CrbJ7U5lyl0Qe98lbc",
        "name": "Jandir Ferreira Gomes Júnior",
        "data": {
          "resident_institute": "Serv. Cir.Cardiovascular NHU-UFMS - José Carlos Dorsa Pontes",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "396eJ7aniX2IJAzCJfGa",
        "name": "Jaqueline Maria de Oliveira lima ",
        "data": {
          "resident_institute": "Serv. CCV Hospital Santa Casa de Londrina - Dr. Arnaldo Okino (Treinamento/capacitação item 2.6.7 do Edital 2021)",
          "resident_begin": "2011-03-01T03:00:00.000Z",
          "resident_end": "2021-04-06T03:00:00.000Z"
        }
      },
      {
        "id": "tTBqk5Cr1MrfBF0Pl5ZR",
        "name": "Jarbas Ferrari Júnior ",
        "data": {
          "resident_institute": "IMC/SJ Rio Preto/SP - Roberto V. Ardito",
          "resident_begin": "1983-01-01T03:00:00.000Z",
          "resident_end": "1985-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "fVNXav4rEz5KTGiUocDg",
        "name": "Jarbas Jakson Dinkhuysen ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Paulo Paredes Paulista",
          "resident_begin": "1971-01-01T03:00:00.000Z",
          "resident_end": "1972-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "EuFTUJbbImJ15aBol5OW",
        "name": "Jean Marc Vinagre Prado de Oliveira ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia de Campinas do Hospital Celso Pierro - Dr. Gustavo Calado Aguiar Ribeiro",
          "resident_begin": "2012-02-01T02:00:00.000Z",
          "resident_end": "2016-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "cKU7SsxJGFLFKE9asOk4",
        "name": "Jean Pierre Aquino de Almeida ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca Hosp. BP/SP - Dr. Luiz Boro Puig",
          "resident_begin": "2000-12-01T02:00:00.000Z",
          "resident_end": "2002-01-20T02:00:00.000Z"
        }
      },
      {
        "id": "7hg60fnBP55gkbZykTTJ",
        "name": "Jean Pierre Nogueira ",
        "data": {
          "resident_institute": "Atua no Hospital Estadual de Bauru a mais de 8 anos",
          "resident_begin": "2004-02-04T02:00:00.000Z",
          "resident_end": "2018-12-14T02:00:00.000Z"
        }
      },
      {
        "id": "Ie8k0LlO3jL8S0vQ08fb",
        "name": "Jeferson Roberto Sesca ",
        "data": {
          "resident_institute": "Hospital Cruz Vermelha Brasileira - Filial do Estado do Paraná - Dr. Jeronimo Fortunato Jr",
          "resident_begin": "2010-09-01T03:00:00.000Z",
          "resident_end": "2014-09-01T03:00:00.000Z"
        }
      },
      {
        "id": "7DQlmrUktMDB7A2msJO4",
        "name": "Jefferson Cavalcanti Chaves ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1979-01-02T03:00:00.000Z",
          "resident_end": "1981-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "W6R1sp2nVC2bu0aKoSMN",
        "name": "Jefferson Duarte Flávio Magalhães ",
        "data": {
          "resident_institute": "Clínica Cardio Cirúrgica J. P. da Silva Ltda - Dr. José Pedro da Silva",
          "resident_begin": "1991-01-01T02:00:00.000Z",
          "resident_end": "1994-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "2e80dquV3SvmR85BTDD1",
        "name": "Jenny Lourdes Rivas de Oliveira ",
        "data": {
          "resident_institute": "Inst. Card. Dante Pazzanese - Magaly Arraes",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "mdBBUKBUdSbJzI54YW0F",
        "name": "Jerônimo Antonio Fortunato Júnior",
        "data": {
          "resident_institute": "Universidade Federal do Paraná - CNRM/MEC",
          "resident_begin": "1990-02-01T02:00:00.000Z",
          "resident_end": "1993-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "uc7ygrqrXZ8jOy6l9cZQ",
        "name": "Jéssica Cordeiro de Siqueira Campos ",
        "data": {
          "resident_institute": "CENTRO CIRÚRGICO DO PRONTO SOCORRO CARDIOLOGICO DE PERNAMBUCO -",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-31T03:00:00.000Z"
        }
      },
      {
        "id": "59vJkvm8kGnxIBfUhodR",
        "name": "Jesualdo Guedes Pereira Filho ",
        "data": {
          "resident_institute": "Serviço CCV Sociedade de Beneficência Hospital Matarazzo",
          "resident_begin": "1975-02-01T03:00:00.000Z",
          "resident_end": "1977-02-01T03:00:00.000Z"
        }
      },
      {
        "id": "1xdxQBBzvVGwp77X6HKl",
        "name": "Jesus Antonio Gutierrez Saurith ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia",
          "resident_begin": "2018-05-01T03:00:00.000Z",
          "resident_end": "2023-02-01T03:00:00.000Z"
        }
      },
      {
        "id": "9dmj6WEbsLdkIQRp1yIX",
        "name": "Jhyeniffer Sakemya",
        "data": {
          "resident_institute": "UAM",
          "resident_begin": "2019-01-01T02:00:00.000Z",
          "resident_end": "2025-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "EwIXyS1YUYI8dEiuUdyV",
        "name": "João Antonio Caparroz Vieira ",
        "data": {
          "resident_institute": "Beneficência Portuguesa Serviço: Prof. Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Hj1NU91LqLlm59V09jpj",
        "name": "João Bosco Ferreira Gadelha",
        "data": {
          "resident_institute": "Biocor - Bayard Gontijo Fº",
          "resident_begin": "1997-01-01T02:00:00.000Z",
          "resident_end": "1999-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "xk3y7wSVAg9AaOvoRqtm",
        "name": "João Bosco Pellattiero de Oliveira",
        "data": {
          "resident_institute": "Serviço CCV Instituto Dante Pazzanese - Dr. Adib Jatene",
          "resident_begin": "1974-02-01T03:00:00.000Z",
          "resident_end": "1977-02-01T03:00:00.000Z"
        }
      },
      {
        "id": "487mQwdaZGJfbJ8NbJ9n",
        "name": "João Carlos Ferreira Leal ",
        "data": {
          "resident_institute": "Hosp. Infante D. Henrique (Hosp. Benef. Portuguesa) - Domingo M. Braile",
          "resident_begin": "1990-02-01T02:00:00.000Z",
          "resident_end": "1993-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "K94xCUDyv3acXvNQtUKa",
        "name": "João Carlos Otoni Andrade ",
        "data": {
          "resident_institute": "Serv. CCV Hospital Vera Cruz - Coord. Dr. Renato Rocha Rabello",
          "resident_begin": "2017-01-03T02:00:00.000Z",
          "resident_end": "2021-01-03T03:00:00.000Z"
        }
      },
      {
        "id": "hYOHleCjJze0G2JTCeWM",
        "name": "João da Fonseca Júnior",
        "data": {
          "resident_institute": "Especialização em CCV na Irmandade da Santa Casa de Misericórdia de Santos - Dr. Cesar A. Confotti",
          "resident_begin": "1992-02-01T02:00:00.000Z",
          "resident_end": "1996-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "eXkDRDibvUOWmRzEw461",
        "name": "João Filipe Machado Miranda De La Casa",
        "data": {
          "resident_institute": "Universidade Nove de Julho (UNINOVE) - Osasco",
          "resident_begin": "2022-01-01T03:00:00.000Z",
          "resident_end": "2027-01-01T03:00:00.000Z"
        }
      },
      {
        "id": "8iznqKkO9IG2gi0KoIdC",
        "name": "João Galantier ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC - Dr. Adib Jatene",
          "resident_begin": "1995-02-01T02:00:00.000Z",
          "resident_end": "1997-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "OvoaLFHgwaxp1cR0deZQ",
        "name": "João Jackson Duarte ",
        "data": {
          "resident_institute": "Hospital Universitário da Universidade Federal do Mato Grosso Sul - Dr. José Carlos Dorsa",
          "resident_begin": "1997-01-01T02:00:00.000Z",
          "resident_end": "2000-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "CQ6SwYGpXn98HFZ0epLS",
        "name": "João Luiz Itagiba Fonseca ",
        "data": {
          "resident_institute": "Instituto de Cirurgia do Coração de Londrina/PR - Dr. Kengo Baba",
          "resident_begin": "2016-01-15T02:00:00.000Z",
          "resident_end": "2020-01-15T03:00:00.000Z"
        }
      },
      {
        "id": "UtvN2wCNEVCIr4ZpNDw8",
        "name": "João Madeira Neto",
        "data": {
          "resident_institute": "especialização em CCV no Hosp. Universitário Cajuru - Paulo Roberto S. Brofman",
          "resident_begin": "1998-01-10T02:00:00.000Z",
          "resident_end": "1994-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "04h2scYEUKTReNq7iogR",
        "name": "João Marcelo Ancilon Cavalcante Albuquerque ",
        "data": {
          "resident_institute": "Universidade São Paulo - CNRM Coordenador do Programa: Sérgio Almeida Oliveira",
          "resident_begin": "2002-02-01T02:00:00.000Z",
          "resident_end": "2005-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "UZ4gF3qx00SMADbN1fSH",
        "name": "João Nelson Rodrigues Branco ",
        "data": {
          "resident_institute": "Escola Paulista de Medicina / CNRM/MEC - Coord. Ulisses Fagundes Reto",
          "resident_begin": "1978-01-02T03:00:00.000Z",
          "resident_end": "1980-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "KknoPWiFLlfc8TkiwjI2",
        "name": "João Paulo Segundo de Paiva Oliveira ",
        "data": {
          "resident_institute": "Residência em CCV no Instituto de Medicina Integral Prof. Fernando Figueira - IMIP CNRM",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "5GLTy62au1mw9ji3cKIl",
        "name": "João Pedro Araújo Bruno ",
        "data": {
          "resident_institute": "Universidade Severino Sombra USS",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2025-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "ageruc1pzVnXgL0BOYtZ",
        "name": "João Ricardo Michielin Sant'anna ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul - Ivo Abrahão Nesralla",
          "resident_begin": "1975-01-01T03:00:00.000Z",
          "resident_end": "1977-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "JOAqOQxuAhdVCoPL3bj3",
        "name": "João Sérgio Aschauer Cristo ",
        "data": {
          "resident_institute": "Serviço de Clínica e Cirurgia Cardiovascular Prof Dr. Adib Domingo Jatene - Beneficência Portuguesa",
          "resident_begin": "1989-02-01T03:00:00.000Z",
          "resident_end": "1992-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "1kKY77XWqvI2E7TiJwMT",
        "name": "João Victor Tavares Mendonça Garretto ",
        "data": {
          "resident_institute": "Biocor Instituto",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2024-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "V4lNxRE1ahs8lFozTLUZ",
        "name": "João Victor Ventura de Oliveira ",
        "data": {
          "resident_institute": "Serv. CCV Irmandade da Santa Casa de Misericórdia de Santos CNRM/MEC Coord. Dr. Paulo Henrique Caruso",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "HOKll3AsTq8d8FbKTt8B",
        "name": "Joaquim Aprigio Nóbrega Batista ",
        "data": {
          "resident_institute": "USP - Instituto do Coração CNRM/MEC - Dr. Alfredo Inácio Fiorelli",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "3PGBHb0C3UO8TXp9gDM2",
        "name": "Jocerlano Santos de Sousa ",
        "data": {
          "resident_institute": "InCor-FMUSP CNRM/MEC - Dr Alfredo Fiorelli",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "EvVFh8OLLMfofSFQ21aa",
        "name": "John Allexander de Oliveira Freitas ",
        "data": {
          "resident_institute": "Serv CCV BPSP Equipe Dr Sérgio de Almeida Oliveira",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "EZvDBOpsZ950SbLpvo7v",
        "name": "Jorge Alberto Morales Gutierrez",
        "data": {
          "resident_institute": "Serviço CCV Equipe do Dr. Antoninho Arnoni - Instituto Dante Pazzanese de Cardiologia",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "T6JJA80BmmkTvBelaRbk",
        "name": "Jorge Jerry Bustamante Bustamante ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Paulo Paredes Paulista",
          "resident_begin": "2000-02-01T02:00:00.000Z",
          "resident_end": "2003-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "JCmUl2kox1onHCyHvdw7",
        "name": "Jorge Luís da Silva ",
        "data": {
          "resident_institute": "Serv. CCV do Hospital Celso Pierro - PUC. Coord. Dr. Gustavo Calado de Aguiar Ribeiro",
          "resident_begin": "2014-03-01T03:00:00.000Z",
          "resident_end": "2018-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "nRpWSVawqNbARIrQZxBY",
        "name": "Jorge Luiz Ribeiro da Luz ",
        "data": {
          "resident_institute": "Faculdade de Medicina do ABC - CNRM/MEC Dr. Andréa Cristina Oliveira Freitas",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "Y90o4YcoL3yo2DzNQf0g",
        "name": "Josalmir José Melo do Amaral ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1979-01-20T03:00:00.000Z",
          "resident_end": "1981-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "RMcoizDXtjSyoyobtbUD",
        "name": "José Airton Barão Ceratti ",
        "data": {
          "resident_institute": "InCor-Fundação Universitária de Cardiologia - CNRM/MEC - Dr Ivo A. Nesralla",
          "resident_begin": "1975-01-01T03:00:00.000Z",
          "resident_end": "1976-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "IlRWq11fbN0LUA1fi0In",
        "name": "José Augusto Baucia ",
        "data": {
          "resident_institute": "Hosp. Infante D. Henrique (Hosp. Benef. Portuguesa) João Carlos F. Leal",
          "resident_begin": "1978-01-02T03:00:00.000Z",
          "resident_end": "1979-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "Sc8INEzLO3HQm3PdgCvH",
        "name": "José Augusto Duncan Santiago ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC Coordenador: Alfredo Inácio Fiorelli",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "KADLhWa8QcBdfcnWStm7",
        "name": "José Augusto Ferreira ",
        "data": {
          "resident_institute": "Hospital e Maternidade Santa Rica S/A - Raul Corrêa Rabelo",
          "resident_begin": "1983-02-01T03:00:00.000Z",
          "resident_end": "1985-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "2yy7G6goxDl7ZHgm7Z7R",
        "name": "José Carlos Arteaga Camacho ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Magnus R. Coelho Souza",
          "resident_begin": "2000-01-02T02:00:00.000Z",
          "resident_end": "2000-03-30T03:00:00.000Z"
        }
      },
      {
        "id": "hMXmx67yD0R7SrTKvxoy",
        "name": "José Carlos Rossini Iglezias ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo - Mario Ramos de Oliveira",
          "resident_begin": "1979-03-01T03:00:00.000Z",
          "resident_end": "1981-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "sGnvLi9QXUPMwIPurSib",
        "name": "José Carone Filho ",
        "data": {
          "resident_institute": "Hospital Evangélico de Vila Velha - ES",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "UKjwwwgrmHifFYPy4yCg",
        "name": "José Carone Júnior",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - Dr. Sergio A Oliveira",
          "resident_begin": "1988-01-02T02:00:00.000Z",
          "resident_end": "1989-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "ojVPBcxW6WCnYtTHpsXE",
        "name": "José Cícero Stocco Guilhen ",
        "data": {
          "resident_institute": "UNIFESP/EPM - CNRM/MEC - Enio Buffolo",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "tzJCMWiuMCTkL2QuBrP8",
        "name": "José da Silva Leitão Neto ",
        "data": {
          "resident_institute": "Especialização em CCV Hospital Santa Casa de Misericórdia de Maceió - Dr. José Wanderley Neto",
          "resident_begin": "2014-02-03T02:00:00.000Z",
          "resident_end": "2018-02-03T02:00:00.000Z"
        }
      },
      {
        "id": "XiW8Y94tEbQ5Bp7ZPtvD",
        "name": "José Dario Frota Filho ",
        "data": {
          "resident_institute": "Sta Casa P. Alegre -Hosp. S. Francisco - Fernando Antonio Lucchese",
          "resident_begin": "1990-01-02T02:00:00.000Z",
          "resident_end": "1992-12-30T02:00:00.000Z"
        }
      },
      {
        "id": "RFAxBFnAJYgmXy5CsvYg",
        "name": "José Darwin Rivera Rodriguez ",
        "data": {
          "resident_institute": "HOSPITAL VERA CRUZ",
          "resident_begin": "2002-02-01T02:00:00.000Z",
          "resident_end": "2005-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "O4hUZzabxKMdNyeFinhe",
        "name": "José Emanuel Echeverria Cuevas ",
        "data": {
          "resident_institute": "Serviço CCV Irmandade Santa Casa Misericórdia de Santos- CNRM/MEC - Coord. Dr. Paulo Henrique Caruso",
          "resident_begin": "2023-03-01T03:00:00.000Z",
          "resident_end": "2028-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "kJHdsSp2a02kOkV5aJFh",
        "name": "José Francisco Baumgratz ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1980-01-02T03:00:00.000Z",
          "resident_end": "1981-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "9z8Vr7sBOwFl9XHRyX7W",
        "name": "José Ivo Figueiredo de Souza ",
        "data": {
          "resident_institute": "USP - Instituto do Coração CNRM/MEC - Alfredo Inácio Fiorelli",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "lXt9fXUeNk3UTwg0g3hM",
        "name": "José Kleberth Tenório Filho ",
        "data": {
          "resident_institute": "Especialização em CCV no Hospital Santa Casa de Misericórdia de Maceió - Dr. José Wanderley Neto",
          "resident_begin": "2013-01-31T02:00:00.000Z",
          "resident_end": "2017-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "1UndH3VoztwJ4x1gJjxY",
        "name": "José Manoel Medeiros Junior",
        "data": {
          "resident_institute": "Ser. CCV Hospital Santa Isabel CNRM/MEC - Coord. Dr. Roger Pirath Rodrigues",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "mWDp9cm6qybJnwRrh4Fr",
        "name": "José Oscar Reis Brito ",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - Dr. Sergio A Oliveira",
          "resident_begin": "1986-01-02T02:00:00.000Z",
          "resident_end": "1990-07-30T03:00:00.000Z"
        }
      },
      {
        "id": "RMgYjWDJG31XBgtBOMP2",
        "name": "José Pedro da Silva ",
        "data": {
          "resident_institute": "Hospital do Servidor Público do Estado de São Paulo - Dr Francisco Morado de Oliveira",
          "resident_begin": "1977-02-01T03:00:00.000Z",
          "resident_end": "1978-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "nNSNDHhYxn9sgFvObRiH",
        "name": "José Pedro Esteves Dias ",
        "data": {
          "resident_institute": "Inst. D. Cardio Pulm. Zerbini - Preceptor atual: Eduardo Coelho Souza",
          "resident_begin": "1988-01-15T02:00:00.000Z",
          "resident_end": "1990-12-16T02:00:00.000Z"
        }
      },
      {
        "id": "la75wT9Th9iFvmmjrRMP",
        "name": "José Reinaldo de Moura Coelho ",
        "data": {
          "resident_institute": "Santa Casa de Maceió - Dr. J. Wanderley Neto",
          "resident_begin": "1981-01-02T03:00:00.000Z",
          "resident_end": "1984-02-20T03:00:00.000Z"
        }
      },
      {
        "id": "mCVhLTwkYpTeM5WS383I",
        "name": "José Roberto Coutinho Nogueira ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E. L. Zerbini",
          "resident_begin": "1978-01-02T03:00:00.000Z",
          "resident_end": "1979-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "lraNaZ36fd5djaNCihks",
        "name": "José Rogério Silva de Holanda ",
        "data": {
          "resident_institute": "Instituto Biocor Doenças cardiovasculares - Dr. Fernando Antônio Fantini",
          "resident_begin": "1999-01-01T02:00:00.000Z",
          "resident_end": "2002-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "RuH8Y0ywVUq3pRpcsLmY",
        "name": "José Ronaldo Junqueira Dias ",
        "data": {
          "resident_institute": "Especialização em CCV Hospital Adventista Silvestre - - DR. José Albino M. de Souza",
          "resident_begin": "1979-01-01T03:00:00.000Z",
          "resident_end": "1981-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "9htODv572g6sZFVUAMyS",
        "name": "José Viera Zárate",
        "data": {
          "resident_institute": "Serv. CCV Inst. Card. Dante Pazzanese - Dr. Horário Arakaki",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "1999-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "X3m6lL9bByHNfXysQcwH",
        "name": "Joseval da Silva Lacerda ",
        "data": {
          "resident_institute": "HBSP- Serviço de Clínica e Cirurgia Cardiovascular - Paulo Paredes Paulista",
          "resident_begin": "1983-02-01T03:00:00.000Z",
          "resident_end": "1989-06-30T03:00:00.000Z"
        }
      },
      {
        "id": "YgWA0T0kqIr214Qn4LRo",
        "name": "Josué Viana de Castro Neto ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Carlos Gun",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "NjXH6yqx5p0aW6Tcg62D",
        "name": "Joyce Cardoso Abecassis ",
        "data": {
          "resident_institute": "Hospital de Força Aérea do Galeão / CNRM. Coordenador: Dr. Marcelo Sávio da Silva Martins",
          "resident_begin": "2008-01-02T02:00:00.000Z",
          "resident_end": "2012-01-04T02:00:00.000Z"
        }
      },
      {
        "id": "P9UyXjLgwAEpBdjEf1cg",
        "name": "Juan Carlos Ozan",
        "data": {
          "resident_institute": "Serv. CCV Instituto Dante Pazzanese de Cardiologia - Programa Estrangeiro - Dra. Magaly Arrais",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "qsXRu9LcIyVtZe1wdckz",
        "name": "Juan Fernando Terrones Cáceres ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Antoninho Sanfins Arnoni",
          "resident_begin": "1991-02-01T02:00:00.000Z",
          "resident_end": "1994-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "pEaGaUzdznqNjGWwWjr6",
        "name": "Juarez Rode ",
        "data": {
          "resident_institute": "Hospital Nossa Senhora da Conceição RS",
          "resident_begin": "1994-01-01T02:00:00.000Z",
          "resident_end": "1996-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "3cVLHxI1NnB40Lckwf89",
        "name": "Juliana Pereira Mendanha Camilo",
        "data": {
          "resident_institute": "Serv. CCV. Instituto do Coração do Hospital das Clínicas FMUSP CNRM/MEC - Dr. Equipe Dr. Alfredo Fiorelli",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "Rw9LwU7RG8X6Rt9IEru0",
        "name": "Juliano Cavalcante de Sá ",
        "data": {
          "resident_institute": "Hospital Beneficência Portuguesa de São Paulo - Responsável, Dr. Noedir Stolf",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "yLHqu6enmRyVO8fYaA8J",
        "name": "Julie Matos Boeloni ",
        "data": {
          "resident_institute": "Universidade Federal da Bahia (UFBA)",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "1TBRbaAa2F3WsSamvKvW",
        "name": "Júlio Faria Honório ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - José Pedro da Silva",
          "resident_begin": "1999-01-01T02:00:00.000Z",
          "resident_end": "2002-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "t6u6y39k5XtGmS4hEN7w",
        "name": "Juscelino Teixeira Barbosa ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Belo Horizonte João Alfredo de Paula e Silva",
          "resident_begin": "1973-01-03T03:00:00.000Z",
          "resident_end": "1975-01-23T03:00:00.000Z"
        }
      },
      {
        "id": "VCat3CFCvjiIQtwdmKou",
        "name": "Kalil Hussein Khalil ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina - CNRM/MEC - Alfredo Fiorelli",
          "resident_begin": "2013-04-04T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "IN5pnKHGuCewCoeIonGz",
        "name": "Kanim Kalil Kassab ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - José Pedro da Silva",
          "resident_begin": "1991-01-01T02:00:00.000Z",
          "resident_end": "1994-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "mG2QRigoVRKC0QCk8uGf",
        "name": "Karlos Jennysson Sousa Soares",
        "data": {
          "resident_institute": "Serv. CCV Instituto Dante Pazzanese de Cardiologia - CNRM/MEC - Dr. Mario Issa",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "MmpxwSPvWkDxVCnHwbNE",
        "name": "Kassio Akio Tanaka",
        "data": {
          "resident_institute": "Serv. em CCV Hospital Madre Teresa - Dr Rodrigo Bernardes de Castro",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "760V7ejHSrsuN9IF8Tol",
        "name": "Kathize Betti Lira",
        "data": {
          "resident_institute": "Serv. CCV do Hospital Nossa Senhora da Conceição - GHC CNRM/MEC - Dra Adriana Silveira de Almeida",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "n8I1UxVM8BdLz3GaCaaz",
        "name": "Katsuro Harada Júnior",
        "data": {
          "resident_institute": "Serv. em CCV Hospital do Coração - Luiz Carlos Bento de Souza",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "qAIn9HQfny5wfFidXsx6",
        "name": "Kelter Jamel Sgobi ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Santa Casa de Misericórdia Rib. Preto - Dr. Eduardo Cosac Paranhos",
          "resident_begin": "2008-02-02T02:00:00.000Z",
          "resident_end": "2012-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "pXPepXyvrWzfXzGqUCWA",
        "name": "Kengo Baba ",
        "data": {
          "resident_institute": "Hospital Evangélico de Londrina - Dr. Francisco Gregori",
          "resident_begin": "1981-11-20T03:00:00.000Z",
          "resident_end": "1984-11-20T03:00:00.000Z"
        }
      },
      {
        "id": "2PY5VPSqRzRw42on2wSq",
        "name": "Kleber Hirose ",
        "data": {
          "resident_institute": "Fundação do ABC - CNRM/MEC Dr. João Antônio Corrêa",
          "resident_begin": "2003-02-01T02:00:00.000Z",
          "resident_end": "2007-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "XZfKhHG4j9CmQgiDJido",
        "name": "Kyonis Rodrigues Florentino",
        "data": {
          "resident_institute": "Serv. CCV Hospital Santa Casa de Misericórdia de Santos - Dr. Jefferson dos Santos",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2027-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "jGFBsUOzLJuz8ASB1Ue5",
        "name": "Laertes Sidney Bianchessi Jr. ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Curitiba - Dr. Francisco Costa",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "KtjxvX4UB2m9N80WUAVa",
        "name": "Lafaiete Alves Jr. ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca Hosp. do Coração. Responsável: Magaly Arraes",
          "resident_begin": "1994-01-02T02:00:00.000Z",
          "resident_end": "1997-02-02T02:00:00.000Z"
        }
      },
      {
        "id": "0HKGwQwroXpkyJLzp9Sh",
        "name": "Laio Caju Wanderley",
        "data": {
          "resident_institute": "CCV Hospital Santa Casa de Misericórdia de Maceió - AL - Dr. José Wanderley Neto",
          "resident_begin": "2015-02-02T02:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "bKKtiT5gDG614GVRmJO4",
        "name": "Landerson Furtado Fonseca ",
        "data": {
          "resident_institute": "Hospital Vera Cruz-MG - Homero Geraldo de Oliveira",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "bKKtiT5gDG614GVRmJO4",
        "name": "Landerson Furtado Fonseca ",
        "data": {
          "resident_institute": "Hospital Vera Cruz-MG - Homero Geraldo de Oliveira : ",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "lczYjnMB5tvH7cCeQZjv",
        "name": "Lara Alessandra Andrade Monção ",
        "data": {
          "resident_institute": "Universidade Nove de Julho (UNINOVE)",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "tHNJjPA2ZF5BMHdfz5dx",
        "name": "Laura Amaral Barboza ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular No Hospital de Caridade da Irmandade da Santa Casa de Misericórdia",
          "resident_begin": "2003-02-02T02:00:00.000Z",
          "resident_end": "2007-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "YHqRH8vRfDzc9SzIlNLr",
        "name": "Leandra Duarte Bastos ",
        "data": {
          "resident_institute": "Universidade Severino Sombra",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "1gSL5Yja1vonfzXm856n",
        "name": "Leandro Batisti de Faria ",
        "data": {
          "resident_institute": "Instituto do Coração (Incor) HC/FMUSP CNRM/MEC Dr Alfredo Fiorelli",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "kcahmkO6iuMZkXYJryIJ",
        "name": "Leandro de Moura ",
        "data": {
          "resident_institute": "Hospital de Clinicas de Porto Alegre - CNRM/MEC - Dr Alceu Migliavacca",
          "resident_begin": "2002-01-02T02:00:00.000Z",
          "resident_end": "2005-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "a5RnslKQQfYHPp2prB06",
        "name": "Leiza Loiane Hollas",
        "data": {
          "resident_institute": "Serv. CCV Hosp. Cruz Vermelha Brasileira - PR Dr. Jerônimo A. Fortunato",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "AEL5ffQIBrujRn3Oy8e6",
        "name": "Leonardo Cosac Oliveira Paranhos",
        "data": {
          "resident_institute": "Serviço CCV S.B.H. Santa Casa de Misericórdia de Ribeirão Preto - Dr. Eduardo Cosac",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "EnuH2FJspA1fZ8fcUEV0",
        "name": "Leonardo da Costa Buczynski ",
        "data": {
          "resident_institute": "Universidade do Estado do Rio de Janeiro - CNRM/MEC - Hospital Universidade Pedro Ernesto - Paulo Roberto",
          "resident_begin": "2001-03-01T03:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "oJrgmASkJD4172djhF1S",
        "name": "Leonardo de Oliveira Souza",
        "data": {
          "resident_institute": "Hospital Madre Teresa BH",
          "resident_begin": "2007-01-01T02:00:00.000Z",
          "resident_end": "2011-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "94oeZkIk3g8PSuB2ydgo",
        "name": "Leonardo Dorneles de Souza ",
        "data": {
          "resident_institute": "São Francisco - Santa Casa",
          "resident_begin": "2003-01-01T02:00:00.000Z",
          "resident_end": "2007-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "M1CxP5XmF4IBQhVslNGb",
        "name": "Leonardo Esteves Lima ",
        "data": {
          "resident_institute": "Especialização em CCV pela Universidade René Decartyes - Paris",
          "resident_begin": "1985-07-10T03:00:00.000Z",
          "resident_end": "1987-01-19T02:00:00.000Z"
        }
      },
      {
        "id": "X07J7OPqiWdU2jtG8Zhk",
        "name": "Leonardo Eugênio Fonseca Soares",
        "data": {
          "resident_institute": "Item 2.6.8 do Edital 2024 - Comprovação de treinamento/capacitação em Cirurgia Cardiovascular por meio de atividades profissionais, consd 10 anos",
          "resident_begin": "2007-01-01T02:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "971Ou8wxjWV2HCw7LfyV",
        "name": "Leonardo Ferber Drumond ",
        "data": {
          "resident_institute": "BIOCOR - Bayard Gontijo Fº",
          "resident_begin": "1991-12-31T02:00:00.000Z",
          "resident_end": "1994-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "jPAAgDWTj4KtPXs5xYOl",
        "name": "Leonardo Lacava Lopes ",
        "data": {
          "resident_institute": "Universidade Federal de Pelotas - CNRM/MEC",
          "resident_begin": "2001-01-01T02:00:00.000Z",
          "resident_end": "2002-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "S1wZhMaRVSsOrDogLU72",
        "name": "Leonardo Marega Angotti",
        "data": {
          "resident_institute": "Marinha do Brasil - Hospital Naval Marcílio Dias Clinica de Cirurgia Cardíaca - Chefe: Dr Fábio S. C. S. Amaral (Decl.8 anos)",
          "resident_begin": "2013-01-01T02:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "MALGpg56kmYX0frk9DNx",
        "name": "Leonardo Meireles Martins de Araujo ",
        "data": {
          "resident_institute": "Serviço CCV Hospital Vera Cruz - Dr. Renato Rocha Rebello",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "U9eIq7e7MDjpajFElLIE",
        "name": "Leonardo Moraes Albuquerque ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Carlos Gun",
          "resident_begin": "2003-02-01T02:00:00.000Z",
          "resident_end": "2007-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "gJ5tLLqdvtFB08PvAGXy",
        "name": "Leonardo Peixoto Lopes Vilar ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Norte Parana - Francisco Gregori Junior ",
          "resident_begin": "2009-01-10T02:00:00.000Z",
          "resident_end": "2014-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "zhSb0TyeIhKup04dDbh0",
        "name": "Leonardo Ribeiro de Almeida Lana ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Hospital São Francisco Assis de BH - Dr. José Augusto Ferreira",
          "resident_begin": "2010-12-31T02:00:00.000Z",
          "resident_end": "2014-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "268hGKEtxZb78WbesYCy",
        "name": "Leonel Henrique Fernandes da Cunha",
        "data": {
          "resident_institute": "Universidade de Pernambuco - FCM CNRM/MEC - Dr Enéas de Vasconcelos",
          "resident_begin": "2014-03-06T03:00:00.000Z",
          "resident_end": "2018-03-05T03:00:00.000Z"
        }
      },
      {
        "id": "jKErQm0gBTymzlXcvMgM",
        "name": "Leopoldo Moratelli Neto ",
        "data": {
          "resident_institute": "Instituto Cardiologia Centro de Estados dos ICSC CNRM/MEC - Dr Jauro Collaço",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "ixGh8r07HJmWob7k8n9L",
        "name": "Letícia Isabel Dias Candido",
        "data": {
          "resident_institute": "Universidade Nove de julho (Uninove)",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "770FBuk4BjAgZVPR0465",
        "name": "Letícia Siman Lopes ",
        "data": {
          "resident_institute": "Universidade de Marília (UNIMAR)",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2025-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "Qg12nQgE4S75egYT3joY",
        "name": "Liberato Sávio Siqueira de Souza ",
        "data": {
          "resident_institute": "Instituto do Coração - Fundação Zerbini - Dr. E. J. Zerbini",
          "resident_begin": "1972-03-01T03:00:00.000Z",
          "resident_end": "1974-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "qQwOEyPuRGDBx645M1MP",
        "name": "Lina Pinheiro Marques Gonçalves Ribeiro",
        "data": {
          "resident_institute": "Cirurgia Cardíaca na Unidade de Doenças Torácicas Stolf - Dr Noedir Stolf",
          "resident_begin": "2014-02-03T02:00:00.000Z",
          "resident_end": "2018-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "XwgeEKuwBnKnwHnD8rtl",
        "name": "Lindolfo Moratelli Filho",
        "data": {
          "resident_institute": "Instituto Cardiologia de Santa Catarina ICSC CNRM/MEC - Dr Amandio Rampineli",
          "resident_begin": "2015-03-02T03:00:00.000Z",
          "resident_end": "2019-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "VN6gwHy7V4WWfbaJcGGb",
        "name": "Lisandro Gonçalves Azeredo ",
        "data": {
          "resident_institute": "Universidade São Paulo - CNRM/MEC Coordenador do Programa: Alfredo Inácio Fiorelli",
          "resident_begin": "2007-01-01T02:00:00.000Z",
          "resident_end": "2011-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "tUzN8y7XCAWqP0dA5ayS",
        "name": "Livia Naomi Sasaki Feitoza",
        "data": {
          "resident_institute": "Universidade nove de julho ( UNINOVE )",
          "resident_begin": "2022-06-01T03:00:00.000Z",
          "resident_end": "2027-06-01T03:00:00.000Z"
        }
      },
      {
        "id": "GpZRhTdTjvBCFvSVgyfD",
        "name": "Lívia Silva de Paula Faria ",
        "data": {
          "resident_institute": "Hospital Felicio Rocho",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2026-07-01T03:00:00.000Z"
        }
      },
      {
        "id": "8N0fAJ9yfrANy1nep3p0",
        "name": "Louise Horiuti de Barros ",
        "data": {
          "resident_institute": "Faculdades de Medicina ABC - CNRM/MEC Dr. Adriano Meneghini",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "AI2Dhd0hv2gIiYU3y6pJ",
        "name": "Louise Náder Santos Silva ",
        "data": {
          "resident_institute": "Universidade Tiradentes",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "tfuripbpQlYD1rUm0RvK",
        "name": "Lourival Bonatelli Filho ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1981-02-01T03:00:00.000Z",
          "resident_end": "1984-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "gDH7UKur5qxUW8dXXdA3",
        "name": "Luana Pimentel Duarte",
        "data": {
          "resident_institute": "HOSPITAL FELICIO ROCHO - Dr. Charles Simão Filho",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "BwMC5Fknv8UbxvGHbNqz",
        "name": "Luana Vital Koike",
        "data": {
          "resident_institute": "Hospital de Base - FAMERP",
          "resident_begin": "2020-03-02T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "hZ2z7mCTK5dA8w3DhQ1z",
        "name": "Lucas Carvalho Durães Pena ",
        "data": {
          "resident_institute": "Hospital Vera Cruz e Hospital Universitário São José - Homero Geraldo de Oliveira",
          "resident_begin": "2011-01-17T02:00:00.000Z",
          "resident_end": "2014-12-17T02:00:00.000Z"
        }
      },
      {
        "id": "0zq4Ljqp6LmYQxxqL847",
        "name": "Lucas de Oliveira Ferrer ",
        "data": {
          "resident_institute": "BP",
          "resident_begin": "2020-02-17T03:00:00.000Z",
          "resident_end": "2025-02-17T03:00:00.000Z"
        }
      },
      {
        "id": "pK1gzf682D0MXGzILKzt",
        "name": "Lucas Destro Wedekin",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Ribeirão Preto/Hospital São Francisco - Dr. Eduardo Cosac",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-03-28T03:00:00.000Z"
        }
      },
      {
        "id": "r3wy6alP9U4mvanr5aCb",
        "name": "Lucas Estevão Moura Bezz Maciel",
        "data": {
          "resident_institute": "Serv. Instituto Nacional De Cardiologia Coordenação De Ensino E Pesquisa CNRM/MEC - Dra. Tereza Cristina Felippe Guimarães",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "VbT05qwQFtaJoSD625ZS",
        "name": "Lucas Fernandes Bonamigo",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo/InCor - HCFMUSP CNRM/MEC - DR. Alfredo Fiorelli",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "9L8vYBbfYLUTdMFiDQmH",
        "name": "Lucas Figueredo Cardoso",
        "data": {
          "resident_institute": "Serv. CCV Universidade de SP - CNRM/MEC - Coor: Dr. Alfredo Inácio Fiorelli",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "jpKwTBOYsYLvcyrRJnRH",
        "name": "Lucas Henrique Prado Sousa",
        "data": {
          "resident_institute": "Hospital SÃ£o Francisco de Assis",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "YozbnOW9c3WLmixzsSRK",
        "name": "Lucas Lacerda Araújo",
        "data": {
          "resident_institute": "Serv. CCV. Instituto do Coração do Hospital das Clínicas FMUSP CNRM/MEC - Dr. Equipe Dr. Alfredo Fiorelli",
          "resident_begin": "2014-03-06T03:00:00.000Z",
          "resident_end": "2018-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "jyXogw9Cvy3ba1QIAtpe",
        "name": "Lucas Machado Paraizo ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular BPSP - Dr Sérgio Almeida de Oliveira",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "caHwmq8IBqzjhrKwB1Eh",
        "name": "Lucas Molinari Veloso da Silveira",
        "data": {
          "resident_institute": "Serv. CCV. Instituto do Coração do Hospital das Clínicas FMUSP CNRM/MEC - Dr. Equipe Dr. Alfredo Fiorelli",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "8q6EcsxVq6yZiUJyCx1v",
        "name": "Lucas Nogueira Pansani",
        "data": {
          "resident_institute": "Famerp",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "DkYboTP43BDRWx2bQUVr",
        "name": "Lucas Regatieri Barbieri ",
        "data": {
          "resident_institute": "Hospital São Joaquim - CNRM - Gláucio Furlanetto",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2008-12-15T02:00:00.000Z"
        }
      },
      {
        "id": "9Wur5mlBxqRBsiC0ZPdP",
        "name": "Luciana Fonseca da Silva",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "1993-01-01T02:00:00.000Z",
          "resident_end": "1996-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "z7koAlJEGjYXiGA4TL4k",
        "name": "Luciano Abdallah Ferreira ",
        "data": {
          "resident_institute": "Unidade de Doenças Toracicas Stolf - Dr. Noedir Stolf",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "GGTc8WIyKMqG4hkZXwja",
        "name": "Luciano Augusto Leitão ",
        "data": {
          "resident_institute": "Hospital de Clinicas - Universidade Fed do Paraná - CNRM/MEC - Miguel Sobrinho",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2003-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "ZnzxDdrZVoNZPLuaxGTG",
        "name": "Luciano Cabral Albuquerque ",
        "data": {
          "resident_institute": "Hospital São Lucas - CNRM/MEC",
          "resident_begin": "1988-01-02T02:00:00.000Z",
          "resident_end": "1992-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "4UctxeQNOLJtltNyWTTa",
        "name": "Luciano Jannuzzi Carneiro ",
        "data": {
          "resident_institute": "irmandade da Santa Casa de Misericórdia de São Paulo - CNRM/MEC - Raimuindo Raffaelli Filho",
          "resident_begin": "2000-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Q97CwqvKjiVbwZoC3Md8",
        "name": "Luciano Matar Miranda ",
        "data": {
          "resident_institute": "Especialização em CCV no Hosp. Madre Teresa - Dr. Rodrigo de Castro Bernardes",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2003-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "loZfZrsD8j2k8VgJNZ0I",
        "name": "Lúcio Pereira Guarçoni Duarte ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Adib Jatene",
          "resident_begin": "1992-02-01T02:00:00.000Z",
          "resident_end": "1994-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "0E5eIVBl2pf1cNwPZykN",
        "name": "Luís Alberto Saraiva Santos ",
        "data": {
          "resident_institute": "Hospital Beneficiência Portuguesa de Sp",
          "resident_begin": "2003-01-01T02:00:00.000Z",
          "resident_end": "2006-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "JDR4in0ONdxlOxXuzCoR",
        "name": "Luís Anibal Larco Patino",
        "data": {
          "resident_institute": "Especialização em CCV na Clinica de Moléstias Cardiovasculares - Dr João Bosco de Oliveira",
          "resident_begin": "1992-03-01T03:00:00.000Z",
          "resident_end": "1996-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "uRrJnORT5HPh1MbdMuuU",
        "name": "Luís Bongiolo Mattos",
        "data": {
          "resident_institute": "Serv CCV Equipe do Dr José Pedro da Silva - Clinica Cardio PJ da Silva",
          "resident_begin": "2015-01-02T02:00:00.000Z",
          "resident_end": "2019-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "NFJKzIZsYtnQEy06Kpey",
        "name": "Luís Ernesto Avanci",
        "data": {
          "resident_institute": "Hosp. Infante D. Henrique (Hosp. Benef. Portuguesa) Dr. João Carlos F. Leal",
          "resident_begin": "1995-02-02T02:00:00.000Z",
          "resident_end": "2001-02-02T02:00:00.000Z"
        }
      },
      {
        "id": "sgbKk73I52LmYw1LZ9oV",
        "name": "Luís Fernando Carmona Cesar Portugal ",
        "data": {
          "resident_institute": "Serviço CCV Instituto Cardiologia Dante Pazzanese - Dr. Luiz Carlos Bento de Souza",
          "resident_begin": "1996-02-01T02:00:00.000Z",
          "resident_end": "1999-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "uzPjBUd3Onm1qteeJwLS",
        "name": "Luís Fernando Tirolli Sanches",
        "data": {
          "resident_institute": "Instituto de Cirurgia do Coração de Londrina - Dr Kengo Baba (mais de 8 anos)",
          "resident_begin": "2009-01-01T02:00:00.000Z",
          "resident_end": "2019-11-30T03:00:00.000Z"
        }
      },
      {
        "id": "rzl2SSIWN0s5Wq0xMSbk",
        "name": "Luís Roberto Palma Dallan ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC Coordenador: Alfredo Inácio Fiorelli",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "HgWBtRgmMotX0hboA6XR",
        "name": "Luísa Lois Rodrigues de Oliveira",
        "data": {
          "resident_institute": "Hospital Santa Casa de Misericórdia de Passos - MG - Dr. Ricardo Nilson Sgarbieri",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "doPUsbNaRVQJ4InVDqYN",
        "name": "Luísa Salek Vieira",
        "data": {
          "resident_institute": "Instituto Nacional de Cardiologia",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-03-31T03:00:00.000Z"
        }
      },
      {
        "id": "Gjk0ZDxlhsVB3367YJYB",
        "name": "Luiz Antonio Brasil ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1984-02-02T03:00:00.000Z",
          "resident_end": "1987-02-20T03:00:00.000Z"
        }
      },
      {
        "id": "Pv0mSjwxMLuDp8OdKP3H",
        "name": "Luiz Antonio Castilho Teno ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia -",
          "resident_begin": "1976-02-01T03:00:00.000Z",
          "resident_end": "1978-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "kxivft58PY13s4xQK7LR",
        "name": "Luiz Antonio Costa Donelli ",
        "data": {
          "resident_institute": "Faculdade de Ciências Médicas da Santa Casa de Miserocórdia de São Paulo - Prof. Emilio Athié",
          "resident_begin": "1976-02-01T03:00:00.000Z",
          "resident_end": "1980-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "UFGdWWcOzmh6GDgD0dDC",
        "name": "Luiz Augusto Ferreira Lisboa ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de São Paulo- CNRM/MEC",
          "resident_begin": "1992-02-01T02:00:00.000Z",
          "resident_end": "1996-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "5QbDsU1GPb8Dpjo1MWpk",
        "name": "Luiz Boro Puig ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de SP - CNRM/MEC Dr. Zerbini",
          "resident_begin": "1967-01-03T02:00:00.000Z",
          "resident_end": "1969-01-03T03:00:00.000Z"
        }
      },
      {
        "id": "KRdq6EKkMOplzsaARGN7",
        "name": "Luiz Carlos Schimin ",
        "data": {
          "resident_institute": "Hospital das Forças Armadas - CNRM/MEC - Dr. André Esteves Lima",
          "resident_begin": "1976-01-02T03:00:00.000Z",
          "resident_end": "1977-12-30T03:00:00.000Z"
        }
      },
      {
        "id": "urqa8kheZfSyrtQUcRh6",
        "name": "Luiz Cláudio Moreira Lima ",
        "data": {
          "resident_institute": "Hosp. Madre Teresa - Rodrigo Bernardes",
          "resident_begin": "1991-01-01T02:00:00.000Z",
          "resident_end": "1993-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "Grp7ZpLL5sbcfYJM0t21",
        "name": "Luiz Fernando Caneo ",
        "data": {
          "resident_institute": "Universidade São Paulo - CNRM Coordenador do Programa: Adib Domingos Jatene",
          "resident_begin": "1987-02-01T02:00:00.000Z",
          "resident_end": "1990-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Tccv45OmiqVOe12bC7Mj",
        "name": "Luiz Fernando Coimbra",
        "data": {
          "resident_institute": "Instituto de Cardiologia/BPSP - Secretaria da Saúde - CNRM/MEC Adib Jatene",
          "resident_begin": "1986-03-01T02:00:00.000Z",
          "resident_end": "1989-03-30T03:00:00.000Z"
        }
      },
      {
        "id": "L14lyaA2guegwmc8salH",
        "name": "Luiz Fernando Kubrusly ",
        "data": {
          "resident_institute": "Hospital de Clinicas - Universidade Fed do Paraná - CNRM/MEC",
          "resident_begin": "1980-01-01T03:00:00.000Z",
          "resident_end": "1981-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "QoFsIoDYEaoctZdQ6EyZ",
        "name": "Luiz Fernando Machado ",
        "data": {
          "resident_institute": "Universidade Federal do Paraná CNRM/MEC",
          "resident_begin": "1981-02-02T03:00:00.000Z",
          "resident_end": "1983-01-30T03:00:00.000Z"
        }
      },
      {
        "id": "N4jnPze9t3O80hWvNRsh",
        "name": "Luiz Henrique Dussin ",
        "data": {
          "resident_institute": "Hospital de Clínicas de Porto Alegre - CNRM/MEC Cood Sérgio Martins Costa",
          "resident_begin": "1993-01-02T02:00:00.000Z",
          "resident_end": "1997-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "OPpAVkZwJLVA2HGIAJEF",
        "name": "Luiz Neves Neto",
        "data": {
          "resident_institute": "Serv. CCV Hospital Nossa Senhora do Rocio - Dr Leonardo Mulinari",
          "resident_begin": "2013-02-01T02:00:00.000Z",
          "resident_end": "2017-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "n5ncSJi4i631o9bykgk6",
        "name": "Luiz Paulo Rangel Gomes da Silva ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Dr Gonzaga Morboch",
          "resident_begin": "1977-02-01T03:00:00.000Z",
          "resident_end": "1980-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "OSsKBohNVpukXNaBqzDX",
        "name": "Luiz Penariol de Souza",
        "data": {
          "resident_institute": "Item 2.6.8 do Edital 2024 - Comprovação de treinamento/capacitação em Cirurgia Cardiovascular por atuação (10 anos )",
          "resident_begin": "2016-07-01T03:00:00.000Z",
          "resident_end": "2023-12-11T03:00:00.000Z"
        }
      },
      {
        "id": "TM7fw84BEFJbyhCS8cZN",
        "name": "Luiz Rafael Pereira Cavalcanti",
        "data": {
          "resident_institute": "Universidade de Pernambuco/Faculdade de Ciências Medicas - CNRM/MEC Coord. Dra. Mariane Regina A. Sabino",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "kf3Sl2H4pYDwYe839VUH",
        "name": "Luiz Ricardo Pescatori Dutra ",
        "data": {
          "resident_institute": "CCV BP SP - Clínica Stolf - Dr. Noedir Stolf",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "I4bQ2Cju5Zlwbz4nig0W",
        "name": "Luiz Takeshi Nagahashi",
        "data": {
          "resident_institute": "Instituto de Cirurgia do Coração de Londrina - Dr Kengo Baba (mais de 8 anos)",
          "resident_begin": "2008-01-01T02:00:00.000Z",
          "resident_end": "2019-11-30T03:00:00.000Z"
        }
      },
      {
        "id": "8vWrWlQ4IZxCMIoSQAF5",
        "name": "Magaly Arrais dos Santos",
        "data": {
          "resident_institute": "Hospital do Coração - Luiz Carlos Bento de Souza",
          "resident_begin": "1990-02-01T02:00:00.000Z",
          "resident_end": "1993-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "oNlbl9hoqO4Ywxa9vCaG",
        "name": "Maikon Lucian Madeira Quarti",
        "data": {
          "resident_institute": "Hospital Marieta Konder Bornhuasen Itajaí-SC",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "0vzlrRHM6YjX7RVv3tti",
        "name": "Malena Verona Singling",
        "data": {
          "resident_institute": "SANTA CASA DE MISERICÓRDIA DE SANTOS - DR JEFFERSON DOS SANTOS",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "L5AqRa9PkxIflC083Y2v",
        "name": "Mamede Francisco Johnson de Aquino Filho ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "gtnrr0TfETnKy7I3VOUX",
        "name": "Manoel Araujo Maneschy ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio Pulmonar E.J. Zerbini - Dr. E. J. Zerbini",
          "resident_begin": "1976-01-01T03:00:00.000Z",
          "resident_end": "1978-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "GVijgcqVdZdOrCiVyqIn",
        "name": "Mansuor Chaer Alameddin ",
        "data": {
          "resident_institute": "Serviço CCV Instituto Nacional de Cardiologia/Hospital Laranjeiras do Rio de Janeiro - Dr. Alexandre Siciliano Colafranceschi",
          "resident_begin": "2016-03-14T03:00:00.000Z",
          "resident_end": "2020-03-15T03:00:00.000Z"
        }
      },
      {
        "id": "nrJrL0xVeFIyk1UUmb2N",
        "name": "Manuel Arturo de Isasa Paredes",
        "data": {
          "resident_institute": "Serv. CCV Hospital das Clínicas FMUSP - Programa de Capacitação p/ Estrangeiro - Prof. Fábio Jatene",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "d5L8EhUz2aBPrthkgMnY",
        "name": "Manuella Muniz Trindade Varejão ",
        "data": {
          "resident_institute": "Instituto do Coração (incor Pernambuco) CNRM/MEC - Fernando Ribeiro de Moraes Neto",
          "resident_begin": "2012-03-02T03:00:00.000Z",
          "resident_end": "2017-01-19T02:00:00.000Z"
        }
      },
      {
        "id": "4l3989WUqEkyDScf47UK",
        "name": "Marcela da Cunha Sales ",
        "data": {
          "resident_institute": "Hospital São Lucas da PUCRS - CNRM/MEC - Dr José Miguel Chatkin",
          "resident_begin": "1992-01-02T02:00:00.000Z",
          "resident_end": "1994-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "Hp67vJBmeY0JV3LTYmo1",
        "name": "Marcela Reis Rico Ornellas",
        "data": {
          "resident_institute": "Serv. CCV Sta Casa de Santos CNRM/MEC Coord. Paulo Henrique Caruso",
          "resident_begin": "2024-03-01T03:00:00.000Z",
          "resident_end": "2029-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "v4VaZ08M1qZr00WvQYZA",
        "name": "Marcella Menezes Relvas",
        "data": {
          "resident_institute": "RJ - HOSPITAL DE FORÇA AÉREA DO GALEÃO RJ - CNRM/MEC Dr. Marcelo Sávio",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "yV8jl34ApgLSq1X65ZDi",
        "name": "Marcello Gomide Campos de Faria ",
        "data": {
          "resident_institute": "Incor - FMUSP CNRM/MEC - Cood. Pablo M. A. Pomerantzeff",
          "resident_begin": "2001-01-01T02:00:00.000Z",
          "resident_end": "2004-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "vXfovm1wt1yDTbcBo0A6",
        "name": "Marcello Laneza Felício ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "2001-01-01T02:00:00.000Z",
          "resident_end": "2004-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "nGTIUy7ZeT70CHsUJ7mC",
        "name": "Marcelo Anadão Brambilla",
        "data": {
          "resident_institute": "Serv. CCV Hospital Norte do Paranaense - HONPAR Coord. Dr. Francisco Gregori Junior",
          "resident_begin": "2024-03-01T03:00:00.000Z",
          "resident_end": "2029-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "bPK40aNYW7olk4LePR1r",
        "name": "Marcelo Biscegli Jatene ",
        "data": {
          "resident_institute": "Faculdade de Medicina de SP - Depart. CCV - CNRM/MEC - Denize Terezinha Costa",
          "resident_begin": "1987-02-01T02:00:00.000Z",
          "resident_end": "1990-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "ZyceYD1qk77T0oIhFMqb",
        "name": "Marcelo Braga Ivo ",
        "data": {
          "resident_institute": "Especialização em CCV no Hosp. Madre Teresa - Dr. Rodrigo Bernardes",
          "resident_begin": "2012-08-01T03:00:00.000Z",
          "resident_end": "2016-07-31T03:00:00.000Z"
        }
      },
      {
        "id": "VMXpFbIrKZLYp6GUguSB",
        "name": "Marcelo Carneiro Drumond ",
        "data": {
          "resident_institute": "Serviço CCV Santa Santa Casa de Belo Horizonte - CNRM/MEC - Coordenador Coreme Dr. Miguel Angelo Pinto Farage",
          "resident_begin": "2017-03-06T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "wrPZzsFc1X0vNajfsUWG",
        "name": "Marcelo Dágola Paulista ",
        "data": {
          "resident_institute": "Serviço de Clínica e Cirurgia Cardiovascular Dr Paulo Paredes Paulista - BPSP",
          "resident_begin": "2004-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "glaeM844cmsxACPujuim",
        "name": "Marcelo de Almeida Costa ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Paulo Paredes Paulista",
          "resident_begin": "2000-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "0CfTrXlm2vtJq4OHjy0I",
        "name": "Marcelo Ferraz de Freitas ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Norte do Paraná - Francisco Gregori Jr",
          "resident_begin": "1997-05-05T03:00:00.000Z",
          "resident_end": "2000-07-15T03:00:00.000Z"
        }
      },
      {
        "id": "RKXTtRQhYcbVzqn6S09K",
        "name": "Marcelo Frederigue de Castro ",
        "data": {
          "resident_institute": "Biocor - Bayard Gontijo Filho",
          "resident_begin": "1987-02-01T02:00:00.000Z",
          "resident_end": "1990-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "hQroTPyy01X2ULkfeV1k",
        "name": "Marcelo Gentil Almeida Guedes ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - José Pedro da Silva",
          "resident_begin": "1990-01-01T02:00:00.000Z",
          "resident_end": "1992-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "9lMeTcTxlqNY7HCQnI4J",
        "name": "Marcelo Matos Cascudo",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1979-01-02T03:00:00.000Z",
          "resident_end": "1981-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "i2idPxy4mPXGkzR3rlr6",
        "name": "Marcelo Nunes de Sousa",
        "data": {
          "resident_institute": "BPSP Serviço de Clínica e Cirurgia Cardiovascular Direção Dr Paulo Paredes Paulista",
          "resident_begin": "2000-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "VenhvfiYpQ71IcSKYOf2",
        "name": "Marcelo Pandolfo ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Curitiba - PUCPR",
          "resident_begin": "2006-01-01T02:00:00.000Z",
          "resident_end": "2010-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "biZsvTpcm4MjBe3TRNKu",
        "name": "Marcelo Pimenta Borem ",
        "data": {
          "resident_institute": "Hospital e Maternidade Santa Rita S/A - Raul Corrêa Rabelo",
          "resident_begin": "1985-06-01T03:00:00.000Z",
          "resident_end": "1988-07-31T03:00:00.000Z"
        }
      },
      {
        "id": "N9I1Ok8L40F1YoTwEpLu",
        "name": "Marcelo Rodrigues Covolan ",
        "data": {
          "resident_institute": "Instituto estadual de cardiologia Aloysio de Castro - Responsavel pelo Serviço.....: Dr Claudio Assumpção",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "ZiJcJ0OGTqqoI3PboNwF",
        "name": "Marcelo Santos Morbeck",
        "data": {
          "resident_institute": "Serv CCV Equipe do Dr Sérgio Almeida - Clínica Cirúrgica e Cardiologia Dr Sérgio Almeida",
          "resident_begin": "2006-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "UyaVScV1eqscIewX3Hl9",
        "name": "Marcelo Sávio da Silva Martins",
        "data": {
          "resident_institute": "BPRJ - Antônio de Pádua Jazbik",
          "resident_begin": "1991-01-01T02:00:00.000Z",
          "resident_end": "1993-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "0jVZmrNHHGVAR0CcnnXc",
        "name": "Márcio Bevilaqua Lacerda",
        "data": {
          "resident_institute": "Serv. CCV Hosp. Felício Rocho - Dr. Dielson Teixeira Sampaio",
          "resident_begin": "2006-11-01T03:00:00.000Z",
          "resident_end": "2010-11-01T02:00:00.000Z"
        }
      },
      {
        "id": "rBspyVxHtuv3xXPKkjiu",
        "name": "Márcio Fabiano Chaves Bastos",
        "data": {
          "resident_institute": "Hospital Universitário Cajuru - CNRM/MEC - Flávio Bortalozzi",
          "resident_begin": "1995-01-10T02:00:00.000Z",
          "resident_end": "1999-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "n4i4Luz3K8PqDuZZqG7r",
        "name": "Márcio Henrique Cardoso ",
        "data": {
          "resident_institute": "Instituto de Cirurgia do Coração de Londrina - Dr. Roberto Takeda",
          "resident_begin": "2004-07-02T03:00:00.000Z",
          "resident_end": "2008-07-15T03:00:00.000Z"
        }
      },
      {
        "id": "f1jjsVbtk1YztMCfqRpC",
        "name": "Márcio Pimentel Fernandes ",
        "data": {
          "resident_institute": "Faculdade de Medicina de S. J. do Rio Preto - SP - Dr. Marcelo José Soares",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "1tcbnqS87iMTZOTXE4zV",
        "name": "Márcio Rodrigo Martins ",
        "data": {
          "resident_institute": "Universidade Federal de São Paulo CNRM/MEC - Dr Gilmar Fernando do Prado",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "9jXNcyMycG2lokoQ1TWN",
        "name": "Márcio Rufino Barbosa Jr. ",
        "data": {
          "resident_institute": "Serviço CCV Instituto Dante Pazzanese de Cardiologia/CNRM - Dra. Antoninho Sanfins Arnoni",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "SWOUm8l1mgfj2QsBIXLu",
        "name": "Marco Antônio Araújo de Mello ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia",
          "resident_begin": "1997-02-01T02:00:00.000Z",
          "resident_end": "2000-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "e8MvgBbNO0pWzMH5Wy6w",
        "name": "Marco Antonio Ayin Fossa ",
        "data": {
          "resident_institute": "Beneficência Portuguesa Serviço: Prof. Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "1999-01-01T02:00:00.000Z",
          "resident_end": "2002-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "VuaXN3IT66I9fC9kHiBR",
        "name": "Marco Antonio Cunha ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo - CNRM/ME - Dr. Marcio Rogério Batista",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2001-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "QSZ4bbcx4OTty6oevl2U",
        "name": "Marco Antonio Figueiredo Fidalgo Donadelli",
        "data": {
          "resident_institute": "Serv. CCV no Hospital Santa Casa de Misericórdia de Ribeirão Preto - Dr. Eduardo Cosac Paranhos",
          "resident_begin": "2022-02-01T03:00:00.000Z",
          "resident_end": "2027-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "cTtBxRWhmahOG7q7b4Sf",
        "name": "Marco Antonio Goldani ",
        "data": {
          "resident_institute": "Hosp. São Lucas PUC RS - João Batista Petracco",
          "resident_begin": "1971-02-01T03:00:00.000Z",
          "resident_end": "1973-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "apSeaBeXo0aDJ76g6vpI",
        "name": "Marco Antonio Vieira Guedes ",
        "data": {
          "resident_institute": "USP - CARDIO-PNEUMOLOGIA - Glauciete Costa Roque",
          "resident_begin": "2004-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "U9tEEDwHp6BXRrbW3ojE",
        "name": "Marco Aurélio Barroso Aguiar ",
        "data": {
          "resident_institute": "Instituto Nacional de Assistência Médica da Previdência Social - CNRM/MEC - Diretor: José Roberio de Souza",
          "resident_begin": "1987-07-14T03:00:00.000Z",
          "resident_end": "1990-07-13T03:00:00.000Z"
        }
      },
      {
        "id": "zyoG7EDQNkqTn1cBd0Hn",
        "name": "Marco Aurélio Borazo ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba / CNRM/MEC - Danton Loures",
          "resident_begin": "1997-01-10T02:00:00.000Z",
          "resident_end": "2000-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "xZe5J5qFMomjbSL8F4ZW",
        "name": "Marco Aurélio Nascimento Crespo Júnior ",
        "data": {
          "resident_institute": "Serv. CCV S.B.H. Santa Casa de Misericórdia De Ribeirão Preto - Dr. Eduardo Paranhos",
          "resident_begin": "2018-01-15T02:00:00.000Z",
          "resident_end": "2023-01-14T03:00:00.000Z"
        }
      },
      {
        "id": "Q9ArhqnmGaVDOKUF8y1g",
        "name": "Marco Aurélio Salles Assef ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1993-02-01T03:00:00.000Z",
          "resident_end": "1996-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "r73KauKcaLjHGTKYG4V0",
        "name": "Marco Aurelio Vilela Borges de Lima ",
        "data": {
          "resident_institute": "Faculdade de Medicina de SP - Depart. Cárdio-Pulmonar - CNRM/MEC - Yara Corradini",
          "resident_begin": "1994-02-01T02:00:00.000Z",
          "resident_end": "1997-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "YJDTGZgB3erkSjQsEwGH",
        "name": "Marconi de Oliveira Ruas ",
        "data": {
          "resident_institute": "Biocor - BIOCOR INSTITUTO - Dr. Mario Vrandecic",
          "resident_begin": "1994-01-01T02:00:00.000Z",
          "resident_end": "1996-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "yPvUyGyWTaE6hB2WgOta",
        "name": "Marcos Alfredo de Andrade Pires ",
        "data": {
          "resident_institute": "Instituto de Cirurgia do Coração - Equipe Arnaldo Akino (Atua no IncorPR a mais de 8 anos - Sócio, desde 2011)",
          "resident_begin": "2011-01-02T02:00:00.000Z",
          "resident_end": "2019-02-02T02:00:00.000Z"
        }
      },
      {
        "id": "JDupwQyvnXZXKoaikvJo",
        "name": "Marcos Antonio Cantero ",
        "data": {
          "resident_institute": "Instituto de Cirurgia do Coração de Londrina - Dr. Roberto Takeda",
          "resident_begin": "2002-02-01T02:00:00.000Z",
          "resident_end": "2005-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "AH09t9UrCFIaSelIvaxw",
        "name": "Marcos Antonio de Farias Lira",
        "data": {
          "resident_institute": "Hospital Nossa Senhora da Penha SP - Dr. Delmont Bittencourt",
          "resident_begin": "1978-03-01T03:00:00.000Z",
          "resident_end": "1981-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "G2yaTkqhk7erdbR3URcK",
        "name": "Marcos Antonio Ferreira Lima ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca Hosp. BP/SP - Dr. Luiz Boro Puig",
          "resident_begin": "1999-01-01T02:00:00.000Z",
          "resident_end": "2001-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "Ew8TnYbLbwnWqjXZZzFH",
        "name": "Marcos Aurélio Barboza de Oliveira ",
        "data": {
          "resident_institute": "Serv. CCV da FAMERP / CNRM/MEC - Coord. Dr. Marcelo José Ferreira Soares",
          "resident_begin": "2004-02-02T02:00:00.000Z",
          "resident_end": "2008-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "0ycfymjme8WqPqJDP22a",
        "name": "Marcos Bonin ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba Danton Loures",
          "resident_begin": "2000-01-10T02:00:00.000Z",
          "resident_end": "2002-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "pjnshO6Q3rxRJvrUa52e",
        "name": "Marcos Fassheber Berlinck",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - Dr. Sergio A Oliveira",
          "resident_begin": "1981-01-02T03:00:00.000Z",
          "resident_end": "1984-01-02T03:00:00.000Z"
        }
      },
      {
        "id": "SjdUSHpcZCE3jt8G9BJ6",
        "name": "Marcos Monteiro Pinto Moreira ",
        "data": {
          "resident_institute": "Hospital Madre Teresa",
          "resident_begin": "2008-01-01T02:00:00.000Z",
          "resident_end": "2012-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "fdUmOfrk45fi6NA5lnEh",
        "name": "Marcos Pimentel da Cunha ",
        "data": {
          "resident_institute": "Cirurgia Cardiovascular no Real Benemérita Associação Portuguesa de Beneficência - preceptoria do Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2003-02-03T02:00:00.000Z",
          "resident_end": "2006-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Iu8kcxTPHZujbr3kRKEY",
        "name": "Marcos Ramos Carvalho ",
        "data": {
          "resident_institute": "Clínica Cardiovascular Hospital Santa Isabel - Dr. Nilson Augusto Mendes Ribeiro",
          "resident_begin": "1980-01-01T03:00:00.000Z",
          "resident_end": "1983-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "dI2s6JCI1hoclhIEcMQz",
        "name": "Marcos Rogério Joaquim ",
        "data": {
          "resident_institute": "Hospital de Base - FAMERP - CNRM/MEC",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "jDgN71xCqp6maPjVcl6s",
        "name": "Marcos Vargas Aleixo",
        "data": {
          "resident_institute": "Inst. D. Cardio Pulm. Zerbini - Preceptor atual: Eduardo Coelho Souza",
          "resident_begin": "1986-01-15T02:00:00.000Z",
          "resident_end": "1990-01-15T02:00:00.000Z"
        }
      },
      {
        "id": "9RltrVDRcNKAzWDCMnhF",
        "name": "Marcos Vinícius da Cunha",
        "data": {
          "resident_institute": "BP",
          "resident_begin": "2020-02-01T03:00:00.000Z",
          "resident_end": "2025-02-01T03:00:00.000Z"
        }
      },
      {
        "id": "rvcElUgPIDGqtyojyYl2",
        "name": "Marcos Vinícius Gonçalves Matozinhos",
        "data": {
          "resident_institute": "Universidade Federal de Minas Gerais (UFMG)",
          "resident_begin": "2023-03-01T03:00:00.000Z",
          "resident_end": "2028-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "7okxkXuyHT1x8nHAu4vq",
        "name": "Marcus Gustavo Tito ",
        "data": {
          "resident_institute": "Hospital Vera Cruz",
          "resident_begin": "1996-01-01T02:00:00.000Z",
          "resident_end": "1998-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "3bTq0jZFFudOWKFbF4ft",
        "name": "Marcus Matheus Ferry e Silva",
        "data": {
          "resident_institute": "Universidade Nove de Julho (UNINOVE)",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "a4cUWbBBEnXewk8eAvGR",
        "name": "Marcus Paulo Santa Bárbara de Abreu ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Vera Cruz - Dr. Roney Ronald Peixoto",
          "resident_begin": "2014-02-03T02:00:00.000Z",
          "resident_end": "2018-02-03T02:00:00.000Z"
        }
      },
      {
        "id": "TLWgzY3AllxcdbUxbqBx",
        "name": "Marcus Vinicius Henriques de Carvalho ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1979-01-02T03:00:00.000Z",
          "resident_end": "1980-06-30T03:00:00.000Z"
        }
      },
      {
        "id": "SNh4nm1E4nCDiNTK1AqK",
        "name": "Marcus Vinicius Reggiori Pereira Caldas ",
        "data": {
          "resident_institute": "Fundação Centro de Estudo Dr. Wiliam Maksoud - João Jazbik Neto",
          "resident_begin": "1995-01-05T02:00:00.000Z",
          "resident_end": "1998-01-05T02:00:00.000Z"
        }
      },
      {
        "id": "yVy8SLIOuwvRDJOT0REG",
        "name": "Maria Alejandra Rivero Garcia ",
        "data": {
          "resident_institute": "Instituto do Coração - Fundação Zerbini - Dr. Noedir Stolf",
          "resident_begin": "1996-01-01T02:00:00.000Z",
          "resident_end": "1999-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "ykjmwGhs3Qwc0sHRz4E8",
        "name": "Maria Eduarda Bertol",
        "data": {
          "resident_institute": "Universidade Nove De Julho (uninove)",
          "resident_begin": "2022-01-01T03:00:00.000Z",
          "resident_end": "2027-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "8fWM0oLuV2aym4YbTrJY",
        "name": "Maria Fernanda Domingos Berlatto",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Curitiba - Dr. Paulo Brofmann",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "mBs5GXGCEH9NgPLR55c4",
        "name": "Maria Luiza Marx Pessoa Silva",
        "data": {
          "resident_institute": "Faculdade Santa Marcelina (FASM)",
          "resident_begin": "2019-06-01T03:00:00.000Z",
          "resident_end": "2025-06-01T03:00:00.000Z"
        }
      },
      {
        "id": "GWUvLVCiXXoDeVLiEWO1",
        "name": "Maria Mônica de Farias Costa ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular da Santa Casa de Misericórdia da Maceió - Dr Wanderley Neto",
          "resident_begin": "1991-08-02T03:00:00.000Z",
          "resident_end": "1995-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "aFmwtwZlggCEc0dlls51",
        "name": "Maria Raquel Brigoni Massoti ",
        "data": {
          "resident_institute": "Incor - FMUSP/CNRM-MEC - Dr Alfredo Inácio Fiorelli",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "QCpe9xbL1EPOwPTVaS9A",
        "name": "Marialda M. Coimbra ",
        "data": {
          "resident_institute": "Hospital da Loga - CNRM/MEC Dr. Paulo Rodrigues da Silva",
          "resident_begin": "1975-01-01T03:00:00.000Z",
          "resident_end": "1976-12-30T03:00:00.000Z"
        }
      },
      {
        "id": "DSY3w3ZkZHjBLsGLaLzI",
        "name": "Mariana Brandão da Silva Sousa ",
        "data": {
          "resident_institute": "Serv. CCV Sta Casa P. Alegre -Hosp. S. Francisco - Dr. Fernando Antonio Lucchese",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "ArqjLkxBuuLnxyFVqIyo",
        "name": "Maribel Flores Mamani",
        "data": {
          "resident_institute": "\"Serv. CCV Hospital Interzonal de Agudos y Crónicos \"\"San Juan de Dios\"\" de La Plata\"",
          "resident_begin": "2016-06-01T03:00:00.000Z",
          "resident_end": "2021-09-30T03:00:00.000Z"
        }
      },
      {
        "id": "X1lRYYq0p3EDz7d0ExB3",
        "name": "Mário Augusto Cray da Costa ",
        "data": {
          "resident_institute": "Universidade Federal do Paraná - CNRM/MEC",
          "resident_begin": "1994-02-01T02:00:00.000Z",
          "resident_end": "1997-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "8ehPQW160jgFEcDVDkgA",
        "name": "Mário César Santos de Abreu ",
        "data": {
          "resident_institute": "Faculdade de Medicina de São Paulo - Preceptor: Adib Jatene",
          "resident_begin": "1985-02-01T03:00:00.000Z",
          "resident_end": "1988-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "U2wbHAmJXf0jd4fXWcVd",
        "name": "Mário Florizel Almeida de Araújo ",
        "data": {
          "resident_institute": "Sociedade Beneficente de Campo Grande - Santa Casa CNRM/MEC - Dr. Wiiliam Maksoud",
          "resident_begin": "1994-01-04T02:00:00.000Z",
          "resident_end": "1997-01-04T02:00:00.000Z"
        }
      },
      {
        "id": "7ssWCdr7OaxnKxcgKRcf",
        "name": "Mário Issa ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese se Cardiologia - CNRM/MEC - Paulo Paredes Paulista",
          "resident_begin": "1989-02-01T03:00:00.000Z",
          "resident_end": "1992-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "UFJ3Ac1G2vumQDKpdZpH",
        "name": "Mário Ricardo Amar ",
        "data": {
          "resident_institute": "Universidade do Estado do Rio de Janeiro - CNRM/MEC",
          "resident_begin": "1988-03-01T03:00:00.000Z",
          "resident_end": "1991-02-20T03:00:00.000Z"
        }
      },
      {
        "id": "mfeh0UWXliyw7SMTfWyM",
        "name": "Marli Cavalcanti Lopes Annes ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio - Pulmonar E. J. Zerbini - Dr Eduardo Coelho de Souza",
          "resident_begin": "1993-01-01T02:00:00.000Z",
          "resident_end": "1996-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "anFfkGZkuE7xreIuMQ5t",
        "name": "Martin Antonio Diaz Zuazo",
        "data": {
          "resident_institute": "Serv. CCV Hospital Stella Maris, UNIFESP e Hospital Santa Clara - Item 2.6.8 do Edital de 2023 (considerando 10 anos de atuação",
          "resident_begin": "2004-05-02T03:00:00.000Z",
          "resident_end": "2023-03-31T03:00:00.000Z"
        }
      },
      {
        "id": "pg90bvqn977vi8k2o3rG",
        "name": "Martin Ferreira Bucek ",
        "data": {
          "resident_institute": "Cirurgia Cardiovascular - Fundação Hospitalar São Francisco de Assis - Dr. José Augusto Ferreira",
          "resident_begin": "2012-01-10T02:00:00.000Z",
          "resident_end": "2016-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "NfLEYPpxMUentIfnY2R3",
        "name": "Mateus Bueno Bueno",
        "data": {
          "resident_institute": "Serviço CCV Instituto de Cardiologia do Rio Grande do Sul - CNRM/MEC - Dr. Domingos Vitola",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "XZ23rrHuotEHMMFvMcen",
        "name": "Matheus Cipriano Vidal Heluany",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul - CNRM/MEC - Dr. Domingos Vitola",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "54OVq36hwzJb7Cf8LnpH",
        "name": "Matheus de França Furtado",
        "data": {
          "resident_institute": "Serv CCV Hospital Santa Casa de Misericórdia de Belo Horizonte - Coord. Dr. Marcelo Frederigue de Castro",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "nj86nIBSuw5HijdEzfvN",
        "name": "Matheus Ferber Drumond ",
        "data": {
          "resident_institute": "BIOCOR - Bayard Gontijo Fº",
          "resident_begin": "2005-08-01T03:00:00.000Z",
          "resident_end": "2009-08-01T03:00:00.000Z"
        }
      },
      {
        "id": "K2Mi690hYALSENcnrkWG",
        "name": "Matheus Pontes Meirelles ",
        "data": {
          "resident_institute": "Serv. CCV Incor CNRM/MEC Coord. Dr. Alfredo Inácio Fiorelli",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "3iXSPnIzLwdxAoj1mTpS",
        "name": "Matheus Sant’Anna de Oliveira Gonçalves ",
        "data": {
          "resident_institute": "Universidade Federal do Ceará (UFC)",
          "resident_begin": "2023-01-01T03:00:00.000Z",
          "resident_end": "2028-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "qRi45xv0uM68VRqTpULw",
        "name": "Maurício de Castro Gomes ",
        "data": {
          "resident_institute": "Hosp. Madre Teresa - Rodrigo Bernardes",
          "resident_begin": "1994-01-01T02:00:00.000Z",
          "resident_end": "1996-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "3XbkLPB7ZsxYxq3ZbnDu",
        "name": "Maurício Galantier ",
        "data": {
          "resident_institute": "Instituto de Cardiologia de SP",
          "resident_begin": "1970-02-01T03:00:00.000Z",
          "resident_end": "1972-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "zBRq29FRxF3333IY3Cec",
        "name": "Maurício Landulfo Jorge Guerrieri",
        "data": {
          "resident_institute": "Residência em CCV, CNRM/MEC Univ. do Vale do Sapucai - Hospital das Clínicas Samuel Libâno - Dr. Alexandre Ciappina Hueb",
          "resident_begin": "2015-03-09T03:00:00.000Z",
          "resident_end": "2019-03-08T03:00:00.000Z"
        }
      },
      {
        "id": "ab9TTMWl8N9hlfRrxkFG",
        "name": "Maurício Leichter Suksteris",
        "data": {
          "resident_institute": "Serv. CCV Universidade Católica do Rio Grande do Sul - CNRM/MEC - Coord: Dr. Carlos Kupski",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "3JY234dJ9rSpkcG9Gs28",
        "name": "Maurício Lobo Nascimento ",
        "data": {
          "resident_institute": "Serv. CCV Hosp. Clementino Fraga Fº - Dr Mauro Paes Leme de Sá",
          "resident_begin": "2008-06-11T03:00:00.000Z",
          "resident_end": "2011-11-30T02:00:00.000Z"
        }
      },
      {
        "id": "wQvCDxqKx3hrExuXNGmz",
        "name": "Maurílio Onofre Deininger ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "1989-02-01T03:00:00.000Z",
          "resident_end": "1990-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "PKjfvOcxsrIemox3jl4E",
        "name": "Mauro Barbosa Arruda Filho ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de SP - CNRM/MEC Dr. Denise Terezinha Costa Coord.",
          "resident_begin": "1992-02-01T02:00:00.000Z",
          "resident_end": "1994-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "jhqm6gcngGLkcwa2YrKG",
        "name": "Mauro Cosme Gomes de Andrade ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Hospital Universitário Pedro Ernesto - Dr. José Jazbik Sobrinho",
          "resident_begin": "1981-11-29T03:00:00.000Z",
          "resident_end": "1985-11-29T02:00:00.000Z"
        }
      },
      {
        "id": "RKZ2PoBQYTLNe7SRQBR8",
        "name": "Mayara Baschiera Barbosa",
        "data": {
          "resident_institute": "Faculdade de Medicina do ABC - CNRM/MEC Dr. Andréa Cristina Oliveira Freitas",
          "resident_begin": "2020-03-02T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "CAXRyYBoEGo7TzzuYL31",
        "name": "Melchior Luiz Lima ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca Hosp. BP/SP - Dr. Luiz Boro Puig",
          "resident_begin": "1988-12-01T02:00:00.000Z",
          "resident_end": "1990-07-30T03:00:00.000Z"
        }
      },
      {
        "id": "bLV5BRFJqwEkinXaN4M2",
        "name": "Melina Moroz Barg",
        "data": {
          "resident_institute": "Serv. CCV Inst. Card. Dante Pazzanese - Dr. Mário Issa",
          "resident_begin": "2022-03-03T03:00:00.000Z",
          "resident_end": "2027-03-03T03:00:00.000Z"
        }
      },
      {
        "id": "6DinLDfra7ppL2zswfsD",
        "name": "Michael Hikaru Mikami",
        "data": {
          "resident_institute": "Hospital Santa Casa de Misericórdia de Curitiba - RESPONSÁVEL PELO SERVIÇO: Dr. Claudinei Collatusso",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2027-02-27T03:00:00.000Z"
        }
      },
      {
        "id": "YjzG0LlRQX6pOXH9psPf",
        "name": "Michel Peruzzo",
        "data": {
          "resident_institute": "Hospital Santa Isabel - Instituto do Coração Ltda - Frederico J. Di Giovanni",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "5yruXyzx4lOFOiqBMOqz",
        "name": "Miguel Barbero Marcial ",
        "data": {
          "resident_institute": "Faculdade Nacional de Medicina de Rosário",
          "resident_begin": "1963-01-03T03:00:00.000Z",
          "resident_end": "1964-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "nogq5P5D7b3aSVHF6goW",
        "name": "Milton de Miranda Santoro ",
        "data": {
          "resident_institute": "UFPR",
          "resident_begin": "1992-02-01T02:00:00.000Z",
          "resident_end": "1995-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "QFwWkGvRXk6owLC7YQmw",
        "name": "Murilo Teixeira Macedo ",
        "data": {
          "resident_institute": "Escola Paulista de Medicina - UNIFESP CNRM/MEC - Dr Adagmar Andriolo",
          "resident_begin": "2010-01-31T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "muTdRfCjWN8iFF6l4GeK",
        "name": "Myrian Christiane Krexu Veloso Wisniewski",
        "data": {
          "resident_institute": "Serv. CCV Instituto de Neurologia e Cardiologia de Curitiba - Dr. Francisco Diniz A. da Costa",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "D2cTwd9pATkdowb98vkW",
        "name": "Nadja Cecília de Castro Kraychete ",
        "data": {
          "resident_institute": "Hospital do Coração - Luiz Carlos Bento de Souza",
          "resident_begin": "1986-01-28T02:00:00.000Z",
          "resident_end": "1987-01-13T02:00:00.000Z"
        }
      },
      {
        "id": "UcAoDUapxD6xrNRXpy8s",
        "name": "Náthalie Lorna Rosado Teixeira ",
        "data": {
          "resident_institute": "Hospital Rio Grande/INCOR Natal",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2027-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "ZZvy9XO2JeHDwcOek7oW",
        "name": "Nei Antonio Rey ",
        "data": {
          "resident_institute": "Incor - Dr Adib Jatene",
          "resident_begin": "1971-02-19T03:00:00.000Z",
          "resident_end": "1973-04-30T03:00:00.000Z"
        }
      },
      {
        "id": "CTeVn2laNylUaC1vHRKp",
        "name": "Neimar Gardenal ",
        "data": {
          "resident_institute": "Hospital Universitário da Universidade Federal do Mato Grosso do Sul - José Carlos Dorsa Viera Pontes",
          "resident_begin": "1997-01-01T02:00:00.000Z",
          "resident_end": "2000-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "xBlS67SuCxOdyLWhi7zs",
        "name": "Nelson Américo Hossne Júnior",
        "data": {
          "resident_institute": "UNIFESP/EPM - CNRM/MEC - Dr. Arnaldo Guilherme",
          "resident_begin": "2002-02-01T02:00:00.000Z",
          "resident_end": "2005-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "IyYYFbjLQo9xCag8hQMA",
        "name": "Nelson Barg ",
        "data": {
          "resident_institute": "Hospital Adventista Silvestre - Dr. Ranieri C. leitão",
          "resident_begin": "1981-01-02T03:00:00.000Z",
          "resident_end": "1984-01-02T03:00:00.000Z"
        }
      },
      {
        "id": "zasbdfnuytyCLmecCOlx",
        "name": "Nelson Seixas Júnior",
        "data": {
          "resident_institute": "Serviço CCV Hospital FAMERP - Dr. Antonio Carlos Brandi",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "Vw5qHcLUxmopn3VRLqNG",
        "name": "Nelson Urajo Yamazaki ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca Hosp S. Joquim BP/SP - Dr. Kenji Nakiri",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "0qhPHbRIIKFp5Na5NXvN",
        "name": "Noedir Antonio Groppo Stolf ",
        "data": {
          "resident_institute": "Serv. CCV - FMUSP - CNRM/MEC -",
          "resident_begin": "1966-01-02T02:00:00.000Z",
          "resident_end": "1968-02-28T02:00:00.000Z"
        }
      },
      {
        "id": "Wvs73dSsdiTxoKR1cylN",
        "name": "Norman Eduardo Colina Manzano ",
        "data": {
          "resident_institute": "Hospital Universitário da Universidade Federal do Maranhão - Dr Vinicius José da Silva Nina",
          "resident_begin": "2004-07-01T03:00:00.000Z",
          "resident_end": "2007-07-01T03:00:00.000Z"
        }
      },
      {
        "id": "axmGBvMyamxm7tOWt1w7",
        "name": "Oaidia Adelina Noceti Serman",
        "data": {
          "resident_institute": "Serv. CCV Hospital de Clínicas UFPR - CNRM/MEC - Prof. Dr. Angelo Luiz Tesse",
          "resident_begin": "2003-02-01T02:00:00.000Z",
          "resident_end": "2007-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "oidwrXhtswEYWHL5LMh9",
        "name": "Odilon Nogueira Barbosa ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular do Hospital Servidores do Estado do Rio de Janeiro",
          "resident_begin": "1972-01-03T03:00:00.000Z",
          "resident_end": "1974-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "gFH4bxIDParjfoBkYuLX",
        "name": "Odilon Silva Henrique Júnior ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - José Pedro da Silva",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2003-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "h4ZGxsqoUaysseZ5lscF",
        "name": "Omar Alonzo Pozo Ibanez ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Carlos Gun",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "LGhSU3EWefWIrNY8DH39",
        "name": "Omar Asdrubal Vilca Mejia ",
        "data": {
          "resident_institute": "incor",
          "resident_begin": "2004-01-01T02:00:00.000Z",
          "resident_end": "2008-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "rzjVKZzZnFsDCby8mgzb",
        "name": "Oscar Reynaldo Molina Benitez ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1983-02-01T03:00:00.000Z",
          "resident_end": "1986-03-04T02:00:00.000Z"
        }
      },
      {
        "id": "PgX0Lyn55DYa8bVbycPX",
        "name": "Oscar Willian Bomfim Oliveira",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia CNRM/MEC - Dr. Antoninho Arnoni",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "IyOBTot6ca2BBkjQrfUX",
        "name": "Oswaldo Bezerra Cascudo Filho",
        "data": {
          "resident_institute": "Hospital Rio Grande/INCOR Nata",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2027-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "sfZbgUKRN63KLh6WTeDU",
        "name": "Oswaldo Teno Castilho ",
        "data": {
          "resident_institute": "Hosp. Felício Rocho - Dielson Teixeira Sampaio",
          "resident_begin": "1981-10-08T03:00:00.000Z",
          "resident_end": "1983-10-08T03:00:00.000Z"
        }
      },
      {
        "id": "MEZc1ZunEc9X1BHGVCZ6",
        "name": "Otávio Penna Braga",
        "data": {
          "resident_institute": "Serv. CCV Hospital das Clínicas Universidade Federal de Minas Gerais - CNRM/MEC - Diretor Dr. Antônio Luiz Pinho Ribeiro Coord. Cláudio Gelape",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "5HPhGKwwY07O5Myps0LX",
        "name": "Pabllo Namorato Barros",
        "data": {
          "resident_institute": "Hospital inBiocor - BIOCOR INSTITUTO - Dr. Bayard Gontijo Fº",
          "resident_begin": "2014-03-30T03:00:00.000Z",
          "resident_end": "2018-04-01T03:00:00.000Z"
        }
      },
      {
        "id": "MKgNulfx7pI0kd6D2ZcM",
        "name": "Pâmela Sacalina Camargo ",
        "data": {
          "resident_institute": "Instituto HCOR - CNRM/MEC - Dr. Frederico Carlos Mendonça",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "swv5sDij38nzPP0LGPX0",
        "name": "Paola Keese Montanhesi ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "2010-01-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "f4PrSXplrnlbR6dR8T3x",
        "name": "Patrícia Eduardo Teles Correia ",
        "data": {
          "resident_institute": "INSTITUTO DO CORAÇÃO DE PERNAMBUCO",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "RSJt5wZs4nKxUmU3XEr2",
        "name": "Patricia Ferreira Alves Casimiro",
        "data": {
          "resident_institute": "Universidade Nove de Julho - UNINOVE",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2027-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "8aTzXBSRggPCd8myNKXq",
        "name": "Patrícia Marques de Oliveira ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina - CNRM/MEC - Dr Adib B. Jatene",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2001-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "rkVKoGrKHZcwT5oocDSF",
        "name": "Patrícia Pampuri Lopes Peres ",
        "data": {
          "resident_institute": "Hospital do Coração do MS - Dr Mauro Cosme Gomes de Andrade",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "SwGT19Cck2WFy1MyIFii",
        "name": "Paula Linck de Mello Nesralla",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Jv6FziXZdY54Xyyc0kMP",
        "name": "Paula Maria Carvalho do Lago",
        "data": {
          "resident_institute": "Especialização em CCV no Hosp. Universitário Ciências Médicas - Dr Eduardo Rocha",
          "resident_begin": "2015-04-02T03:00:00.000Z",
          "resident_end": "2019-04-02T03:00:00.000Z"
        }
      },
      {
        "id": "kL5APSHZ6u6APGYa95o1",
        "name": "Paulo Ceratti de Azambuja ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul - Fundação Universidade de Cardiologia - Prof. Dr. Paulo Roberto Prates",
          "resident_begin": "1976-01-20T03:00:00.000Z",
          "resident_end": "1977-12-19T03:00:00.000Z"
        }
      },
      {
        "id": "tdcgkmaT7RopEnIq7Zzl",
        "name": "Paulo Chaccur ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Luiz Carlos Bento de Souza",
          "resident_begin": "1975-01-02T03:00:00.000Z",
          "resident_end": "1978-01-02T03:00:00.000Z"
        }
      },
      {
        "id": "o9CCurNLYUTu8x5StAaJ",
        "name": "Paulo de Tarso do Couto ",
        "data": {
          "resident_institute": "Serviço Equipe do Dr. Sérgio Almeida de Oliveira - Hospital R. B. SPBP",
          "resident_begin": "1982-11-01T03:00:00.000Z",
          "resident_end": "1985-11-30T02:00:00.000Z"
        }
      },
      {
        "id": "LJ2Sd3oAxgzRXShfbJZl",
        "name": "Paulo Eduardo Meneguzzo ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "nJdCKaaeNz7yBsdvTMuW",
        "name": "Paulo Ernando Ferraz Cavalcanti ",
        "data": {
          "resident_institute": "PROCAPE / FCM / UPE - CNRM/MEC Dra Valdecira L. de Lucena",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "3TZS1bc5Jrfh3IL9dElo",
        "name": "Paulo Henrique Caruso ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "HRdMUW15uWDraXMbrrHE",
        "name": "Paulo Henrique Duarte de Lima e Silva ",
        "data": {
          "resident_institute": "Especialização em CCV no Hosp. BPSP - Clínica Cardio-cirurgica JP da Silva - Dr. José Pedro da Silva",
          "resident_begin": "1998-01-01T02:00:00.000Z",
          "resident_end": "2001-12-12T02:00:00.000Z"
        }
      },
      {
        "id": "Q8fDOftCGqIuvUsI8srM",
        "name": "Paulo Henrique Husseini Botelho ",
        "data": {
          "resident_institute": "Hosp. Infante D. Henrique (Hosp. Benef. Portuguesa) João Carlos F. Leal",
          "resident_begin": "1998-03-11T03:00:00.000Z",
          "resident_end": "2003-03-10T03:00:00.000Z"
        }
      },
      {
        "id": "khSZMNahxQmVWpP6UC9K",
        "name": "Paulo Henrique Medeiros Costa ",
        "data": {
          "resident_institute": "Serviço Equipe do Dr. Sérgio Almeida de Oliveira - Hospital R. B. SPBP",
          "resident_begin": "1982-02-01T03:00:00.000Z",
          "resident_end": "1986-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "mp1PTZpmgJamRI5lm4aR",
        "name": "Paulo Henrique Nogueira Costa ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC Coordenador: Dr. Luiz Alberto Bacheschi",
          "resident_begin": "2000-02-01T02:00:00.000Z",
          "resident_end": "2003-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "td9hNzndz6vB885NeAIa",
        "name": "Paulo Lavaniere de Azevedo Moreno ",
        "data": {
          "resident_institute": "Hospital de Clínicas de Porto Alegre",
          "resident_begin": "1993-03-01T03:00:00.000Z",
          "resident_end": "1996-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "3YKHsRROT0UV32P4W7Wm",
        "name": "Paulo Manuel Pêgo-Fernandes ",
        "data": {
          "resident_institute": "Incor - FMUSP CNRM/MEC - Cood. atual Pablo M. A. Pomerantzeff",
          "resident_begin": "1985-01-01T03:00:00.000Z",
          "resident_end": "1987-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "Yu176Jtb6U37kLsLKf9T",
        "name": "Paulo Marcelo Barbosa Mesquita ",
        "data": {
          "resident_institute": "Unidade de Doenças Toracicas Stolf - Dr. Noedir Stolf",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "HpAQ9NQjmjwtFQlGbFXQ",
        "name": "Paulo Roberto Barbosa Evora ",
        "data": {
          "resident_institute": "Serviço CCV - FMRP-USP",
          "resident_begin": "1973-11-05T03:00:00.000Z",
          "resident_end": "1974-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "zhA7Pb6BCAp6Ka9T5EbQ",
        "name": "Paulo Roberto Giublin ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba - Danton R. Rocha Loures",
          "resident_begin": "1985-01-01T03:00:00.000Z",
          "resident_end": "1987-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "LmU4Qtu1eKzjgpwIEjBg",
        "name": "Paulo Roberto Prates ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do RS / Fundação Universitária de Cardiologia",
          "resident_begin": "1970-01-01T03:00:00.000Z",
          "resident_end": "1971-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "MNTt0PEzSWSglNXPwjY3",
        "name": "Paulo Roberto Slud Brofman ",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1972-03-01T03:00:00.000Z",
          "resident_end": "1974-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "KCwxFooT6D3a10j905PQ",
        "name": "Paulo Roberto Soltoski ",
        "data": {
          "resident_institute": "ST Francis Medical Center - Robert Wood Jonhson Medical School",
          "resident_begin": "1996-07-01T03:00:00.000Z",
          "resident_end": "1997-06-30T03:00:00.000Z"
        }
      },
      {
        "id": "oQTbeRU7vUB5Qi76EgU6",
        "name": "Paulo Ruiz Lúcio de Lima",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese se Cardiologia - CNRM/MEC - Paulo Paredes Paulista",
          "resident_begin": "1986-02-01T02:00:00.000Z",
          "resident_end": "1988-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "cfWu4R5n27vJxULCk8yw",
        "name": "Paulo Sérgio Tajra Cortellazzi ",
        "data": {
          "resident_institute": "BP SP - Clínica Stolf - Noedir Stolf",
          "resident_begin": "1983-01-10T03:00:00.000Z",
          "resident_end": "1986-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "LuiM47JCI7Fp39nwuipZ",
        "name": "Pedro Augusto da Costa Bertolin",
        "data": {
          "resident_institute": "Serviço CCV Instituto de Neurologia de Curitiba - Equipe do Dr. Francisco Diniz A. da Costa",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "kCpF1Fmi2ipfeHgxMO5O",
        "name": "Pedro de Araújo Godinho",
        "data": {
          "resident_institute": "Hosp. Vera Cruz - Dr Roney Ronald Peixoto da Silva",
          "resident_begin": "2015-02-02T02:00:00.000Z",
          "resident_end": "2019-02-02T02:00:00.000Z"
        }
      },
      {
        "id": "KuuASxEfrvzOxmCvGBEB",
        "name": "Pedro de Souza Rondinelli ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Porto Alegre",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "Y7YRZxn97HFtIcRvaG19",
        "name": "Pedro Gregori Neto",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Norte do Paraná-Hospital Evangélico de Londrina / Dr. Francisco Gregori Jr",
          "resident_begin": "2019-01-01T02:00:00.000Z",
          "resident_end": "2024-01-01T03:00:00.000Z"
        }
      },
      {
        "id": "deKYKZwN02GOFHJnZHP3",
        "name": "Pedro Henrique Conte ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Cir Cardíaca - Dr. Sergio Almeida de Oliveira",
          "resident_begin": "2013-02-18T03:00:00.000Z",
          "resident_end": "2017-02-18T02:00:00.000Z"
        }
      },
      {
        "id": "ZN1KAAZJRo9SjAhkBS7C",
        "name": "Pedro Henrique Romani Lauand",
        "data": {
          "resident_institute": "Serv. CCV FAMERP CNRM/MEC - Dr. Octavio Ricci Jr",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "P55rsVpSEnRDCQuIAS23",
        "name": "Pedro Henrique Soares",
        "data": {
          "resident_institute": "Instituto Nossa Senhora Aparecida - Umuarama-PR - Dr. Aldo Pesarini",
          "resident_begin": "2023-03-01T03:00:00.000Z",
          "resident_end": "2028-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "fU55AKnmIzO1G2dxwFVy",
        "name": "Pedro Horigoshi Reis ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina CNRM/MEC - Prof. Dr. Alfredo Fiorelli",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "33Bw977aainJtRmZu3sf",
        "name": "Peter Conde Vidal Júnior",
        "data": {
          "resident_institute": "Especialização em CCV na Santa Casa de Misericórdia de Maceió, Inst. de Doenças do Coração - Dr. José Wanderley Neto",
          "resident_begin": "2016-02-28T03:00:00.000Z",
          "resident_end": "2020-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "hxipIvvwZRX7BgKScHgN",
        "name": "Pietro Franchon Marques Cappellari ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Ribeirão Preto Responsável pelo Serviço: Dr Eduardo Cosac Paranhos Estágio",
          "resident_begin": "2010-08-01T03:00:00.000Z",
          "resident_end": "2014-07-31T03:00:00.000Z"
        }
      },
      {
        "id": "10V4WtE8zo0IGhBTY67B",
        "name": "Poliana Maziero Monge ",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Porto Alegre ia.....: 28/02/2024 Dra Marcela Sales",
          "resident_begin": "2019-01-01T02:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "9GUmwEh73xxy9MmWafSL",
        "name": "Pompílio Sampaio Britto ",
        "data": {
          "resident_institute": "Residencia: Beneficência Portuguesa de São Paulo. Responsável: Dr. Noedir Stof. Início",
          "resident_begin": "2010-01-01T02:00:00.000Z",
          "resident_end": "2015-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "b8kWLgAiNlBUBxjMHRbx",
        "name": "Portiuncola Gorini",
        "data": {
          "resident_institute": "Instituto de Cardiologia de Santa Catarina - CNRM/ME Jamil Schneider",
          "resident_begin": "2001-03-01T03:00:00.000Z",
          "resident_end": "2004-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "UusZttGetujwqTczqfa8",
        "name": "Priscila Paulina Gonçalves da Silveira ",
        "data": {
          "resident_institute": "Serv CCV BPSP Equipe Dr Januário - Dr Januário M de Souza",
          "resident_begin": "2014-02-01T02:00:00.000Z",
          "resident_end": "2018-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "PjftICkthHR2ZlFh7YnO",
        "name": "Rafael Albino Lencioni ",
        "data": {
          "resident_institute": "Cirurgia Cardiovascular no Real Benemérita Associação Portuguesa de Beneficência - preceptoria do Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "9tel4Ap9Ce1uSJLJMlbq",
        "name": "Rafael Angelo Tineli ",
        "data": {
          "resident_institute": "InCor-FMUSP",
          "resident_begin": "2007-01-01T02:00:00.000Z",
          "resident_end": "2011-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "eIzqT8V6SF6gHpilL5Id",
        "name": "Rafael Antonio Widholzer Rey ",
        "data": {
          "resident_institute": "Hospital Nossa Senhora da Conceição RS",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2003-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "fU6z6ZhUp5eVbNeq4sfw",
        "name": "Rafael Aon Moysés ",
        "data": {
          "resident_institute": "hospital do coração",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "wXmQkyULd1EFSJD5BevY",
        "name": "Rafael Augusto da Silva Moratto",
        "data": {
          "resident_institute": "Serviço CCV FAMERP - CNRM/MEC Coord. Dr. Antônio Carlos Brandi",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "ni9MU4cLA4XslLcnauSA",
        "name": "Rafael Catoni Santoro",
        "data": {
          "resident_institute": "Instituto de Cirurgia do Coração de Londrina - Dr Kengo Baba (mais de 8 anos)",
          "resident_begin": "2005-01-02T02:00:00.000Z",
          "resident_end": "2019-11-30T03:00:00.000Z"
        }
      },
      {
        "id": "lSsXFE1HuWPLTvuBhfUc",
        "name": "Rafael de Oliveira Ceron ",
        "data": {
          "resident_institute": "InCor-Fundação Universitária de Cardiologia - CNRM/MEC - Dr Ivo A. Nesralla",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "qtTtCFIqtYutduuELdW8",
        "name": "Rafael Dib de Paulo Tajra",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - IDPC",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "YSlxzh9JFcNBbP8uFQ3M",
        "name": "Rafael Diniz Abrantes ",
        "data": {
          "resident_institute": "Hospital Madre Teresa - Preceptor Responsável: Rodrigo Bernardes",
          "resident_begin": "2008-01-03T02:00:00.000Z",
          "resident_end": "2012-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "Ndi5ALOUaG6FaUkUGmM6",
        "name": "Rafael do Amor Xavier",
        "data": {
          "resident_institute": "Serv CCV Unidade Cardiotorácica Fundação Beneficência Hospital de Cirurgia - Dr José Teles de Mendonça",
          "resident_begin": "2012-01-02T02:00:00.000Z",
          "resident_end": "2016-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "Qm8rvO9Zor3MaOGaqafR",
        "name": "Rafael Geraldo Leão ",
        "data": {
          "resident_institute": "Hosp. Madre Teresa - Dr Rodrigo de Castro Bernardes",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ZUqdAfpdIdEOELT5kYYh",
        "name": "Rafael Guimarães Vianna",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - IDPC CNRM/MEC - Dr. Daniel Dantas",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ZNlFpcMeMejJYDJbWUfZ",
        "name": "Rafael Haddad ",
        "data": {
          "resident_institute": "Serv. CCV no Hospital Santa Genoveva - Aleksander Dobrianskyj",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2003-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "B4QKLD0pcUDJhPrmRRWB",
        "name": "Rafael Otto Schneidewind ",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - BPSP - Profº. Dr. Sergio A de Oliveira",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "OJwFBZj3WOcQrXPasD2p",
        "name": "Rafaela da Hora Sales Quintella Cavalcanti ",
        "data": {
          "resident_institute": "Santa casa de Misericordia de Maceio - Dr Jose Wanderley Neto",
          "resident_begin": "2014-02-03T02:00:00.000Z",
          "resident_end": "2018-02-03T02:00:00.000Z"
        }
      },
      {
        "id": "TQsbkusIwkxG8n4m6OcI",
        "name": "Raffael Espin Ota",
        "data": {
          "resident_institute": "Serv. CCV Beneficência Portuguesa SP - Equipe do Dr. Januário Manoel de Souza",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "iEe3B08DMQMiMxSwa1ir",
        "name": "Raiane Pereira ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC Coordenador: Alfredo Inácio Fiorelli",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "GEOJ5NVoSmpwjWzvJwT5",
        "name": "Raimundo de Barros Araújo Júnior ",
        "data": {
          "resident_institute": "Hospital Santa Maria / Clinicor Clinica de Serv. Médicos e Cardiologicos LTDA Dr Marcelo Nunes - (mais de 8 anos)",
          "resident_begin": "2000-03-01T03:00:00.000Z",
          "resident_end": "2019-11-28T03:00:00.000Z"
        }
      },
      {
        "id": "cVRfg3F6lBbBzK8swi8S",
        "name": "Ralf Stuermer ",
        "data": {
          "resident_institute": "Ir. Santa Casa de Misericórdia de Porto Alegre",
          "resident_begin": "1998-01-01T02:00:00.000Z",
          "resident_end": "2000-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "Ko8mCzlnztGuP8ph66s4",
        "name": "Rangel Silva Martins de Queiroz",
        "data": {
          "resident_institute": "Universidade Nove de Julho (UNINOVE)",
          "resident_begin": "2021-01-01T03:00:00.000Z",
          "resident_end": "2026-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "gUy7M0aFSvOGye35f9PC",
        "name": "Ranieri Meirelis Rocha ",
        "data": {
          "resident_institute": "Incor - FMUSP/CNRM-MEC - Dr Alfredo Inácio Fiorelli",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "84D35aCRSm8n0c7INV09",
        "name": "Ranniere Gurgel Furtado de Aquino",
        "data": {
          "resident_institute": "Serviço CCV Hospital De Messejana Dr Carlos Alberto Studart Gomes - CNRM/MEC - Dr Acrisio S. Valente / Dr Francisco Rodrigues",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "K67ugS4cuYPoz6XQJYdJ",
        "name": "Raony Previtalli Paniquar ",
        "data": {
          "resident_institute": "Hospital Universitário da Universidade Federal do Mato Grosso Sul - Dr. Ricardo Adala Benfatti",
          "resident_begin": "2011-01-03T02:00:00.000Z",
          "resident_end": "2014-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "9SWKnvKtFsCB4u9B0fHW",
        "name": "Raphael Lira Guterman ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina - CNRM/MEC - Alfredo Fiorelli",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "DGTBvAE7NBLGcZEaPqxa",
        "name": "Raphael Quintana Pereira ",
        "data": {
          "resident_institute": "Incor Rio Grande do Sul - CNRM/MEC Dr Marne de Freitas Gomes",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "wrcfPQUOJUyKdn1nrF2D",
        "name": "Raquel Cristina Villar Barroso",
        "data": {
          "resident_institute": "Hospital das Clínicas - Universidade Federal de Minas Gerais - CNRM/MEC -",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "C94LtHfX2nQs7a4Pyf4t",
        "name": "Raúl Armando Micalay Paredes",
        "data": {
          "resident_institute": "Intituto Dante Pazzanese de Cardiologia - Dra Magaly Arrais",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "hlZQJcKL3oP7cxqVIGWq",
        "name": "Raul Gaston Sanchez Mas ",
        "data": {
          "resident_institute": "Candidato apresentou documento com mais de 8 anos de atuação - 2007 Climac Argentina, 2009 a 2010 Unifesp e desde 2013 Hospital São Vicente JundiaíSP",
          "resident_begin": "2007-01-01T02:00:00.000Z",
          "resident_end": "2018-11-13T02:00:00.000Z"
        }
      },
      {
        "id": "gvij9QyFYZhyE0UOH2RI",
        "name": "Ravi Azevedo Bernardes ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Madre Teresa - Dr. Rodrigo Bernardes de Castro",
          "resident_begin": "2014-02-03T02:00:00.000Z",
          "resident_end": "2018-02-03T02:00:00.000Z"
        }
      },
      {
        "id": "bQxWQQut7uWZLhTCUsMG",
        "name": "Rayssa de Sousa Gois",
        "data": {
          "resident_institute": "Serv. CCV Instituto de Neurologia e Cardiologia de Curitiba - Dr. Francisco Diniz A. da Costa",
          "resident_begin": "2022-03-01T03:00:00.000Z",
          "resident_end": "2027-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "ZpdrdiUdGtRbKeEx2cbM",
        "name": "Reginaldo Pereira de Castro ",
        "data": {
          "resident_institute": "Santa Casa de Rib. Preto - Eduardo Cosac",
          "resident_begin": "1996-01-02T02:00:00.000Z",
          "resident_end": "2000-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "y48upFK4XWbMwt0iawCq",
        "name": "Rêmulo José Rauen Júnior",
        "data": {
          "resident_institute": "Hospital Nossa Senhora das Graças - CNRM/MEC - Roberto de Carvalho",
          "resident_begin": "2003-01-05T02:00:00.000Z",
          "resident_end": "2006-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "iFjYoqp39UW6T96Mt6P6",
        "name": "Renan Pontes Petinelli ",
        "data": {
          "resident_institute": "Serv. CCV Hospital Santa Casa de Londrina CNRM/MEC - Dr. Arnaldo Okino",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "h27D2sKLjCeyoK0uQ3Jc",
        "name": "Renan Prado Límaco ",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - BPSP - Profº. Dr. Sergio A de Oliveira",
          "resident_begin": "2000-02-01T02:00:00.000Z",
          "resident_end": "2003-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "kY5v8vQsYHz6oZIJmn53",
        "name": "Renata Pereira Esteves de Jesus ",
        "data": {
          "resident_institute": "Instituto Nascional de Cardiologia RJ - CNRM/MEC - José Oscar Reis Brito",
          "resident_begin": "2013-04-30T03:00:00.000Z",
          "resident_end": "2017-04-29T03:00:00.000Z"
        }
      },
      {
        "id": "ZebI3mSmhsWZHYTKRcsw",
        "name": "Renato Abdala Karam Kalil ",
        "data": {
          "resident_institute": "Fundação Universitária de Cardiologia - CNRM/MEC Dr. João Antônio Corrêa",
          "resident_begin": "1971-01-01T03:00:00.000Z",
          "resident_end": "1973-09-20T03:00:00.000Z"
        }
      },
      {
        "id": "yyUucBmHE2M5T48sL1LK",
        "name": "Renato Antonio Del Bianco ",
        "data": {
          "resident_institute": "Santa Casa de Ribeirão Preto/ Instituto do Coração - Dr. Oswaldo Castilho",
          "resident_begin": "1990-01-01T02:00:00.000Z",
          "resident_end": "1992-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "U75AfgIWBMJIX8J6CWzb",
        "name": "Renato Bastos Pope ",
        "data": {
          "resident_institute": "Hospital NS das Graças - CNRM/MEC -",
          "resident_begin": "2002-01-05T02:00:00.000Z",
          "resident_end": "2005-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "esB6KSaVUwhgsmI2VwGu",
        "name": "Renato Bauab Dauar ",
        "data": {
          "resident_institute": "Unidade de Doenças Toracicas Stolf - Dr. Noedir Stolf",
          "resident_begin": "1991-01-02T02:00:00.000Z",
          "resident_end": "1995-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "7wOWHMbqEWQJomCzhcEp",
        "name": "Renato Bráulio ",
        "data": {
          "resident_institute": "Hospital Felicio Rocho - CNRM/MEC- Angelo P. Macedo Coord. Coreme",
          "resident_begin": "2002-01-02T02:00:00.000Z",
          "resident_end": "2005-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "pca9g31pHDMovLQnmXci",
        "name": "Renato Cesar de Souza ",
        "data": {
          "resident_institute": "Instituto do Coração/USP - CNRM/MEC Coordenador: Alfredo Inácio Fiorelli",
          "resident_begin": "2016-03-01T03:00:00.000Z",
          "resident_end": "2020-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "4bDIWuAi1efKpD8IrlEH",
        "name": "Renato Max Faria ",
        "data": {
          "resident_institute": "Clínica Cardio-Cirurgia J.P. da Silva",
          "resident_begin": "2009-01-01T02:00:00.000Z",
          "resident_end": "2013-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "ufR533teXfSp6AwhDGcd",
        "name": "Renato Morais Araujo",
        "data": {
          "resident_institute": "Serv. em CCV Hospital Madre Teresa - Dr Rodrigo de Castro Bernardes",
          "resident_begin": "2015-03-01T03:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "dSLHPzKH0oiuukq43W10",
        "name": "Renato Samy Assad ",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - Dr. Sergio A Oliveira",
          "resident_begin": "1985-01-02T03:00:00.000Z",
          "resident_end": "1987-02-11T02:00:00.000Z"
        }
      },
      {
        "id": "8Map0XjSF9QFrEjbJ8Uj",
        "name": "Renato Tambellini Arnoni ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1998-02-01T02:00:00.000Z",
          "resident_end": "2001-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "JUoLceN6nVddGAiBiJzn",
        "name": "Ricardo Adala Benfatti ",
        "data": {
          "resident_institute": "Serv. Cir.Torácica NHU-UFMS - José Carlos Dorsa V. Pontes",
          "resident_begin": "2002-01-02T02:00:00.000Z",
          "resident_end": "2005-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "QSshnDERt5TfEgyewOjg",
        "name": "Ricardo Barros Corso ",
        "data": {
          "resident_institute": "Instituto do Coração do Hospital das Clínicas da FMUSP",
          "resident_begin": "1993-02-01T03:00:00.000Z",
          "resident_end": "1996-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "9ZKlavdg3y3pAm1VyHLB",
        "name": "Ricardo das Neves ",
        "data": {
          "resident_institute": "Clinica Paulista Terapêutica Cardiovascular - Hospital BP/SP - Ricardo F. Azevedo Melo",
          "resident_begin": "2008-02-02T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "2pNWvS8bMLSSIkc6Cptx",
        "name": "Ricardo Eloy Pereira ",
        "data": {
          "resident_institute": "Serv. CCV - Instituto de Cardiologia de SP - Dr. Luiz Carlos Bento de Souza",
          "resident_begin": "1973-02-01T03:00:00.000Z",
          "resident_end": "1974-08-31T03:00:00.000Z"
        }
      },
      {
        "id": "nreL4X3kvmJVZ6Gs05wq",
        "name": "Ricardo Estéfano Germano ",
        "data": {
          "resident_institute": "Hospital Madre Teresa - Dr. Ricardo Bernardes de Castro",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Gmu1nr8JtWOLUB9YK6rx",
        "name": "Ricardo Fabian Gonzalez Fiandro",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Luis Carlos Bento de Souza",
          "resident_begin": "2006-02-01T02:00:00.000Z",
          "resident_end": "2010-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "31vhJSp1Mbrc88Ld13or",
        "name": "Ricardo José Choma ",
        "data": {
          "resident_institute": "Hosp. Clínicas UFPR - Danton Loures",
          "resident_begin": "1988-02-02T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Q2IxHUqxWnmd6YOp7z6L",
        "name": "Ricardo Kazunori Katayose ",
        "data": {
          "resident_institute": "Cirurgia Cardiovascular no Real Benemérita Associação Portuguesa de Beneficência - preceptoria do Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "yVkbNbQKfmICse6cLJ0R",
        "name": "Ricardo Lage Guerra Lott Pires ",
        "data": {
          "resident_institute": "Serv. CCV Hospital Madre Teresa - Dr. Fernando Antonio Roquette Reis Filho",
          "resident_begin": "2022-08-01T03:00:00.000Z",
          "resident_end": "2027-08-01T03:00:00.000Z"
        }
      },
      {
        "id": "8fMnEpRrboOOKgdzZb4a",
        "name": "Ricardo Miguel G. Carvalho Francisco ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Paulo Paredes Paulista",
          "resident_begin": "1982-02-01T03:00:00.000Z",
          "resident_end": "1985-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "9k0EGRTP67Xcz878MBZa",
        "name": "Ricardo Ribeiro Dias ",
        "data": {
          "resident_institute": "Incor/FMUSP - Hospital das Clínicas - Prof. Geraldo Vergnelli",
          "resident_begin": "1994-02-01T02:00:00.000Z",
          "resident_end": "1997-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "WzBtxoMAHXitrP7Pwv6q",
        "name": "Ricardo Riet Vargas Langenegger ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul - CNRM/MEC Karen Kauffmann da Silva",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "y2v21lAwaF8c6cxNLloj",
        "name": "Ricardo Siqueira Goncalves ",
        "data": {
          "resident_institute": "Serv. CCV Faculdade de Medicina do ABC Centro Universitário CNRM/MEC - Coord. Dr. Alexandre Cruz Henriques",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "HGZkozWwRpK3iFbgNLdH",
        "name": "Rika Kakuda Costa ",
        "data": {
          "resident_institute": "Hospital das Clínicas - Dr. Augusto Leite - Aracaju / Sergipe",
          "resident_begin": "1982-01-02T03:00:00.000Z",
          "resident_end": "1984-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "AWoruns510uO8qD4qj8J",
        "name": "Roberto Augusto Carneiro de Mesquita Lobo ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Porto Alegre - CNRM/MEC- Dr. Jaques Baeatletruk",
          "resident_begin": "2000-01-01T02:00:00.000Z",
          "resident_end": "2002-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "aXVRgQX86zb6TDVDnbC5",
        "name": "Roberto Cardoso Barroso ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1988-01-31T02:00:00.000Z",
          "resident_end": "1991-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "p3icsNmj9hpWGbK7yXhm",
        "name": "Roberto Catani",
        "data": {
          "resident_institute": "UNIFESP/EPM - Dr. Costabile Gal Lucci",
          "resident_begin": "1970-02-01T03:00:00.000Z",
          "resident_end": "1972-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "akUPKrpWe1E9PFpHU5Bm",
        "name": "Roberto Costa ",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo - CNRM/ME - Dra. Helena M. Nese",
          "resident_begin": "1978-02-02T03:00:00.000Z",
          "resident_end": "1980-01-30T03:00:00.000Z"
        }
      },
      {
        "id": "GIPCggnaV6yPlV46tIWr",
        "name": "Roberto Galhardo ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Norte do Paraná - Dr. Francisco Gregori Jr",
          "resident_begin": "1987-08-13T03:00:00.000Z",
          "resident_end": "1990-06-11T03:00:00.000Z"
        }
      },
      {
        "id": "87zqmcFtJ9GNHX8PujS0",
        "name": "Roberto Gomes de Carvalho",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1974-01-02T03:00:00.000Z",
          "resident_end": "1976-01-02T03:00:00.000Z"
        }
      },
      {
        "id": "F96rA9iIVVENfC54KcBy",
        "name": "Roberto Gouvêa Silva Diniz",
        "data": {
          "resident_institute": "Equipe PROCAPE - Dr. Pedro Augusto Casé da Silva (mais de 8 anos)",
          "resident_begin": "2006-01-01T02:00:00.000Z",
          "resident_end": "2019-11-30T03:00:00.000Z"
        }
      },
      {
        "id": "h4QpYB1e2aIslAE3enEO",
        "name": "Roberto Santos Saraiva ",
        "data": {
          "resident_institute": "Hospital Santa Casa de Campo Grande - João Jazbik Neto",
          "resident_begin": "2008-02-04T02:00:00.000Z",
          "resident_end": "2012-02-06T02:00:00.000Z"
        }
      },
      {
        "id": "PIQdHi4gVfur4BzudaOt",
        "name": "Roberto Vito Ardito ",
        "data": {
          "resident_institute": "Instituto de Moléstias Cardiovasculares - Dr. Domingo M. Braile",
          "resident_begin": "1974-08-20T03:00:00.000Z",
          "resident_end": "1978-07-10T03:00:00.000Z"
        }
      },
      {
        "id": "pMi090p1FjQBUqcaXGFD",
        "name": "Robinson Bertoncini ",
        "data": {
          "resident_institute": "Instituto de Cirurgia do Coração de Londrina - Dr. Roberto Takeda",
          "resident_begin": "1998-12-02T02:00:00.000Z",
          "resident_end": "2002-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "VfFO3FTnWduNYdCq9nCY",
        "name": "Robinson Poffo ",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Curitiba Hospital de Caridade - Coord Dr. Milton Cesar Scaramuzza",
          "resident_begin": "1993-01-10T02:00:00.000Z",
          "resident_end": "1997-01-10T02:00:00.000Z"
        }
      },
      {
        "id": "IuBqLMTEmQm7BdKlDIKK",
        "name": "Robson de Souza Almeida Júnior",
        "data": {
          "resident_institute": "Serv. CCV Hospital das Clínicas da UFMG CNRM/MEC - Coord. Dra Marilene de Castro Vale Monteiro",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "ZBwUyy4AUoC9sSnQt51a",
        "name": "Robson Oliveira Cerqueira ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Felício Rocho - Dr. Dielson Teixeira Sampaio",
          "resident_begin": "2011-06-05T03:00:00.000Z",
          "resident_end": "2015-04-05T03:00:00.000Z"
        }
      },
      {
        "id": "J9wk3uvN01XRrfSMMBEQ",
        "name": "Rochele Lorenzi Pol ",
        "data": {
          "resident_institute": "Sta Casa de Curitiba - Serv. Dr. Francisco Costa",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "WUQXWzTmXhYSBY7r3Kpv",
        "name": "Rodolfo Folchini Gomes ",
        "data": {
          "resident_institute": "Instituto de Cardiologia de Santa Cataria CNRM/MEC - Armando Valdomiro Pereira Fontoura",
          "resident_begin": "2014-03-06T03:00:00.000Z",
          "resident_end": "2018-03-05T03:00:00.000Z"
        }
      },
      {
        "id": "NTVn2838RvhOXSqQ7agS",
        "name": "Rodolfo Guillermo Vigil Verastégui ",
        "data": {
          "resident_institute": "Hospital de Clínicas da UFMG",
          "resident_begin": "1984-01-15T03:00:00.000Z",
          "resident_end": "1988-01-15T02:00:00.000Z"
        }
      },
      {
        "id": "VahWNwZzQWk4rqa5uuZ0",
        "name": "Rodrigo Bahia Vasconcelos ",
        "data": {
          "resident_institute": "Serviço CCV Faculdade de Ciências Médicas/Hosp. Felício Rocho - Equipe Dr. Dielson Teixeira Sampaio",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "tHqDojmyXOjvWTwUc3OD",
        "name": "Rodrigo de Castro Bernardes ",
        "data": {
          "resident_institute": "Hospital e Maternidade Santa Rita S/A - Raul Corrêa Rabelo",
          "resident_begin": "1980-02-02T03:00:00.000Z",
          "resident_end": "1982-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "tTSG956F1D7kvRqE2par",
        "name": "Rodrigo Freire Bezerra",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - Preceptor Responsável: Dr. José Pedro da Silva",
          "resident_begin": "1999-01-02T02:00:00.000Z",
          "resident_end": "2002-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "28CRVKgX9ysK6UVb5vlP",
        "name": "Rodrigo Jardim Pierin ",
        "data": {
          "resident_institute": "Hospital Santa Casa de Misericordia de Curitiba - Dr Paulo Brofmann",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "HetjI5Tc5XijA3nBPqFJ",
        "name": "Rodrigo Luiz Rocha Cardoso ",
        "data": {
          "resident_institute": "Serviço CCV Universidade do Estado do Rio de Janeiros - Hospital Universitário Pedro Ernesto CNRM/MEC - Coord. João José Abrahão Caramez",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "2ge2KpsXubbgQUJ0jQ0H",
        "name": "Rodrigo Lunelli de Freitas ",
        "data": {
          "resident_institute": "Sta Casa de Curitiba - Francisco Costa",
          "resident_begin": "2007-02-01T02:00:00.000Z",
          "resident_end": "2011-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "bSsDSpL26M8wanj5vuGn",
        "name": "Rodrigo Moreira Castro ",
        "data": {
          "resident_institute": "Hosp. Beneficencia Portuguesa - SP - CNRM/MEC - Dr. Gláucio Forlanetto",
          "resident_begin": "2003-02-03T02:00:00.000Z",
          "resident_end": "2004-12-15T02:00:00.000Z"
        }
      },
      {
        "id": "3s109UpEWYUNQutdWY9L",
        "name": "Rodrigo Oliveira Rosa Ribeiro de Souza ",
        "data": {
          "resident_institute": "Hospital das Clínicas - Universidade Federal do Paraná - CNRM/MEC - Dr Danton Richlin da Rocha Loures",
          "resident_begin": "2005-03-01T03:00:00.000Z",
          "resident_end": "2009-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "TU9UT1G3VHTpzFeTj1x3",
        "name": "Rodrigo Pereira Paez ",
        "data": {
          "resident_institute": "UNIFESP/EPM - CNRM/MEC - Dr. Arnaldo Guilherme",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "MTjuT15aXjKFibPaeyGT",
        "name": "Rogério Alves Pereira ",
        "data": {
          "resident_institute": "Beneficiência Portuguesa de São Paulo",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2005-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "J8MkskxJgfFnNrA6Vrza",
        "name": "Rogério de Paula Garcia Caravante ",
        "data": {
          "resident_institute": "Faculdade de Medicina de São José do Rio Preto - CNRM - Coordenador: Marcelo José Ferreira Soares",
          "resident_begin": "2002-02-01T02:00:00.000Z",
          "resident_end": "2005-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "1Yt2q59uHYGbH4Gszx9m",
        "name": "Rogério de Souza Abrahão ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul - Fundação Universidade de Cardiologia/CNRM-MEC - Prof. Dr. Ivo A. Nesralla",
          "resident_begin": "1990-01-01T02:00:00.000Z",
          "resident_end": "1992-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "7d0Yn3HYvs193QNeJ3ft",
        "name": "Rogério Ferrari Peron ",
        "data": {
          "resident_institute": "Beneficência Portuguesa Serviço: Prof. Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "ehrM5SRwv3rRUFjxmmgC",
        "name": "Rogério Sbroggio",
        "data": {
          "resident_institute": "Serviço de CCV na Faculdade de Med. de São José do Rio Preto - CNRM/MEC - Coord. Dr. Marcelo José Ferreira Soares",
          "resident_begin": "2014-03-01T03:00:00.000Z",
          "resident_end": "2018-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "4DzEox5JVXbTaeRQOzkK",
        "name": "Rolf Francisco Bub ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "1974-02-01T03:00:00.000Z",
          "resident_end": "1977-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "A7jqjS8rC7rBiqvdwK9b",
        "name": "Romullo Medeiros Santos",
        "data": {
          "resident_institute": "Faculdade de Medicina da Universidade de São Paulo/InCor - HCFMUSP CNRM/MEC - DR. Alfredo Fiorelli / Dr. Fábio Jatene",
          "resident_begin": "2018-03-01T03:00:00.000Z",
          "resident_end": "2023-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "itXzdpYWGmRbIx1k3tdE",
        "name": "Rômulo César Arnal Bonini",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor Dr. Paulo Paredes Paulista",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "uM12BjbOmKcpmgchH7pw",
        "name": "Rômulo Soares Teixeira ",
        "data": {
          "resident_institute": "Serv. CCV Hosp. São Francisco de Assis - Dr. José Augusto Ferreira",
          "resident_begin": "2015-06-15T03:00:00.000Z",
          "resident_end": "2019-06-14T03:00:00.000Z"
        }
      },
      {
        "id": "c1pZ5bbdPvWsLRmRLPyv",
        "name": "Ronald Paulo Pinto Zart ",
        "data": {
          "resident_institute": "PUC RS",
          "resident_begin": "1991-01-02T02:00:00.000Z",
          "resident_end": "1993-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "2P5sB0hUpZwpUaAScd6H",
        "name": "Ronaldo Honorato Barros Santos",
        "data": {
          "resident_institute": "Serv. CCV. Instituto do Coração do Hospital das Clínicas FMUSP CNRM/MEC - Dr. Equipe Dr. Alfredo Fiorelli",
          "resident_begin": "1996-02-12T03:00:00.000Z",
          "resident_end": "1999-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "AVkDCdr1rxV5Pj5Edxyj",
        "name": "Roney Ronald Peixoto da Silva ",
        "data": {
          "resident_institute": "Serv CCV - Hospital Vera Cruz Belo Horizonte",
          "resident_begin": "1976-03-02T03:00:00.000Z",
          "resident_end": "1977-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "K6StEb3NoDwLcXeLoneb",
        "name": "Rosilene Barroso Caetano ",
        "data": {
          "resident_institute": "universidade Estadual de Campinas - Faculdade de Ciências Medicas - Reinaldo Wilson Vieira",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "S9zmUmwliYvoh8vL0eTa",
        "name": "Rubens Giambroni Filho ",
        "data": {
          "resident_institute": "Hospital Força Aérea do Galeão - CNRM/MEC - Eumenes Cysne",
          "resident_begin": "1980-01-31T03:00:00.000Z",
          "resident_end": "1983-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "ihjp2weCyOgHBhYgV64h",
        "name": "Rubens Lorentz Araújo ",
        "data": {
          "resident_institute": "Hospital São Lucas da PUCRS - Dr. Marco Antônio Goldani",
          "resident_begin": "1983-01-02T03:00:00.000Z",
          "resident_end": "1984-12-30T03:00:00.000Z"
        }
      },
      {
        "id": "n9Z6BDJ50t5jBtPyY8Bb",
        "name": "Rubens Tofano de Barros ",
        "data": {
          "resident_institute": "Inst. D. Cardio Pulm. Zerbini - Preceptor atual: Eduardo Coelho Souza",
          "resident_begin": "1979-01-15T03:00:00.000Z",
          "resident_end": "1980-01-15T03:00:00.000Z"
        }
      },
      {
        "id": "z0A5dyA1Ri3IHj75mAql",
        "name": "Rubio Bombonato ",
        "data": {
          "resident_institute": "Hospital São Francisco Soc. LTDA - Serv. Cirurgia Cardíaca de Reibeirão Preto - Dr. José Carlos Franco Brasil",
          "resident_begin": "1982-02-01T03:00:00.000Z",
          "resident_end": "1985-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "pHopGlaMmGboS9s4ZJPk",
        "name": "Rui Manuel de Sousa Sequeira Antunes de Almeida ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba - Danton Loures",
          "resident_begin": "1981-01-18T03:00:00.000Z",
          "resident_end": "1984-12-20T03:00:00.000Z"
        }
      },
      {
        "id": "TNegaNCo8I6SdabN45Gc",
        "name": "Samuel Padovani Steffen ",
        "data": {
          "resident_institute": "Universidade de São Paulo - CNRM/MEC - Dr. Alfredo Fiorelli",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "uImyU0A3SiXEIxiRFlED",
        "name": "Samuel Soares Eduardo ",
        "data": {
          "resident_institute": "Hospital de Messejana Dr. Carlos Albert Studart Gomes - CNRM/MEC - Coord: Francisco Rodrigues dos Santos Neto",
          "resident_begin": "2004-02-01T02:00:00.000Z",
          "resident_end": "2008-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "zf0c4WJ8cyH6CQBfkp5N",
        "name": "Sandra Helena Goncalves de Andrade ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Hospital Universitário Pedro Ernesto - Dr. José Jazbik Sobrinho",
          "resident_begin": "1981-11-29T03:00:00.000Z",
          "resident_end": "1985-11-29T02:00:00.000Z"
        }
      },
      {
        "id": "GA6Ncov8tW6bXJW5541J",
        "name": "Sandro Valério Fadel ",
        "data": {
          "resident_institute": "Hospital Santa Isabel - Serv. de CCV - Everton Luz Varella",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2006-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "43TMeF9nTVFf0cu4nL8R",
        "name": "Sara Fernanda Gomes de Lima Frazão ",
        "data": {
          "resident_institute": "Hospital de força Áerea do Galeão",
          "resident_begin": "2021-03-01T03:00:00.000Z",
          "resident_end": "2026-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "ns70xi8KQpCChvEDYkAN",
        "name": "Sarah Neves Batista ",
        "data": {
          "resident_institute": "Universidade Nove de Julho Osasco ( Uninove )",
          "resident_begin": "2022-01-01T03:00:00.000Z",
          "resident_end": "2027-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "nwPjfm9A9X2BaMSMsD9Q",
        "name": "Savério Angrisani Neto ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - CNRM/MEC Preceptor atual Dr. Paulo Paredes Paulista",
          "resident_begin": "1980-02-01T03:00:00.000Z",
          "resident_end": "1982-06-18T03:00:00.000Z"
        }
      },
      {
        "id": "evmpcibU3ijITPW6GAB2",
        "name": "Sckandar Mussi Júnior",
        "data": {
          "resident_institute": "Beneficência Portuguesa Serviço: Prof. Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2004-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "V76S0VQ0HqvtRkWrTsYG",
        "name": "Sérgio Augusto Fudaba Curcio ",
        "data": {
          "resident_institute": "Serviço de CCV BPSP Equipe do Dr. Januário Manuel de Souza",
          "resident_begin": "2013-02-18T03:00:00.000Z",
          "resident_end": "2017-02-18T02:00:00.000Z"
        }
      },
      {
        "id": "8saOxTwggiNq1JM4UYgn",
        "name": "Sérgio Augusto Veiga Lopes",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Santa Casa de Curitiba - Francisco Diniz A. Costa",
          "resident_begin": "2001-02-01T02:00:00.000Z",
          "resident_end": "2003-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "N0o4B4PhcsYX8zMoLbFR",
        "name": "Sérgio Caporali de Oliveira ",
        "data": {
          "resident_institute": "Fundação Educacional Lucas Machado / Hospital Felício Rocho - CNRM/MEC -",
          "resident_begin": "1991-01-02T02:00:00.000Z",
          "resident_end": "1994-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "5q4e8ZV6KSSHFKZhPVit",
        "name": "Sérgio da Costa Rayol",
        "data": {
          "resident_institute": "Serv CCV BPSP Equipe do Dr Paulo Paulista",
          "resident_begin": "1985-08-01T03:00:00.000Z",
          "resident_end": "1988-08-01T03:00:00.000Z"
        }
      },
      {
        "id": "bj7oQ2fxfPdxktst0LvS",
        "name": "Sérgio Figueiredo Campos Christo ",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca - Dr. Sergio A Oliveira",
          "resident_begin": "1988-01-02T02:00:00.000Z",
          "resident_end": "1989-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "ThV5wKk60ERXMcvhChfj",
        "name": "Sérgio Francisco dos Santos Júnior ",
        "data": {
          "resident_institute": "Beneficência Portuguesa de São Paulo",
          "resident_begin": "2007-01-01T02:00:00.000Z",
          "resident_end": "2011-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "Uxn3V6iLOPsIBL12YtoQ",
        "name": "Sergio Goldman",
        "data": {
          "resident_institute": "Instituto do Coração - Fundação Zerbini - Dr. Ricardo F. A. Melo",
          "resident_begin": "1979-01-01T03:00:00.000Z",
          "resident_end": "1982-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "1sRBX2OvshSSNxP35bWs",
        "name": "Sérgio Lima de Almeida ",
        "data": {
          "resident_institute": "Hospital BP/SP S. Oliveira Cir. Cardíaca - Responsável Sergio A Oliveira",
          "resident_begin": "1987-01-18T02:00:00.000Z",
          "resident_end": "1989-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "YQs4GVRdWFTADIkM2CJX",
        "name": "Sérgio Luís Santos Guedes ",
        "data": {
          "resident_institute": "Hospital Vera Cruz-MG - Homero Geraldo de Oliveira",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "NQcgLZJDyapoxqIJPKc8",
        "name": "Sérgio Marques Pereira ",
        "data": {
          "resident_institute": "Hosp. Infante D. Henrique (Hosp. Benef. Portuguesa) - João Carlos F. Leal",
          "resident_begin": "2004-01-01T02:00:00.000Z",
          "resident_end": "2007-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "2xGQGWxaVT3WWR2e2A3V",
        "name": "Sérgio Shibata",
        "data": {
          "resident_institute": "Universidade Federal do Paraná - CNRM/MC Prof. Joel Takashi Totsuqui",
          "resident_begin": "1999-02-01T02:00:00.000Z",
          "resident_end": "2002-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "1mnU1YxNND7gFlsAt2Rg",
        "name": "Shirlyne Fabianni Dias Gaspar ",
        "data": {
          "resident_institute": "USP - Faculdade de Medicina CNRM/MEC - Prof. Dr. Alfredo Fiorelli",
          "resident_begin": "2014-03-06T03:00:00.000Z",
          "resident_end": "2018-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "JHmo2nq663HxeqweGVoy",
        "name": "Siderval Ferreira Alves ",
        "data": {
          "resident_institute": "Instituto do Coração de Marília - Dr. Antônio Carlos G. Penna Jr",
          "resident_begin": "1990-01-20T02:00:00.000Z",
          "resident_end": "1995-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Gu42e7rrf5hQ8eUdN6L0",
        "name": "Silas Fernandes Avelar Júnior",
        "data": {
          "resident_institute": "Hospital São Joaquim da Real Benemérita Sociedade Portuguesa de Beneficência de SP - Dr. Noedir Stolf",
          "resident_begin": "1988-01-20T02:00:00.000Z",
          "resident_end": "1990-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "uudEw5hH0presYaag9Xn",
        "name": "Silvana Agnolleto Berwanger ",
        "data": {
          "resident_institute": "Instituto de Cardiologia do Rio Grande do Sul - CNRM/MEC - Dr. Marne de Freitas Gomes",
          "resident_begin": "2002-01-01T02:00:00.000Z",
          "resident_end": "2004-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "uol3ihysCXDL08qEkd9L",
        "name": "Snyder Cavalcante Gomes",
        "data": {
          "resident_institute": "Ser. CCv Hosp. do Coração do Rio Grande do Norte - Art. 2.6.8 do Edital da Prova de 2022 - Chefe: Dr. Josalmir Amaral",
          "resident_begin": "2011-03-01T03:00:00.000Z",
          "resident_end": "2022-05-03T03:00:00.000Z"
        }
      },
      {
        "id": "za8nqYFd9jJMxO4gmkWu",
        "name": "Stanley Silvano Sousa ",
        "data": {
          "resident_institute": "BPSP- Clinica J.P. da Silva - Dr. José Pedro da Silva",
          "resident_begin": "1998-01-01T02:00:00.000Z",
          "resident_end": "2001-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "D1mBDeta1utrCCtdhGBu",
        "name": "Stêvan Krieger Martins ",
        "data": {
          "resident_institute": "Hospital do Coração - Prof. Dr. Adib D. Jatene",
          "resident_begin": "1995-02-01T02:00:00.000Z",
          "resident_end": "1998-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "nHDe3NftLyVpbS32UqSd",
        "name": "Tanara Martins de Freitas Froehlich ",
        "data": {
          "resident_institute": "Hospital das Clínicas de Porto Alegre / UFRGS / CNRM/MEC - Helena Von Eye Corleta",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "3bBMe1tSxrHWLxgifWCY",
        "name": "Tatiana Maia Jorge Ulhôa Barbosa ",
        "data": {
          "resident_institute": "Faculdade de Medicina do Triangulo Mineiro Programa CNRM - Jair Francisco Saadi Coord.",
          "resident_begin": "2000-01-20T02:00:00.000Z",
          "resident_end": "2005-01-24T02:00:00.000Z"
        }
      },
      {
        "id": "qZ9MXG2qWD1FpMFHWR5p",
        "name": "Tauaní Coelho Nabuco de Araújo Souza",
        "data": {
          "resident_institute": "Universidade Nove de Julho (UNINOVE)",
          "resident_begin": "2022-01-01T03:00:00.000Z",
          "resident_end": "2027-12-31T03:00:00.000Z"
        }
      },
      {
        "id": "BDc4ihRM1POUANIOicol",
        "name": "Thaiane Ribeiro da Silva",
        "data": {
          "resident_institute": "UERJ",
          "resident_begin": "2020-01-01T03:00:00.000Z",
          "resident_end": "2025-12-01T03:00:00.000Z"
        }
      },
      {
        "id": "pfQajAFgjFxrcbaK9w0L",
        "name": "Thaís Isabel Lumikoski ",
        "data": {
          "resident_institute": "ClinCardio (Sta Casa de Curitiba e Hosp. Angelina Caron) - Dr. Paulo Roberto S. Brofman",
          "resident_begin": "2012-01-08T02:00:00.000Z",
          "resident_end": "2016-01-08T02:00:00.000Z"
        }
      },
      {
        "id": "GFTQudYazw3DEXYttgsE",
        "name": "Thales Cantelle Baggio ",
        "data": {
          "resident_institute": "ClinCardio (Sta Casa de Curitiba e Hosp. Angelina Caron) Paulo Roberto S. Brofman",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "EPGJ8a4avtbf0Ou21RHO",
        "name": "Theófilo Gauze Filho ",
        "data": {
          "resident_institute": "Clin. Cardio Cir. J.P. da Silva - José Pedro da Silva",
          "resident_begin": "1986-01-01T02:00:00.000Z",
          "resident_end": "1988-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "bOGIB2PjxYYTJgYitoYr",
        "name": "Thiago Amaral Lourenço",
        "data": {
          "resident_institute": "Serviço CCV Marinha do Brasil/Escola de Saúde da Marinha - Item 2.6.8 do Edital 2023 (Declaração considerando 10 anos (dez) de atuação)",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2023-03-31T03:00:00.000Z"
        }
      },
      {
        "id": "BAwB6jqtRVg83p5Oq2ht",
        "name": "Thiago Cavalcanti Vila Nova de Araújo ",
        "data": {
          "resident_institute": "Escola Paulista de Medicina/UNIFESP CNRM/MEC - Dr Adagmar Andriolo",
          "resident_begin": "2013-03-01T03:00:00.000Z",
          "resident_end": "2017-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "GpDtSjZ5prsMtVcM8w7N",
        "name": "Thiago Faria Almeida",
        "data": {
          "resident_institute": "Hosp. Infante D. Henrique (Hosp. Benef. Portuguesa) - João Carlos F. Leal",
          "resident_begin": "2013-02-04T02:00:00.000Z",
          "resident_end": "2017-02-04T02:00:00.000Z"
        }
      },
      {
        "id": "Um4yJMbMpNBhpBJi9rBB",
        "name": "Thiago Goncalves da Silveira ",
        "data": {
          "resident_institute": "Incor - FMUSP - Dr Alfredo Inácio Fiorelli",
          "resident_begin": "2014-03-06T03:00:00.000Z",
          "resident_end": "2018-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "CWJjpy0Ok61PeuOmjjCP",
        "name": "Thiago Lucena de Brito Pereira ",
        "data": {
          "resident_institute": "Clínica Cardio Cirúrgica J. P. da Silva Ltda - Dr. José Pedro da Silva",
          "resident_begin": "2011-01-03T02:00:00.000Z",
          "resident_end": "2015-01-03T02:00:00.000Z"
        }
      },
      {
        "id": "QDLh9wWL13I7KLlfJUvc",
        "name": "Thiago Pinto Breguêz ",
        "data": {
          "resident_institute": "Hospital vera Cruz - Belo Horizonte - CNRM/MEC",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "tpgqbd97SyvDcAEt3sbh",
        "name": "Thiago Silva Arantes",
        "data": {
          "resident_institute": "Serv. CCV BPSP Equipe do Dr Sérgio Almeida de Oliveira - Dr. Sérgio Almeida de Oliveira",
          "resident_begin": "2015-02-02T02:00:00.000Z",
          "resident_end": "2019-02-02T02:00:00.000Z"
        }
      },
      {
        "id": "u8m0KDoP2TCxnI9Tzmo6",
        "name": "Thierry Araújo Nunes de Sousa ",
        "data": {
          "resident_institute": "BP SP - Clínica Stolf - BP SP - Clínica Stolf",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Q6B61VJH5BsMDZdCKF3s",
        "name": "Tiago Dietrich",
        "data": {
          "resident_institute": "USP - Instituto do Coração CNRM/MEC - Alfredo Inácio Fiorelli",
          "resident_begin": "2012-03-25T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "298vJjPxN0AdX24K3q4x",
        "name": "Tiago Luiz Fernandes",
        "data": {
          "resident_institute": "Serv. CCV Hospital Santa Isabel - Instituto do Coração Ltda. Coord. Dr Frederico Di Giovanni",
          "resident_begin": "2015-08-01T03:00:00.000Z",
          "resident_end": "2019-08-01T03:00:00.000Z"
        }
      },
      {
        "id": "8FuKxod1yy0HnJZG9P7y",
        "name": "Tomás Furtado Reis",
        "data": {
          "resident_institute": "Hospital Vera Cruz",
          "resident_begin": "1996-01-01T02:00:00.000Z",
          "resident_end": "1998-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "jF06qZ2yPJs80JF77iP5",
        "name": "Ulisses Alexandre Croti ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca do Norte do Paraná - Francisco Gregori Jr",
          "resident_begin": "1994-08-17T03:00:00.000Z",
          "resident_end": "1998-08-17T03:00:00.000Z"
        }
      },
      {
        "id": "IOjN5QJiiNmu0jD1RPbg",
        "name": "Ulisses da Silva Alves ",
        "data": {
          "resident_institute": "Instituto Nacional de Cardiologia - Ministério da Saúde / CNRM - Dr. José Leôncio de Andrade Feitosa",
          "resident_begin": "2009-02-01T02:00:00.000Z",
          "resident_end": "2013-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "bBvTbNf5uHVEsDh8QIi0",
        "name": "Ulisses Rodrigues Dias Filho",
        "data": {
          "resident_institute": "Hospital de Força Aérea Galeão CNRM/MEC - Dr. Marcelo Sávio da Silva Martins",
          "resident_begin": "2023-03-01T03:00:00.000Z",
          "resident_end": "2028-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "8KpBED99hVsYtivpQOEO",
        "name": "Vagner de Campos Silva",
        "data": {
          "resident_institute": "Serv. CCV Hospital das Clínicas da Universidade Federal de Minas Gerais CMRN/MEC - Diretor da Residência: Antônio Luiz Pinho Ribeiro",
          "resident_begin": "2008-02-01T02:00:00.000Z",
          "resident_end": "2012-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "xD1A7myG8NorCnUUt2O8",
        "name": "Valcellos José da Cruz Viana",
        "data": {
          "resident_institute": "Serv. CCV Hospital Santa Isabel - Equipe Dr. Nilzo Ribeiro (Item 2.6.7 Edital 2021 Tempo Treinamento/Capacitação)",
          "resident_begin": "1995-01-01T02:00:00.000Z",
          "resident_end": "2021-05-25T03:00:00.000Z"
        }
      },
      {
        "id": "uk3OMbPvTpFbkwnLy5bI",
        "name": "Valdester Cavalcante Pinto Júnior ",
        "data": {
          "resident_institute": "Incor - HCFMUSP - Prof. Dr. Adib Jatene",
          "resident_begin": "1988-02-01T02:00:00.000Z",
          "resident_end": "1991-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "LHKSOuP1kz5cCab2hqfy",
        "name": "Valdir Cesarino Souza ",
        "data": {
          "resident_institute": "Dante Pazanese - Dr Horário Arakaki",
          "resident_begin": "1981-02-01T03:00:00.000Z",
          "resident_end": "1983-11-30T03:00:00.000Z"
        }
      },
      {
        "id": "cf3wF7Ffe1hSPZf6HHkQ",
        "name": "Valdo José Carreira ",
        "data": {
          "resident_institute": "Clínica de Cirurgia Cardiovascular das Moléstias Cardiovascular - João Bosco de Oliveira",
          "resident_begin": "1987-02-02T02:00:00.000Z",
          "resident_end": "1990-12-02T02:00:00.000Z"
        }
      },
      {
        "id": "Z8uiF2pLISUKj38hBtiT",
        "name": "Valquíria Pelisser Campagnucci ",
        "data": {
          "resident_institute": "irmandade da Santa Casa de Misericórdia de São Paulo - CNRM/MEC - Raimundo Raffaelli Filho",
          "resident_begin": "1987-02-01T02:00:00.000Z",
          "resident_end": "1989-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "1UOmAxlzTIuqYS3XX57z",
        "name": "Vanessa Carvalho Duarte ",
        "data": {
          "resident_institute": "Universidade do Estado do Rio de Janeiro / Hospital Univ. Pedro Ernesto - CNRM/MEC - Denise Herdy Afonso",
          "resident_begin": "2005-02-01T02:00:00.000Z",
          "resident_end": "2009-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "iVAz9FUVWZXfTDGrl6FE",
        "name": "Vera Lúcia A. Molari Piccardi ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Paulo Paredes Paulista",
          "resident_begin": "1976-02-01T03:00:00.000Z",
          "resident_end": "1979-01-31T03:00:00.000Z"
        }
      },
      {
        "id": "kblqvbnTFyCeAbJsMaMb",
        "name": "Vicente Ávila Neto",
        "data": {
          "resident_institute": "Instituto de Doenças Cardio-Pulmonares E.J.Zerbini - Dr. Zerbini",
          "resident_begin": "1978-01-20T03:00:00.000Z",
          "resident_end": "1980-01-20T03:00:00.000Z"
        }
      },
      {
        "id": "W1SSqD90WCsCLYaQRBdc",
        "name": "Vicente de Paulo Ferreira Junior ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Madre Teresa - Dr. Rodrigo Bernardes de Castro",
          "resident_begin": "2011-03-04T03:00:00.000Z",
          "resident_end": "2015-03-03T03:00:00.000Z"
        }
      },
      {
        "id": "WwQ0apN35rijenFwGt9i",
        "name": "Victor Bauer Júnior ",
        "data": {
          "resident_institute": "Hosp. Evangélico de Curitiba Danton Loures",
          "resident_begin": "1987-01-02T02:00:00.000Z",
          "resident_end": "1991-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "6Qmkb4YyrHrsjJ13Qxal",
        "name": "Victor Hugo Serafini Volpatto ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Clinica Cardio Cirúrgica J.P da Silva - Dr José Pedro da Silva",
          "resident_begin": "2013-01-01T02:00:00.000Z",
          "resident_end": "2017-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "MNSDBwqg0pBMM7voMf4r",
        "name": "Vinicius Assunção Pratas Sobral ",
        "data": {
          "resident_institute": "Incor - FMUSP/CNRM-MEC - Dr Alfredo Inácio Fiorelli",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "6wO0mIqh2lho65aKHQ9p",
        "name": "Vinicius Augusto de Almeida Pessoa ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardiovascular Hospital Universitário Federal do Mato Grosso do Sul - Ricardo Benfatti",
          "resident_begin": "2011-01-03T02:00:00.000Z",
          "resident_end": "2014-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "8VbZzk8qwfITEM9IobdL",
        "name": "Vinicius Eduardo Araújo Costa ",
        "data": {
          "resident_institute": "Hospital Vera Cruz-MG - Homero Geraldo de Oliveira",
          "resident_begin": "2009-01-02T02:00:00.000Z",
          "resident_end": "2013-01-30T02:00:00.000Z"
        }
      },
      {
        "id": "0tQIshxCG7gIb7nM0Uie",
        "name": "Vinicius Gonçalves Loureiro ",
        "data": {
          "resident_institute": "BIOCOR - Bayard Gontijo Fº",
          "resident_begin": "2006-01-02T02:00:00.000Z",
          "resident_end": "2008-12-31T02:00:00.000Z"
        }
      },
      {
        "id": "bESLK4TXNCoGRdc4F2A9",
        "name": "Vinicius Nesi Cavicchioli ",
        "data": {
          "resident_institute": "Hospital Santa Casa de Curitiba - Francisco Diniz Affonso da Costa",
          "resident_begin": "2013-02-04T02:00:00.000Z",
          "resident_end": "2017-02-03T02:00:00.000Z"
        }
      },
      {
        "id": "n2juAqlE737r3seFtUkI",
        "name": "Vinicius Nicolau Woitowicz ",
        "data": {
          "resident_institute": "Instituto de Neurologia e Cardiologia de Curitiba - Dr. Francisco Diniz A. da Costa",
          "resident_begin": "1996-03-01T03:00:00.000Z",
          "resident_end": "1999-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "wFuxp4eGo4iqIlDx6FFZ",
        "name": "Vinicius Pereira de Carvalho",
        "data": {
          "resident_institute": "Santa Casa de Misericórdia de Ribeirão Preto/Hospital São Francisco - Dr. Eduardo Cosac",
          "resident_begin": "2020-03-02T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "lPOutVIeFCryD2TUo9bF",
        "name": "Vinicius Vilas Boas Furfuro",
        "data": {
          "resident_institute": "Serviço CCV Universidade Católica de Minas Gerais, Hosp. Madre Teresa - Dr. Rodrigo de Castro Bernardes",
          "resident_begin": "2017-03-01T03:00:00.000Z",
          "resident_end": "2021-03-01T03:00:00.000Z"
        }
      },
      {
        "id": "GTGiwPp2GFVxYFucBNIN",
        "name": "Virginia Graciela Rivas Arcia",
        "data": {
          "resident_institute": "Serv. CCV Instituto Dante Pazzanese - Dra. Magaly Arrais dos Santos",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "9CteihxvnZlPWi0xOIzh",
        "name": "Vitor Abaurre Amaral ",
        "data": {
          "resident_institute": "InCor-HCFMUSP",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "kvCSBz9ciJ4oLNBA3yee",
        "name": "Vitor Lucena Carneiro ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Dr. Mário Issa",
          "resident_begin": "2019-03-01T03:00:00.000Z",
          "resident_end": "2024-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "o9ru2dhDmuoF9c8GUo51",
        "name": "Vittor Fernando de Oliveira Castro",
        "data": {
          "resident_institute": "Serv. de CCV Equipe Santa casa de Maceió e hospital do coração de Alagoas - Dr. José Wanderley Neto",
          "resident_begin": "2015-02-02T02:00:00.000Z",
          "resident_end": "2019-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "emxBZ4t9qFbwkQ0aYrLr",
        "name": "Vlander Gomes Costa Júnior",
        "data": {
          "resident_institute": "Universidade Federal do Rio de Janeiro - Hosp Univ. Pedro Ernesto CNRM/MEC",
          "resident_begin": "2000-03-01T03:00:00.000Z",
          "resident_end": "2003-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "MEYtENCPjxZn1bN7bWVx",
        "name": "Wagner Ciongoli ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Cardíaca Hosp. BP/SP - Dr. Luiz Boro Puig",
          "resident_begin": "1985-01-02T03:00:00.000Z",
          "resident_end": "1988-01-02T02:00:00.000Z"
        }
      },
      {
        "id": "plEUN0gWMAWrQcIQQmCd",
        "name": "Wagner Marcondes da Cunha Lopes",
        "data": {
          "resident_institute": "Femina Prest. de Serv. Médico Hospitalar LTDA - Dra. Fernannda Maria Pigatto Coreia Vilela - Diretoria - ( Declaração 8 anos)",
          "resident_begin": "2009-01-05T02:00:00.000Z",
          "resident_end": "2019-11-30T03:00:00.000Z"
        }
      },
      {
        "id": "CKkNqopwpVvW55Fj6bm9",
        "name": "Wagner Tadeu Jurevicius do Nascimento",
        "data": {
          "resident_institute": "Incor - FMUSP/CNRM-MEC - Dr Alfredo Inácio Fiorelli",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "hQn88eIunDaYTLht1Aak",
        "name": "Waldemiro Carvalho Junior ",
        "data": {
          "resident_institute": "Serviço de Cirurgia Torácica e Cardiovascular do Hospital de Messejana - Eduardo Regis Juca",
          "resident_begin": "1973-12-20T03:00:00.000Z",
          "resident_end": "1975-07-15T03:00:00.000Z"
        }
      },
      {
        "id": "IFFBOlR2QfHhXOk6FbdY",
        "name": "Waldo Emerson Pinheiro Daniel",
        "data": {
          "resident_institute": "Serviço Clínica Cardio-Cirúrgica J.P. da Silva - Hospital São Joaquim BPSP",
          "resident_begin": "1995-01-01T02:00:00.000Z",
          "resident_end": "1998-12-30T02:00:00.000Z"
        }
      },
      {
        "id": "dOwfPYBtfqHJfuBeixsJ",
        "name": "Walfran José Hereira Rojas",
        "data": {
          "resident_institute": "Serv. CCV Hospital Francisca Mendes - Dr. Mariano Terrazas",
          "resident_begin": "2011-02-01T02:00:00.000Z",
          "resident_end": "2015-02-01T02:00:00.000Z"
        }
      },
      {
        "id": "lNTsRdKMGiTncYsVGZP2",
        "name": "Walter Labanca Arantes ",
        "data": {
          "resident_institute": "Instituto Estatual de Cardiologia A.C 0 SUSEME - Secretaria da Saúde do Estado do RJ - Guanabara",
          "resident_begin": "1971-03-20T03:00:00.000Z",
          "resident_end": "1973-12-01T03:00:00.000Z"
        }
      },
      {
        "id": "sVa7QmQMK9jcapa0gVdC",
        "name": "Walter Vosgrau Fagundes ",
        "data": {
          "resident_institute": "Instituto Dante Pazzanese de Cardiologia - Paulo Paredes Paulista",
          "resident_begin": "1985-02-01T03:00:00.000Z",
          "resident_end": "1986-10-30T02:00:00.000Z"
        }
      },
      {
        "id": "ZOnv95UAYN1HGNJLs8R9",
        "name": "Wanderley Saviolo Ferreira",
        "data": {
          "resident_institute": "Irmandade da Santa Casa de Misericórdia de Curitiba / CNRM/MEC - Dr. Pedro Emilio de Cerqueira Lima Neto",
          "resident_begin": "1986-01-15T02:00:00.000Z",
          "resident_end": "1989-01-15T02:00:00.000Z"
        }
      },
      {
        "id": "ipYdVH4QVNIWxHikji4D",
        "name": "Wanewman Lins Guedes de Andrade",
        "data": {
          "resident_institute": "S. Oliveira Cir. Cardíaca / BP-SP - Dr. Sergio A Oliveira",
          "resident_begin": "1986-01-20T02:00:00.000Z",
          "resident_end": "1988-12-20T02:00:00.000Z"
        }
      },
      {
        "id": "1a5sKL2GcrIJVhTeOYqG",
        "name": "Wendell Nunes Martins",
        "data": {
          "resident_institute": "Universidade de Pernambuco - FCM CNRM/MEC Dra Valdecira Lilioso de Lucena",
          "resident_begin": "2010-02-01T02:00:00.000Z",
          "resident_end": "2014-01-31T02:00:00.000Z"
        }
      },
      {
        "id": "Awia0RdOAFWSRLLMQoyM",
        "name": "Wilson Andrés Mena Silva",
        "data": {
          "resident_institute": "INSTITUTO DANTE PAZZANESE DE CARDIOLOGIA",
          "resident_begin": "2020-03-01T03:00:00.000Z",
          "resident_end": "2025-02-28T03:00:00.000Z"
        }
      },
      {
        "id": "w2UAzNOgRhunCHtRxWrS",
        "name": "Wilson Nkundumukiza ",
        "data": {
          "resident_institute": "Serv. em CCV Hospital da Cruz Vermelha Brasileira - Filial do Estado do Paraná - Dr. Jeronimo A. Fortunato Junior",
          "resident_begin": "2012-03-01T03:00:00.000Z",
          "resident_end": "2016-02-29T03:00:00.000Z"
        }
      },
      {
        "id": "N3BjYPni7SwbwZRnKrca",
        "name": "Wilson Oliveira Felix",
        "data": {
          "resident_institute": "Unidade Carddiotorácica Fundação Beneficência Hospital de Cirurgia - Dr José Teles Mendonça",
          "resident_begin": "2012-01-02T02:00:00.000Z",
          "resident_end": "2016-01-01T02:00:00.000Z"
        }
      },
      {
        "id": "N5AAv2hdZuSVbLIshWhn",
        "name": "Zildomar Deucher Júnior ",
        "data": {
          "resident_institute": "Especialização em CCV no Hospital de Cardiologia de Laranjeiras Rio de Janeiro - Dr. Celso Garcia",
          "resident_begin": "1992-04-01T03:00:00.000Z",
          "resident_end": "1994-09-30T03:00:00.000Z"
        }
      }
    ]


  }
}

